import * as React from "react";
const WebDevelopmentSVG = (props) => (
  <svg
    className="animated"
    id="freepik_stories-cross-platform-software"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <style>
      {
        "svg#freepik_stories-cross-platform-software:not(.animated) .animable {opacity: 0;}svg#freepik_stories-cross-platform-software.animated #freepik--Plants--inject-835 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-cross-platform-software.animated #freepik--screen-2--inject-835 {animation: 3s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-cross-platform-software.animated #freepik--screen-1--inject-835 {animation: 3s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-cross-platform-software.animated #freepik--gears-3--inject-835 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-cross-platform-software.animated #freepik--speech-bubble--inject-835 {animation: 3s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }"
      }
    </style>
    <g
      id="freepik--Floor--inject-835"
      className="animable"
      style={{
        transformOrigin: "250.002px 352.437px",
      }}
    >
      <path
        id="freepik--floor--inject-835"
        d="M81,450c-93.33-53.89-93.33-141.25,0-195.13s244.65-53.88,338,0S512.32,396.12,419,450,174.34,503.89,81,450Z"
        style={{
          fill: "rgb(250, 250, 250)",
          transformOrigin: "250.002px 352.437px",
        }}
        className="animable"
      />
    </g>
    <g
      id="freepik--Shadows--inject-835"
      className="animable"
      style={{
        transformOrigin: "245.546px 359.94px",
      }}
    >
      <path
        id="freepik--Shadow--inject-835"
        d="M453.2,338.05c9.24,5.4,9.24,14.14,0,19.54s-24.22,5.39-33.46,0-9.24-14.14,0-19.54S444,332.66,453.2,338.05Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "436.47px 347.82px",
        }}
        className="animable"
      />
      <path
        id="freepik--shadow--inject-835"
        d="M272.38,264.37,254.9,254.28a4.19,4.19,0,0,0-3.78,0L31.74,380.94a1.16,1.16,0,0,0,0,2.19L49.38,393.4a4.14,4.14,0,0,0,3.77,0l37.13-21.48A14.58,14.58,0,0,0,91.92,373l28.43,16.42a27.39,27.39,0,0,0,25.2,0l54.86-31.68c4.08-2.35,6.41-5.86,6.41-9.62s-2.33-7.27-6.41-9.63l-26.22-15.13,98.19-56.82A1.15,1.15,0,0,0,272.38,264.37Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "152.056px 323.842px",
        }}
        className="animable"
      />
      <path
        id="freepik--shadow--inject-835"
        d="M377.27,257.79l-89.75,51.78a1.16,1.16,0,0,0,0,2.2l14.05,8.08a4.17,4.17,0,0,0,3.8,0l89.74-51.78a1.16,1.16,0,0,0,0-2.2l-14-8.08A4.17,4.17,0,0,0,377.27,257.79Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "341.315px 288.815px",
        }}
        className="animable"
      />
      <path
        id="freepik--shadow--inject-835"
        d="M386.32,269.65l-78.23,45.13a.92.92,0,0,0,0,1.73l11.09,6.39a3.33,3.33,0,0,0,3,0l78.22-45.13a.92.92,0,0,0,0-1.74l-11.09-6.38A3.31,3.31,0,0,0,386.32,269.65Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "354.252px 296.275px",
        }}
        className="animable"
      />
      <path
        id="freepik--shadow--inject-835"
        d="M421.6,383.83,300.72,453.72a1.78,1.78,0,0,1-1.59,0L209.81,402.1c-.44-.25-.44-.66,0-.92L330.69,331.3a1.74,1.74,0,0,1,1.6,0l89.31,51.61C422,383.17,422,383.58,421.6,383.83Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "315.69px 392.506px",
        }}
        className="animable"
      />
      <path
        id="freepik--shadow--inject-835"
        d="M263.22,403.14l-64-36.31c-1.29-.73-1.3-1.93,0-2.67l62.16-36.45a5.11,5.11,0,0,1,4.63,0L330,364c1.28.73,1.29,1.92,0,2.67l-62.17,36.45A5.11,5.11,0,0,1,263.22,403.14Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "264.606px 365.417px",
        }}
        className="animable"
      />
      <path
        id="freepik--shadow--inject-835"
        d="M166.83,466.05a4.51,4.51,0,0,1-4.37-3.63l-.74-3.9a47.48,47.48,0,0,1-5-1.23l-7.59,3.51a5.07,5.07,0,0,1-2.14.45,5.18,5.18,0,0,1-2.59-.66l-7.77-4.48a3.85,3.85,0,0,1-.33-6.56l4.07-2.93c-.19-.28-.37-.56-.55-.85l-9.48-.6a4.32,4.32,0,0,1-4-4.31v-5.77a4.32,4.32,0,0,1,4-4.3l9.47-.6c.18-.29.36-.57.55-.85l-4.07-2.93a3.85,3.85,0,0,1,.34-6.56l7.76-4.48a5.23,5.23,0,0,1,2.59-.67,5.08,5.08,0,0,1,2.15.46l7.58,3.51a47.48,47.48,0,0,1,5-1.23l.74-3.91a4.51,4.51,0,0,1,4.37-3.62h11.42a4.51,4.51,0,0,1,4.37,3.63l.74,3.9a46.87,46.87,0,0,1,5,1.23l7.59-3.51a5,5,0,0,1,2.14-.46,5.26,5.26,0,0,1,2.6.67l7.76,4.48a3.85,3.85,0,0,1,.33,6.56l-4.07,2.93c.19.28.37.56.55.85l9.48.6a4.31,4.31,0,0,1,4,4.3v5.77a4.32,4.32,0,0,1-4,4.31l-9.48.6c-.18.29-.36.57-.55.85l4.07,2.93a3.91,3.91,0,0,1,1.67,3.37,4,4,0,0,1-2,3.19l-7.76,4.48a5.24,5.24,0,0,1-2.6.66h0a5.07,5.07,0,0,1-2.14-.45l-7.59-3.51a49.44,49.44,0,0,1-5,1.23l-.74,3.9a4.51,4.51,0,0,1-4.37,3.63Zm5.71-35.5a23.74,23.74,0,0,0-11.47,2.7c-2.41,1.39-3.79,3.12-3.79,4.73s1.38,3.34,3.79,4.73a25.8,25.8,0,0,0,22.94,0c2.41-1.39,3.79-3.12,3.79-4.73s-1.38-3.34-3.79-4.73A23.68,23.68,0,0,0,172.54,430.55Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "172.535px 437.98px",
        }}
        className="animable"
      />
      <path
        id="freepik--shadow--inject-835"
        d="M99.87,440a4.41,4.41,0,0,1-.52,0l-7.18-.75a4.74,4.74,0,0,1-4.23-5.3l.13-1.11c-.61-.22-1.2-.46-1.78-.71,0,0,0,0,0,0h-.08l-5.46,1.71a5.58,5.58,0,0,1-1.65.25,6.12,6.12,0,0,1-3.84-1.33l-3.67-3.06a4.26,4.26,0,0,1,.83-7.21l1.25-.62-3.37-.58a4.58,4.58,0,0,1-3.63-5.93l1-3.18a5.27,5.27,0,0,1,4.94-3.62l6.11.24-.79-.84a4.3,4.3,0,0,1,1.56-7.05l5.75-2.31a5.81,5.81,0,0,1,2.14-.39,6.11,6.11,0,0,1,3.35,1l3.72,2.47h0c1.08-.19,2.17-.33,3.27-.43L98.87,399a5.53,5.53,0,0,1,4.82-2.92,4.41,4.41,0,0,1,.52,0l7.18.75a4.74,4.74,0,0,1,4.23,5.3l-.13,1.11c.61.22,1.2.46,1.78.71,0,0,0,0,0,0h.08l5.46-1.71a5.58,5.58,0,0,1,1.65-.25,6.12,6.12,0,0,1,3.84,1.33l3.67,3.06a4.27,4.27,0,0,1-.84,7.21l-1.24.62,3.37.58a4.59,4.59,0,0,1,3.63,5.93l-1,3.18a5.28,5.28,0,0,1-4.94,3.63l-6.11-.25.79.84a4.31,4.31,0,0,1-1.56,7.06l-5.75,2.3a5.81,5.81,0,0,1-2.14.39,6.19,6.19,0,0,1-3.35-.95l-3.72-2.48h0c-1.07.19-2.16.33-3.27.43l-1.11,2.16A5.53,5.53,0,0,1,99.87,440Zm1.9-26.36a17.72,17.72,0,0,0-6.51,1.16c-2.53,1-3.57,2.3-3.69,3.09s.68,1.59,1.17,2c1.92,1.6,5.39,2.6,9.05,2.6a17.72,17.72,0,0,0,6.51-1.17c2.53-1,3.57-2.3,3.69-3.09s-.68-1.59-1.17-2C108.89,414.6,105.42,413.61,101.77,413.61Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "101.778px 418.04px",
        }}
        className="animable"
      />
    </g>
    <g
      id="freepik--Plants--inject-835"
      className="animable animator-hidden"
      style={{
        transformOrigin: "434.97px 301.408px",
      }}
    >
      <g
        id="freepik--Plant--inject-835"
        className="animable"
        style={{
          transformOrigin: "434.97px 301.408px",
        }}
      >
        <g
          id="freepik--Pot--inject-835"
          className="animable"
          style={{
            transformOrigin: "436.47px 333.663px",
          }}
        >
          <path
            d="M422.77,350.52C415.45,343,411.15,324,418.29,318h36.36c7.14,6,2.84,25-4.48,32.55l-.2.21-.25.24a7.73,7.73,0,0,1-.67.6l-.17.14-.55.42a10.1,10.1,0,0,1-.95.61c-6,3.52-15.8,3.52-21.82,0h0a11,11,0,0,1-1-.61c-.18-.13-.34-.26-.51-.4l-.22-.17c-.23-.19-.44-.38-.64-.57l-.29-.29Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "436.47px 336.705px",
            }}
            id="el5jtagruzxam"
            className="animable"
          />
          <path
            d="M451.49,315.55c8.29,4.85,8.29,12.7,0,17.54s-21.75,4.84-30,0-8.3-12.69,0-17.54S443.19,310.71,451.49,315.55Z"
            style={{
              fill: "rgb(245, 245, 245)",
              transformOrigin: "436.496px 324.318px",
            }}
            id="eledxgu6bmasv"
            className="animable"
          />
          <path
            d="M447.5,317.88c6.09,3.56,6.09,9.33,0,12.88s-16,3.56-22.06,0-6.09-9.32,0-12.88S441.41,314.33,447.5,317.88Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "436.476px 324.32px",
            }}
            id="elqyy0nnhl7hb"
            className="animable"
          />
          <path
            d="M425.44,324c6.09-3.56,16-3.56,22.06,0a10.15,10.15,0,0,1,3.65,3.39,10.22,10.22,0,0,1-3.65,3.38c-6.09,3.56-16,3.56-22.06,0a10.22,10.22,0,0,1-3.65-3.38A10,10,0,0,1,425.44,324Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "436.47px 327.385px",
            }}
            id="elfpnwe0jwk6m"
            className="animable"
          />
        </g>
        <path
          d="M434,275.51c-2.78,3-10.53,3.85-13.73-4.31-3-7.65-6.25-14.9-7.18-17.71a2.88,2.88,0,0,1,1.85-3.73s.22-4.2,7.34-1.35,12.15,7.17,15.26,14.16S438.79,274.57,434,275.51Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "425.993px 262.531px",
          }}
          id="el6qvxfmwlm5c"
          className="animable"
        />
        <path
          d="M437.11,286.3a40.85,40.85,0,0,0-.62-4.26,59.91,59.91,0,0,0-10.62-23.44,52.2,52.2,0,0,0-6.49-7.36c-.07-.07-.13.1-.08.15a64.55,64.55,0,0,1,10.16,14,65.27,65.27,0,0,1,5.88,15.92c.35,1.55.69,3.11,1,4.67s.45,3.2.72,4.79c0,.16.28.26.29,0A30,30,0,0,0,437.11,286.3Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "428.319px 271.076px",
          }}
          id="eld3rqf8gd5a"
          className="animable"
        />
        <g id="el89zfmmesxuy">
          <path
            d="M437.11,286.3a40.85,40.85,0,0,0-.62-4.26,59.91,59.91,0,0,0-10.62-23.44,52.2,52.2,0,0,0-6.49-7.36c-.07-.07-.13.1-.08.15a64.55,64.55,0,0,1,10.16,14,65.27,65.27,0,0,1,5.88,15.92c.35,1.55.69,3.11,1,4.67s.45,3.2.72,4.79c0,.16.28.26.29,0A30,30,0,0,0,437.11,286.3Z"
            style={{
              opacity: 0.1,
              transformOrigin: "428.319px 271.076px",
            }}
            className="animable"
            id="elaj7b7j151gn"
          />
        </g>
        <path
          d="M439.49,273.4c-6.4,2-11.15-3-9.51-10.85s9.87-16.52,13-14.19c1.94-1.94,6.21-1.24,8.23,5.12S451.37,276.17,439.49,273.4Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "440.784px 260.624px",
          }}
          id="elukxt810d8f"
          className="animable"
        />
        <path
          d="M443.24,253.13A84.82,84.82,0,0,0,439,267.2a135.52,135.52,0,0,0-2.47,14.73,230,230,0,0,0-1.29,28.87c0,2.66.06,5.33.11,8s0,5.52.24,8.25c.09,1,1.58.77,1.6-.19.1-4.8-.17-9.62-.22-14.41s0-9.49.09-14.23a200.59,200.59,0,0,1,2.59-28.84c.46-2.65,1-5.3,1.58-7.92s1.45-5.48,2.18-8.22C443.43,253.12,443.3,253,443.24,253.13Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "439.307px 290.386px",
          }}
          id="el8kvf28calif"
          className="animable"
        />
        <g id="elqafghvkdu9">
          <path
            d="M443.24,253.13A84.82,84.82,0,0,0,439,267.2a135.52,135.52,0,0,0-2.47,14.73,230,230,0,0,0-1.29,28.87c0,2.66.06,5.33.11,8s0,5.52.24,8.25c.09,1,1.58.77,1.6-.19.1-4.8-.17-9.62-.22-14.41s0-9.49.09-14.23a200.59,200.59,0,0,1,2.59-28.84c.46-2.65,1-5.3,1.58-7.92s1.45-5.48,2.18-8.22C443.43,253.12,443.3,253,443.24,253.13Z"
            style={{
              opacity: 0.1,
              transformOrigin: "439.307px 290.386px",
            }}
            className="animable"
            id="elgjlzrisjvd5"
          />
        </g>
        <path
          d="M429.08,296.36c-2.8,3.16-9.21,2.88-13.5-2.76s-6.88-26.88-.83-25.52c1.28-2.84,18,4,20.13,17.82C436.44,296,429.08,296.36,429.08,296.36Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "423.141px 282.913px",
          }}
          id="elzmxal055hvl"
          className="animable"
        />
        <path
          d="M434.07,306.39a30.27,30.27,0,0,0-.82-3.87,79.93,79.93,0,0,0-2.49-7.68,80.79,80.79,0,0,0-7.46-14.65,72.66,72.66,0,0,0-5.3-7.48c-.05-.07-.1.08-.07.12,1.49,2.18,3,4.33,4.34,6.6a79.91,79.91,0,0,1,3.79,7.29,100.53,100.53,0,0,1,5.51,14.78c.41,1.43.75,2.89,1.17,4.32s1,2.95,1.37,4.46c.06.22.34.3.31,0C434.29,309,434.24,307.69,434.07,306.39Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "426.172px 291.584px",
          }}
          id="elssk12masrk"
          className="animable"
        />
        <g id="elyyqchbkn2zn">
          <path
            d="M434.07,306.39a30.27,30.27,0,0,0-.82-3.87,79.93,79.93,0,0,0-2.49-7.68,80.79,80.79,0,0,0-7.46-14.65,72.66,72.66,0,0,0-5.3-7.48c-.05-.07-.1.08-.07.12,1.49,2.18,3,4.33,4.34,6.6a79.91,79.91,0,0,1,3.79,7.29,100.53,100.53,0,0,1,5.51,14.78c.41,1.43.75,2.89,1.17,4.32s1,2.95,1.37,4.46c.06.22.34.3.31,0C434.29,309,434.24,307.69,434.07,306.39Z"
            style={{
              opacity: 0.1,
              transformOrigin: "426.172px 291.584px",
            }}
            className="animable"
            id="elogjomuquc1r"
          />
        </g>
        <path
          d="M439.3,293.22c-3.65-.83-3.83-5.22.73-10.61s16.09-7.74,16.64-5.47c2.56,0,2.56,8-3.11,15.38S439.65,298.17,439.3,293.22Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "447.448px 286.89px",
          }}
          id="eltvaskkejsw"
          className="animable"
        />
        <path
          d="M446.47,285.39a29.34,29.34,0,0,0-6.33,6,29.73,29.73,0,0,0-4.26,7.65c-.12.31.43.77.55.43a33.62,33.62,0,0,1,10.06-14S446.51,285.35,446.47,285.39Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "441.179px 292.486px",
          }}
          id="el2hik3fk1fh6"
          className="animable"
        />
        <g id="elgnipviwwm5p">
          <path
            d="M446.47,285.39a29.34,29.34,0,0,0-6.33,6,29.73,29.73,0,0,0-4.26,7.65c-.12.31.43.77.55.43a33.62,33.62,0,0,1,10.06-14S446.51,285.35,446.47,285.39Z"
            style={{
              opacity: 0.1,
              transformOrigin: "441.179px 292.486px",
            }}
            className="animable"
            id="elbe9w7u2mg7o"
          />
        </g>
        <path
          d="M443.48,320c-5.06,2-2.89,8.08,2,12.67a22.64,22.64,0,0,0,15.41,5.55c3.4-.25,4.27-.71,4.27-.71a38.49,38.49,0,0,0,0-8.39,16.2,16.2,0,0,0-11.94-12.85C445.37,314.1,443.48,317,443.48,320Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "452.99px 326.871px",
          }}
          id="elfd2t9ank9p"
          className="animable"
        />
        <path
          d="M457.5,328.88a40.85,40.85,0,0,0-7.75-7.17c-2.89-1.9-6.73-3.52-10.19-2.34-1.34.46-3.42,1.79-3.17,3.45,0,.17.32.58.51.35a14.29,14.29,0,0,1,1.83-2.13,5.43,5.43,0,0,1,2.72-1,12.57,12.57,0,0,1,7.1,1.62c3.42,1.81,6.19,4.63,8.91,7.33C457.49,329,457.53,328.91,457.5,328.88Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "446.94px 323.98px",
          }}
          id="elw7z2d5ntzb"
          className="animable"
        />
        <g id="elnc03w3szfqk">
          <path
            d="M457.5,328.88a40.85,40.85,0,0,0-7.75-7.17c-2.89-1.9-6.73-3.52-10.19-2.34-1.34.46-3.42,1.79-3.17,3.45,0,.17.32.58.51.35a14.29,14.29,0,0,1,1.83-2.13,5.43,5.43,0,0,1,2.72-1,12.57,12.57,0,0,1,7.1,1.62c3.42,1.81,6.19,4.63,8.91,7.33C457.49,329,457.53,328.91,457.5,328.88Z"
            style={{
              opacity: 0.1,
              transformOrigin: "446.94px 323.98px",
            }}
            className="animable"
            id="elwxwphs3s57o"
          />
        </g>
        <path
          d="M424.2,294c.48-2.31-2.85-7.83-13.23-8.89s-18.17,3.35-19.74,5.36-2.36,4.13-.47,4.66,8.37,1.16,12.63,3.12,12.92,7.75,18.83,6S427.13,296.33,424.2,294Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "408.096px 294.762px",
          }}
          id="elw3fbg3hr3of"
          className="animable"
        />
        <path
          d="M432.09,302.08c-4.38-9.05-15.67-11.81-24.89-11.76a36.43,36.43,0,0,0-9,1.17s-.05.11,0,.11a48,48,0,0,1,15-.16,31.25,31.25,0,0,1,13.73,5.3,18.76,18.76,0,0,1,4.91,5.51C432,302.47,432.18,302.26,432.09,302.08Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "415.146px 296.332px",
          }}
          id="el4niqqtux00x"
          className="animable"
        />
        <g id="elyft3i2dl72">
          <path
            d="M432.09,302.08c-4.38-9.05-15.67-11.81-24.89-11.76a36.43,36.43,0,0,0-9,1.17s-.05.11,0,.11a48,48,0,0,1,15-.16,31.25,31.25,0,0,1,13.73,5.3,18.76,18.76,0,0,1,4.91,5.51C432,302.47,432.18,302.26,432.09,302.08Z"
            style={{
              opacity: 0.1,
              transformOrigin: "415.146px 296.332px",
            }}
            className="animable"
            id="elyu5g36xn8u"
          />
        </g>
        <path
          d="M448.39,281.92c-.13,3.63,5,5.74,9.92,2.6s10.13-6.19,14.72-7.38,6.75-4.92,5.3-6.73-3.75-6.37-15.79-4.88-16.32,6.91-18,10.75S446.58,283,448.39,281.92Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "461.446px 275.642px",
          }}
          id="el504ghg28pqy"
          className="animable"
        />
        <path
          d="M468,270.39a13.16,13.16,0,0,0-5.17.55,25.56,25.56,0,0,0-4.42,1.58,24.37,24.37,0,0,0-7.54,5.46,20.88,20.88,0,0,0-1.7,2,8.62,8.62,0,0,0-1.28,2.11c-.09.24.26.63.47.39.6-.69,1.05-1.53,1.61-2.26a23.9,23.9,0,0,1,1.94-2.22,24.48,24.48,0,0,1,4.64-3.65,29.1,29.1,0,0,1,5.14-2.51c1-.35,2-.64,3-.9a10.4,10.4,0,0,1,3.28-.45C468,270.53,468.06,270.4,468,270.39Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "457.951px 276.444px",
          }}
          id="eludar3tkuer"
          className="animable"
        />
        <g id="elvjhv7b07ri">
          <path
            d="M468,270.39a13.16,13.16,0,0,0-5.17.55,25.56,25.56,0,0,0-4.42,1.58,24.37,24.37,0,0,0-7.54,5.46,20.88,20.88,0,0,0-1.7,2,8.62,8.62,0,0,0-1.28,2.11c-.09.24.26.63.47.39.6-.69,1.05-1.53,1.61-2.26a23.9,23.9,0,0,1,1.94-2.22,24.48,24.48,0,0,1,4.64-3.65,29.1,29.1,0,0,1,5.14-2.51c1-.35,2-.64,3-.9a10.4,10.4,0,0,1,3.28-.45C468,270.53,468.06,270.4,468,270.39Z"
            style={{
              opacity: 0.1,
              transformOrigin: "457.951px 276.444px",
            }}
            className="animable"
            id="elc64ao4vh0ii"
          />
        </g>
        <path
          d="M439.74,301.52c-1.69-1.68-6.27-1.29-8.44,3.7s2.39,10.45,2.89,12c2.1-1.21,3.73-.49,7.41-1.21a9.19,9.19,0,0,0,7.07-9.17C448.43,302.25,446.5,299.23,439.74,301.52Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "439.695px 308.922px",
          }}
          id="el9d2he7paftt"
          className="animable"
        />
        <path
          d="M439.68,301a6.91,6.91,0,0,0-2.24,2.32,13.2,13.2,0,0,0-1.45,2.79,12,12,0,0,0-.64,6.36c0,.08.09,0,.08-.05a13,13,0,0,1,1.07-6.28,13.19,13.19,0,0,1,1.52-2.52,14.38,14.38,0,0,1,1-1.18,6.29,6.29,0,0,0,1-1C440.13,301.31,439.94,300.9,439.68,301Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "437.615px 306.744px",
          }}
          id="el9ws23cshdjq"
          className="animable"
        />
        <g id="elu3v8a8zuaet">
          <path
            d="M439.68,301a6.91,6.91,0,0,0-2.24,2.32,13.2,13.2,0,0,0-1.45,2.79,12,12,0,0,0-.64,6.36c0,.08.09,0,.08-.05a13,13,0,0,1,1.07-6.28,13.19,13.19,0,0,1,1.52-2.52,14.38,14.38,0,0,1,1-1.18,6.29,6.29,0,0,0,1-1C440.13,301.31,439.94,300.9,439.68,301Z"
            style={{
              opacity: 0.1,
              transformOrigin: "437.615px 306.744px",
            }}
            className="animable"
            id="eln9ek9eq7ho8"
          />
        </g>
        <path
          d="M431.8,311.63c-.16-3.71-4.18-6.65-9.91-8.35a15.57,15.57,0,0,0-16.1,4.27c-4.18,4.55-6.34,8.42-4.64,9.5s9.29,3.87,14.24,5.42,11.45,2,16.41-.93S436.44,313.49,431.8,311.63Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "417.984px 313.125px",
          }}
          id="eln0bi7vq0ynn"
          className="animable"
        />
        <path
          d="M432.11,311.22a15.55,15.55,0,0,0-6.22-1.66,28.22,28.22,0,0,0-6.23.07,39.57,39.57,0,0,0-6.45,1.36c-1.11.33-2.2.69-3.28,1.09a22.91,22.91,0,0,0-3,1.23s-.06.14,0,.13c1.05-.22,2.08-.63,3.1-.94s2.22-.67,3.34-1a41.69,41.69,0,0,1,6.36-1.2,27.92,27.92,0,0,1,6.46,0,38.23,38.23,0,0,1,5.86,1.43C432.46,311.91,432.34,311.35,432.11,311.22Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "419.612px 311.431px",
          }}
          id="elir0vhngc"
          className="animable"
        />
        <g id="elpfbg9dnpvg">
          <path
            d="M432.11,311.22a15.55,15.55,0,0,0-6.22-1.66,28.22,28.22,0,0,0-6.23.07,39.57,39.57,0,0,0-6.45,1.36c-1.11.33-2.2.69-3.28,1.09a22.91,22.91,0,0,0-3,1.23s-.06.14,0,.13c1.05-.22,2.08-.63,3.1-.94s2.22-.67,3.34-1a41.69,41.69,0,0,1,6.36-1.2,27.92,27.92,0,0,1,6.46,0,38.23,38.23,0,0,1,5.86,1.43C432.46,311.91,432.34,311.35,432.11,311.22Z"
            style={{
              opacity: 0.1,
              transformOrigin: "419.612px 311.431px",
            }}
            className="animable"
            id="el2k599ohxmkk"
          />
        </g>
        <path
          d="M443.61,306.1c-4.09-3.25-2.73-11.05,11.6-11.47s24.56,3.32,24.1,7.93c2.31,2.31,1.14,8.77-10.46,10.78S440.66,314.36,443.61,306.1Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "460.943px 304.413px",
          }}
          id="elelp3hs1exo"
          className="animable"
        />
        <path
          d="M472.57,302.61a61.5,61.5,0,0,0-12.79-.74A49.45,49.45,0,0,0,448,303.22a18.45,18.45,0,0,0-2.88,1.07c-.43.21-.85.43-1.26.68s-.68.37-.8.75a.38.38,0,0,0,.42.45,14.63,14.63,0,0,0,2.51-1.24,19.84,19.84,0,0,1,2.48-.9,31.11,31.11,0,0,1,5-1,88.83,88.83,0,0,1,12.09-.67c2.35,0,4.7.21,7.05.4C472.62,302.78,472.65,302.63,472.57,302.61Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "457.838px 303.988px",
          }}
          id="elj38imawqcpo"
          className="animable"
        />
        <g id="els5jzz2n58za">
          <path
            d="M472.57,302.61a61.5,61.5,0,0,0-12.79-.74A49.45,49.45,0,0,0,448,303.22a18.45,18.45,0,0,0-2.88,1.07c-.43.21-.85.43-1.26.68s-.68.37-.8.75a.38.38,0,0,0,.42.45,14.63,14.63,0,0,0,2.51-1.24,19.84,19.84,0,0,1,2.48-.9,31.11,31.11,0,0,1,5-1,88.83,88.83,0,0,1,12.09-.67c2.35,0,4.7.21,7.05.4C472.62,302.78,472.65,302.63,472.57,302.61Z"
            style={{
              opacity: 0.1,
              transformOrigin: "457.838px 303.988px",
            }}
            className="animable"
            id="elswbdjz4lvf7"
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--device-2--inject-835"
      className="animable"
      style={{
        transformOrigin: "341.368px 195.415px",
      }}
    >
      <g
        id="freepik--Mobile--inject-835"
        className="animable"
        style={{
          transformOrigin: "341.368px 195.415px",
        }}
      >
        <path
          d="M387.55,263.2V83c0-4.64-2.3-5.91-4.35-7.1a8.52,8.52,0,0,0-8.32-.21l-74.41,43a11.65,11.65,0,0,0-5.26,9.11V308a7.4,7.4,0,0,0,4.15,6.52c2.05,1.18,5.61,2.48,8.52.8l74.41-43A9.9,9.9,0,0,0,387.55,263.2Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "341.383px 195.415px",
          }}
          id="elm3zkvsxzn2"
          className="animable"
        />
        <path
          d="M382.82,264.91,306.3,309.08l0-181-9.58-5.52a10.75,10.75,0,0,0-1.54,5.18V308a7.4,7.4,0,0,0,4.15,6.52c2.05,1.18,5.61,2.48,8.52.8l74.41-43a10.07,10.07,0,0,0,4.56-5.09l-.3-.17Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "341px 219.341px",
          }}
          id="eldoeu7p0pze8"
          className="animable"
        />
        <path
          d="M382.15,81.44l-74.62,43.09a8.17,8.17,0,0,0-3.7,6.39V309.66c0,3.6,2.56,5.08,5.68,3.27L382.15,271a9.31,9.31,0,0,0,4.19-7.25V83.86C386.34,81.2,384.45,80.11,382.15,81.44Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "345.085px 197.288px",
          }}
          id="eliout85vyuck"
          className="animable"
        />
        <path
          d="M382.7,92.4V259.48a8.81,8.81,0,0,1-4,6.89l-67.27,38.84c-2.2,1.28-4,.25-4-2.29V134.62a8.87,8.87,0,0,1,2.79-6l.38-.35a7.22,7.22,0,0,1,.81-.55l18.92-10.92,1.23-.72c.68-.39,1.24-.07,1.24.72s.59,1.08,1.32.66l22-12.73a2.85,2.85,0,0,0,1.32-2.18,2.79,2.79,0,0,1,1.1-2.07l.13-.08,18.51-10.68.39-.23C380.44,87.9,382.7,89.21,382.7,92.4Z"
          id="elkpbv5u25blk"
          className="animable"
          style={{
            transformOrigin: "345.065px 197.287px",
          }}
        />
        <path
          d="M373,261.91a8.8,8.8,0,0,0,4-6.89V89.93l-18.16,10.48-.13.08a2.79,2.79,0,0,0-1.1,2.07,2.85,2.85,0,0,1-1.32,2.18l-22,12.73c-.73.42-1.32.12-1.32-.66s-.56-1.11-1.24-.72l-1.23.72-18.92,10.92a7.22,7.22,0,0,0-.81.55l-.38.35a8.87,8.87,0,0,0-2.79,6V299.71Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "342.3px 194.82px",
          }}
          id="el7nrvqev4shg"
          className="animable"
        />
        <path
          d="M337.5,110.74l10.11-5.83c.61-.35,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.81l-10.11,5.84c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,337.5,110.74Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "342.555px 109.01px",
          }}
          id="el7vj2kdzsgml"
          className="animable"
        />
        <path
          d="M352.8,101.43c.68-.39,1.23-.07,1.23.71a2.7,2.7,0,0,1-1.23,2.13c-.68.4-1.23.08-1.23-.71A2.72,2.72,0,0,1,352.8,101.43Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "352.8px 102.853px",
          }}
          id="el3p67oemefhe"
          className="animable"
        />
        <path
          d="M302.11,149.38a4.46,4.46,0,0,0-1.94-3.52,1.33,1.33,0,0,0-1.33-.11l-1.46.84a1.52,1.52,0,0,0-.6,1.38v14.68a4.45,4.45,0,0,0,1.94,3.52,1.32,1.32,0,0,0,1.29.14c.27-.14,1.25-.71,1.5-.86a1.53,1.53,0,0,0,.6-1.39Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "299.445px 156.019px",
          }}
          id="elrygoydskjkq"
          className="animable"
        />
        <path
          d="M300.67,150.22V164.9c0,1.32-.87,1.89-1.95,1.27a4.45,4.45,0,0,1-1.94-3.52V148c0-1.32.87-1.89,1.94-1.27A4.43,4.43,0,0,1,300.67,150.22Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "298.725px 156.45px",
          }}
          id="elthfoc9fygse"
          className="animable"
        />
        <path
          d="M302.11,175.08a4.46,4.46,0,0,0-1.94-3.52,1.28,1.28,0,0,0-1.33-.11c-.25.15-1.21.68-1.46.84a1.52,1.52,0,0,0-.6,1.38v14.68a4.46,4.46,0,0,0,1.94,3.52A1.37,1.37,0,0,0,300,192l1.5-.86a1.55,1.55,0,0,0,.6-1.39Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "299.441px 181.708px",
          }}
          id="elne3kuxdf64"
          className="animable"
        />
        <path
          d="M300.67,175.91V190.6c0,1.32-.87,1.89-1.95,1.27a4.46,4.46,0,0,1-1.94-3.52V173.67c0-1.32.87-1.89,1.94-1.27A4.43,4.43,0,0,1,300.67,175.91Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "298.725px 182.135px",
          }}
          id="elnboequ1l0ze"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--screen-2--inject-835"
      className="animable"
      style={{
        transformOrigin: "352.902px 207.03px",
      }}
    >
      <g
        id="freepik--Window--inject-835"
        className="animable"
        style={{
          transformOrigin: "352.902px 207.03px",
        }}
      >
        <g
          id="freepik--window--inject-835"
          className="animable"
          style={{
            transformOrigin: "352.902px 207.03px",
          }}
        >
          <path
            d="M389,96.88a3.58,3.58,0,0,0-3.6.35l-.4.23-18.79,10.85a.57.57,0,0,0-.13.08,2.83,2.83,0,0,0-1.13,2.1,2.89,2.89,0,0,1-1.33,2.21l-22.39,12.92-.05,0a.83.83,0,0,0-.37-.76l-1.29-.75a.87.87,0,0,0-.88.09l-1.25.72L318.13,136a6.26,6.26,0,0,0-.82.56l-.39.35a9.06,9.06,0,0,0-2.83,6.08V313.88a2.83,2.83,0,0,0,1.18,2.61l1.3.75a2.84,2.84,0,0,0,2.85-.28l68.29-39.43a9,9,0,0,0,4-7V100.92a3.59,3.59,0,0,0-1.49-3.29Z"
            style={{
              fill: "#213E60",
              transformOrigin: "352.901px 207.025px",
            }}
            id="els44p7ollllj"
            className="animable"
          />
          <g id="ellf08sqhcyg">
            <path
              d="M319.8,316.4v.33l-.38.22a2.82,2.82,0,0,1-2.85.29l-1.3-.75a2.82,2.82,0,0,1-1.17-2.61V143a8.34,8.34,0,0,1,1.39-4.31l1.54.89a8.16,8.16,0,0,0-1.36,4.17V314.63a3.16,3.16,0,0,0,.56,1.95,1.73,1.73,0,0,0,1.38.65,3.43,3.43,0,0,0,1.67-.52Z"
              style={{
                opacity: 0.3,
                transformOrigin: "316.941px 228.094px",
              }}
              className="animable"
              id="elalrq5rfj35"
            />
          </g>
          <g id="elzhrv342c3f">
            <path
              d="M367,109.93a2.4,2.4,0,0,0-.47,1.3,2.9,2.9,0,0,1-.49,1.5l-1.55-.89a2.62,2.62,0,0,0,.47-1.35,2.7,2.7,0,0,1,.5-1.46Z"
              style={{
                opacity: 0.3,
                transformOrigin: "365.745px 110.88px",
              }}
              className="animable"
              id="eluvt1tzfkugc"
            />
          </g>
          <path
            d="M317.61,317.23a1.73,1.73,0,0,1-1.38-.65,3.14,3.14,0,0,1-.56-1.95V143.78a8.81,8.81,0,0,1,2.74-5.88l.13-.11.25-.22a7.08,7.08,0,0,1,.77-.53L338.77,126l1.25-.73a1,1,0,0,1,.42-.13c.37,0,.41.42.41.61a1,1,0,0,0,1,1.15,1.62,1.62,0,0,0,.78-.23L365,113.7a3.18,3.18,0,0,0,1.49-2.47,2.49,2.49,0,0,1,1-1.86l.1-.07,18.79-10.84.41-.24a4.42,4.42,0,0,1,2.12-.65c1.57,0,2.55,1.29,2.55,3.35V270.53a8.6,8.6,0,0,1-3.89,6.75l-68.29,39.43A3.43,3.43,0,0,1,317.61,317.23Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "353.563px 207.4px",
            }}
            id="eljj2zwipc91"
            className="animable"
          />
          <path
            d="M388.91,97.57a4.42,4.42,0,0,0-2.12.65l-.41.24L367.59,109.3l-.1.07a2.49,2.49,0,0,0-1,1.86A3.18,3.18,0,0,1,365,113.7l-22.38,12.92a1.62,1.62,0,0,1-.78.23,1,1,0,0,1-1-1.15c0-.19,0-.61-.41-.61a1,1,0,0,0-.42.13l-1.25.73L319.56,137a7.08,7.08,0,0,0-.77.53l-.25.22-.13.11a8.81,8.81,0,0,0-2.74,5.88v15.89l75.79-43.77v-15C391.46,98.86,390.48,97.57,388.91,97.57Z"
            style={{
              fill: "#213E60",
              transformOrigin: "353.565px 128.6px",
            }}
            id="el7r019wagvza"
            className="animable"
          />
          <g id="el55isavtxig8">
            <g
              style={{
                opacity: 0.3,
                transformOrigin: "353.565px 128.6px",
              }}
              className="animable"
              id="elkqrj64busb"
            >
              <path
                d="M388.91,97.57a4.42,4.42,0,0,0-2.12.65l-.41.24L367.59,109.3l-.1.07a2.49,2.49,0,0,0-1,1.86A3.18,3.18,0,0,1,365,113.7l-22.38,12.92a1.62,1.62,0,0,1-.78.23,1,1,0,0,1-1-1.15c0-.19,0-.61-.41-.61a1,1,0,0,0-.42.13l-1.25.73L319.56,137a7.08,7.08,0,0,0-.77.53l-.25.22-.13.11a8.81,8.81,0,0,0-2.74,5.88v15.89l75.79-43.77v-15C391.46,98.86,390.48,97.57,388.91,97.57Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "353.565px 128.6px",
                }}
                id="ele4zy3zj4sme"
                className="animable"
              />
            </g>
          </g>
          <path
            d="M383.81,113.61a.23.23,0,0,0,.14,0l4.48-2.58a.29.29,0,0,0,.11-.4.31.31,0,0,0-.41-.11l-4.47,2.58a.29.29,0,0,0-.11.4A.3.3,0,0,0,383.81,113.61Zm4.32.32-4.47,2.58a.29.29,0,0,0-.11.4.3.3,0,0,0,.26.15.23.23,0,0,0,.14,0l4.48-2.58a.29.29,0,0,0,.11-.4A.31.31,0,0,0,388.13,113.93Zm0-1.72-4.47,2.58a.29.29,0,0,0-.11.4.29.29,0,0,0,.4.11l4.48-2.59a.29.29,0,1,0-.3-.5Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "386.045px 113.777px",
            }}
            id="el5s5vcynspxo"
            className="animable"
          />
          <path
            d="M321.14,143.83a.27.27,0,0,1,0,.12.19.19,0,0,1-.07.08l-.16.09h-.07a.1.1,0,0,1,0-.08v-2.75l-.6,1a.17.17,0,0,1-.08.07.06.06,0,0,1-.07,0l-.09-.1a.2.2,0,0,1,0-.09.49.49,0,0,1,0-.11l.8-1.28a.14.14,0,0,1,.06-.07l.06,0,.16-.09s0,0,.07,0a.08.08,0,0,1,0,.07Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "320.576px 142.37px",
            }}
            id="ellve34auvic"
            className="animable"
          />
          <path
            d="M322.72,142.92a.27.27,0,0,1,0,.12l-.07.08-.16.09h-.07a.1.1,0,0,1,0-.08v-2.76l-.61,1a.12.12,0,0,1-.07.07.06.06,0,0,1-.07,0l-.09-.1s0-.05,0-.09a.21.21,0,0,1,0-.11l.8-1.29.06-.07.06,0,.16-.09a0,0,0,0,1,.07,0,.08.08,0,0,1,0,.07Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "322.155px 141.45px",
            }}
            id="elghup09kq99n"
            className="animable"
          />
          <path
            d="M323.6,140.19h.07a.1.1,0,0,1,0,.08v.33a.27.27,0,0,1,0,.12.27.27,0,0,1-.07.08l-.25.14s-.05,0-.07,0a.08.08,0,0,1,0-.07v-.34a.23.23,0,0,1,0-.11s0-.07.07-.08Zm0,1.75h.07a.1.1,0,0,1,0,.08v.33a.27.27,0,0,1,0,.12.27.27,0,0,1-.07.08l-.25.14s-.05,0-.07,0a.08.08,0,0,1,0-.07v-.34a.23.23,0,0,1,0-.11s0-.07.07-.08Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "323.475px 141.44px",
            }}
            id="elpslznacp7ug"
            className="animable"
          />
          <path
            d="M324.47,141.13c0,.14.11.23.22.25a.52.52,0,0,0,.38-.08,1.3,1.3,0,0,0,.23-.18,1.12,1.12,0,0,0,.19-.24,1.36,1.36,0,0,0,.13-.3,1.34,1.34,0,0,0,.05-.35.76.76,0,0,0-.05-.29.32.32,0,0,0-.13-.15.3.3,0,0,0-.19,0,.61.61,0,0,0-.23.09,1.14,1.14,0,0,0-.23.17l-.14.17a1,1,0,0,1-.09.15.31.31,0,0,1-.1.1l-.19.11h-.06a.06.06,0,0,1,0-.06l.12-1.74a.26.26,0,0,1,0-.11.19.19,0,0,1,.07-.08l1.32-.76s.05,0,.07,0a.08.08,0,0,1,0,.07v.18a.2.2,0,0,1,0,.11.22.22,0,0,1-.07.09l-1.09.63-.06.9a1.36,1.36,0,0,1,.17-.18,1.55,1.55,0,0,1,.28-.2,1,1,0,0,1,.37-.13.39.39,0,0,1,.3.06.48.48,0,0,1,.21.25,1.12,1.12,0,0,1,.07.45,1.88,1.88,0,0,1-.07.53,2,2,0,0,1-.21.49,2.06,2.06,0,0,1-.3.41,1.62,1.62,0,0,1-.37.29,1.26,1.26,0,0,1-.36.14.5.5,0,0,1-.3,0,.4.4,0,0,1-.21-.18.68.68,0,0,1-.08-.34.29.29,0,0,1,0-.09.22.22,0,0,1,.06-.07l.18-.1h.05A.07.07,0,0,1,324.47,141.13Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "325.069px 139.887px",
            }}
            id="elp0fz3evgxmn"
            className="animable"
          />
          <path
            d="M326.69,139.92a.75.75,0,0,0,.06.13.14.14,0,0,0,.1.08.24.24,0,0,0,.17,0,1,1,0,0,0,.29-.12,1.18,1.18,0,0,0,.22-.17,1.37,1.37,0,0,0,.19-.22,1.59,1.59,0,0,0,.12-.27,1.06,1.06,0,0,0,.05-.31.55.55,0,0,0-.05-.25.21.21,0,0,0-.12-.11.38.38,0,0,0-.18,0,.89.89,0,0,0-.23.1L327,139s-.05,0-.07,0,0,0,0-.08v-.18a.29.29,0,0,1,0-.09l0-.09.67-1.36-1.08.62a0,0,0,0,1-.07,0,.08.08,0,0,1,0-.07v-.18a.2.2,0,0,1,0-.11.35.35,0,0,1,.07-.09l1.48-.85s.05,0,.07,0,0,0,0,.08v.18a.2.2,0,0,1,0,.1.76.76,0,0,1,0,.11l-.67,1.33a1.46,1.46,0,0,1,.35-.12.44.44,0,0,1,.26.05.46.46,0,0,1,.17.23,1,1,0,0,1,.07.38,1.69,1.69,0,0,1-.08.5,2.13,2.13,0,0,1-.2.46,1.57,1.57,0,0,1-.3.38,1.64,1.64,0,0,1-.36.29,1.51,1.51,0,0,1-.43.17.48.48,0,0,1-.3,0,.37.37,0,0,1-.18-.19.61.61,0,0,1-.06-.28.44.44,0,0,1,0-.1.17.17,0,0,1,.06-.06l.18-.1a0,0,0,0,1,.06,0A.09.09,0,0,1,326.69,139.92Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "327.294px 138.602px",
            }}
            id="elr7h8vzghqpl"
            className="animable"
          />
          <path
            d="M332.54,134h0m0,0L331.39,138v-1.72l-1.29.75,2.44-3m0-.29h0a.33.33,0,0,0-.14,0s-.05,0-.06.05h0l-2.44,3a.29.29,0,0,0,0,.38.3.3,0,0,0,.37.06l.85-.49V138a.28.28,0,0,0,.25.29h0a.29.29,0,0,0,.28-.21l1.15-3.91a.43.43,0,0,0,0-.11.29.29,0,0,0-.29-.29Zm0,.58h0Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "331.316px 136.011px",
            }}
            id="ell9cn46vzt5"
            className="animable"
          />
          <polygon
            points="372.64 114.2 372.01 114.56 372.01 113.33 372.64 112.97 372.64 114.2"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "372.325px 113.765px",
            }}
            id="el2t42954q21t"
            className="animable"
          />
          <polygon
            points="373.64 113.62 373.01 113.98 373.01 112.23 373.64 111.86 373.64 113.62"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "373.325px 112.92px",
            }}
            id="elz2ndjr16vkn"
            className="animable"
          />
          <polygon
            points="374.63 113.05 374 113.41 374 110.99 374.63 110.63 374.63 113.05"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "374.315px 112.02px",
            }}
            id="elswsfkywumb8"
            className="animable"
          />
          <polygon
            points="375.63 112.47 375 112.83 375 109.77 375.63 109.41 375.63 112.47"
            style={{
              fill: "#213E60",
              transformOrigin: "375.315px 111.12px",
            }}
            id="eltpvf1lfuaf"
            className="animable"
          />
          <path
            d="M380,106.8a4.67,4.67,0,0,0-1.66,1.86l.41.33a3.59,3.59,0,0,1,1.25-1.4,1.12,1.12,0,0,1,1.25,0l.42-.81A1.52,1.52,0,0,0,380,106.8Zm-1.08,2.32.38.3a2,2,0,0,1,.7-.79.62.62,0,0,1,.71,0l.38-.75a1,1,0,0,0-1.09,0A3.09,3.09,0,0,0,378.92,109.12Zm.56.45.52.42.53-1a.47.47,0,0,0-.53,0A1.41,1.41,0,0,0,379.48,109.57Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "380.005px 108.265px",
            }}
            id="elqoaht9q52ud"
            className="animable"
          />
          <path
            d="M387.58,102.51c.22-.13.4,0,.4.31v2a1,1,0,0,1-.4.77l-3.53,2c-.23.13-.41,0-.41-.31v-2a1,1,0,0,1,.41-.78l3.53-2m0-.17-3.53,2a1.27,1.27,0,0,0-.54,1v2c0,.39.24.57.54.4l3.53-2a1.29,1.29,0,0,0,.53-1v-2c0-.39-.24-.57-.53-.4Z"
            style={{
              fill: "#213E60",
              transformOrigin: "385.81px 105.03px",
            }}
            id="el65s2r5pnre8"
            className="animable"
          />
          <path
            d="M386.15,105.91l-2,1.14c-.09.06-.17,0-.17-.12v-1.64a.43.43,0,0,1,.17-.32l2-1.14c.09-.06.16,0,.16.12v1.64A.42.42,0,0,1,386.15,105.91Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "385.145px 105.44px",
            }}
            id="el392a9rv8sph"
            className="animable"
          />
          <path
            d="M388.49,104.05l-.14.08v-1.07l.14-.08c.08,0,.14.16.14.45A1,1,0,0,1,388.49,104.05Z"
            style={{
              fill: "#213E60",
              transformOrigin: "388.493px 103.555px",
            }}
            id="elm4vhjgo85w"
            className="animable"
          />
          <path
            d="M388.91,97.86h0c1.42,0,2.26,1.14,2.26,3.06V270.53a8.42,8.42,0,0,1-3.74,6.5l-68.3,39.43a3.15,3.15,0,0,1-1.52.48c-1,0-1.65-.87-1.65-2.31V143.78a8.49,8.49,0,0,1,2.64-5.66l.13-.12.23-.2a5.53,5.53,0,0,1,.75-.51l19.21-11.1,1.25-.72a.63.63,0,0,1,.27-.09c.12,0,.12.28.12.32a1.31,1.31,0,0,0,1.28,1.44,1.83,1.83,0,0,0,.92-.27l22.39-12.93a3.46,3.46,0,0,0,1.62-2.71,2.31,2.31,0,0,1,.88-1.63l.09,0,18.79-10.84.4-.24a4.1,4.1,0,0,1,2-.61m0-.58a4.66,4.66,0,0,0-2.27.7l-.4.23-18.79,10.84-.13.08a2.86,2.86,0,0,0-1.12,2.1,2.9,2.9,0,0,1-1.34,2.22l-22.39,12.92a1.28,1.28,0,0,1-.63.2c-.42,0-.71-.32-.71-.87s-.28-.9-.69-.9a1.11,1.11,0,0,0-.56.18l-1.25.72-19.21,11.09a7,7,0,0,0-.82.56l-.38.34a9,9,0,0,0-2.83,6.09V314.63c0,1.83.9,2.88,2.22,2.88a3.71,3.71,0,0,0,1.81-.55l68.29-39.43a9,9,0,0,0,4-7V100.92c0-2.3-1.16-3.64-2.84-3.64Z"
            style={{
              fill: "#213E60",
              transformOrigin: "353.57px 207.395px",
            }}
            id="el7n7t8meweer"
            className="animable"
          />
        </g>
        <path
          d="M342.59,189.24,322.22,201a3.75,3.75,0,0,0-1.69,2.92V241.7c0,1.07.76,1.51,1.69,1l20.37-11.75a3.75,3.75,0,0,0,1.69-2.92V190.22C344.28,189.14,343.52,188.71,342.59,189.24Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "332.405px 215.963px",
          }}
          id="elgu762jq8yua"
          className="animable"
        />
        <path
          d="M340.26,218,338,219.29a1.85,1.85,0,0,0-.85,1.42c0,.51.38.7.85.43l2.31-1.33a1.85,1.85,0,0,0,.85-1.42C341.11,217.88,340.73,217.69,340.26,218ZM338,197.42l2.31-1.34a1.81,1.81,0,0,0,.85-1.41c0-.51-.38-.71-.85-.43L338,195.57a1.83,1.83,0,0,0-.85,1.42C337.1,197.5,337.48,197.69,338,197.42Zm-4.1,6.18c0,.51.39.7.86.43l2.31-1.34a1.82,1.82,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-2.31,1.34A1.84,1.84,0,0,0,333.85,203.6Zm4,2.41c0-.51-.38-.71-.85-.43l-2.31,1.33a1.84,1.84,0,0,0-.86,1.42c0,.51.39.7.86.43l2.31-1.34A1.81,1.81,0,0,0,337.87,206Zm2.39,2.46L338,209.8a1.83,1.83,0,0,0-.85,1.42c0,.51.38.7.85.43l2.31-1.34a1.81,1.81,0,0,0,.85-1.41C341.11,208.39,340.73,208.19,340.26,208.47Zm-6.41,9.36c0,.51.39.7.86.43l2.31-1.33a1.85,1.85,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-2.31,1.33A1.86,1.86,0,0,0,333.85,217.83Zm-9.3-12.69,9.39-5.4a1.85,1.85,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-9.39,5.41a1.83,1.83,0,0,0-.86,1.41C323.69,205.22,324.08,205.42,324.55,205.14Zm0,23.73,9.39-5.41a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43L324.55,227a1.84,1.84,0,0,0-.86,1.42C323.69,229,324.08,229.14,324.55,228.87Zm0-19,6.14-3.55a1.81,1.81,0,0,0,.85-1.41c0-.51-.38-.71-.85-.43L324.55,208a1.84,1.84,0,0,0-.86,1.42C323.69,210,324.08,210.16,324.55,209.89Zm0,4.74,6.14-3.54a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-6.14,3.55a1.83,1.83,0,0,0-.86,1.41C323.69,214.71,324.08,214.91,324.55,214.63Zm0,4.75,9.39-5.41a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-9.39,5.41a1.84,1.84,0,0,0-.86,1.42C323.69,219.46,324.08,219.65,324.55,219.38Zm0,4.74,6.14-3.54a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-6.14,3.55a1.83,1.83,0,0,0-.86,1.41C323.69,224.2,324.08,224.39,324.55,224.12Zm15.71,3.38L338,228.83a1.85,1.85,0,0,0-.85,1.42c0,.51.38.7.85.43l2.31-1.33a1.85,1.85,0,0,0,.85-1.42C341.11,227.42,340.73,227.23,340.26,227.5Zm-2.39-2.45c0-.51-.38-.7-.85-.43L334.71,226a1.86,1.86,0,0,0-.86,1.42c0,.51.39.7.86.43l2.31-1.33A1.85,1.85,0,0,0,337.87,225.05Zm-3.93,6.1-9.39,5.41a1.84,1.84,0,0,0-.86,1.42c0,.51.39.7.86.43l9.39-5.41a1.83,1.83,0,0,0,.85-1.42C334.79,231.07,334.41,230.88,333.94,231.15Zm-9.39,2.51,6.14-3.54a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-6.14,3.55a1.83,1.83,0,0,0-.86,1.41C323.69,233.74,324.08,233.94,324.55,233.66Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "332.425px 216.313px",
          }}
          id="eluuiyeq6hpkq"
          className="animable"
        />
        <path
          d="M342.59,150.38l-20.37,11.75a3.73,3.73,0,0,0-1.69,2.92v29c0,1.07.76,1.51,1.69,1l20.37-11.75a3.73,3.73,0,0,0,1.69-2.92v-29C344.28,150.28,343.52,149.84,342.59,150.38Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "332.405px 172.706px",
          }}
          id="elre7i96lb98"
          className="animable"
        />
        <path
          d="M340.26,179.09,338,180.43a1.83,1.83,0,0,0-.85,1.42c0,.51.38.7.85.43l2.31-1.34a1.81,1.81,0,0,0,.85-1.41C341.11,179,340.73,178.82,340.26,179.09ZM338,158.56l2.31-1.34a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43L338,156.71a1.81,1.81,0,0,0-.85,1.41C337.1,158.63,337.48,158.83,338,158.56Zm-4.1,6.17c0,.51.39.71.86.43l2.31-1.33a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-2.31,1.34A1.83,1.83,0,0,0,333.85,164.73Zm3.17,2-2.31,1.34a1.83,1.83,0,0,0-.86,1.41c0,.51.39.71.86.44l2.31-1.34a1.83,1.83,0,0,0,.85-1.42C337.87,166.63,337.49,166.44,337,166.71Zm3.24,2.89L338,170.94a1.81,1.81,0,0,0-.85,1.41c0,.51.38.71.85.44l2.31-1.34a1.83,1.83,0,0,0,.85-1.42C341.11,169.52,340.73,169.33,340.26,169.6Zm-2.39,7.05c0-.51-.38-.71-.85-.44l-2.31,1.34a1.84,1.84,0,0,0-.86,1.42c0,.51.39.7.86.43l2.31-1.34A1.81,1.81,0,0,0,337.87,176.65Zm-13.32-10.37,9.39-5.41a1.81,1.81,0,0,0,.85-1.41c0-.51-.38-.71-.85-.43l-9.39,5.4a1.86,1.86,0,0,0-.86,1.42C323.69,166.36,324.08,166.55,324.55,166.28Zm9.39,16.47-9.39,5.41a1.83,1.83,0,0,0-.86,1.41c0,.51.39.71.86.43l9.39-5.4a1.85,1.85,0,0,0,.85-1.42C334.79,182.67,334.41,182.48,333.94,182.75ZM324.55,171l6.14-3.55a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-6.14,3.55a1.83,1.83,0,0,0-.86,1.42C323.69,171.11,324.08,171.3,324.55,171Zm0,4.74,6.14-3.55a1.81,1.81,0,0,0,.85-1.41c0-.51-.38-.7-.85-.43l-6.14,3.54a1.86,1.86,0,0,0-.86,1.42C323.69,175.85,324.08,176,324.55,175.77Zm0,4.75,9.39-5.41a1.85,1.85,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-9.39,5.41a1.83,1.83,0,0,0-.86,1.41C323.69,180.59,324.08,180.79,324.55,180.52Zm0,4.74,6.14-3.54a1.85,1.85,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-6.14,3.54a1.84,1.84,0,0,0-.86,1.42C323.69,185.34,324.08,185.53,324.55,185.26Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "332.425px 172.697px",
          }}
          id="elvqcjspb9wl"
          className="animable"
        />
        <path
          d="M342.59,260.77l-20.37,11.74a3.75,3.75,0,0,0-1.69,2.92v29c0,1.08.76,1.51,1.69,1l20.37-11.75a3.71,3.71,0,0,0,1.69-2.92v-29C344.28,260.66,343.52,260.23,342.59,260.77Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "332.405px 283.091px",
          }}
          id="elpyzs88u3z9a"
          className="animable"
        />
        <path
          d="M340.26,289.48,338,290.82a1.81,1.81,0,0,0-.85,1.41c0,.51.38.7.85.43l2.31-1.33a1.85,1.85,0,0,0,.85-1.42C341.11,289.4,340.73,289.21,340.26,289.48ZM338,268.94l2.31-1.34a1.81,1.81,0,0,0,.85-1.41c0-.51-.38-.7-.85-.43L338,267.09a1.83,1.83,0,0,0-.85,1.42C337.1,269,337.48,269.21,338,268.94Zm-4.1,6.18c0,.51.39.7.86.43l2.31-1.34a1.81,1.81,0,0,0,.85-1.41c0-.51-.38-.71-.85-.43l-2.31,1.33A1.84,1.84,0,0,0,333.85,275.12Zm3.17,2-2.31,1.33a1.84,1.84,0,0,0-.86,1.42c0,.51.39.7.86.43l2.31-1.34a1.81,1.81,0,0,0,.85-1.41C337.87,277,337.49,276.83,337,277.1Zm3.24,2.89L338,281.32a1.83,1.83,0,0,0-.85,1.42c0,.51.38.7.85.43l2.31-1.34a1.81,1.81,0,0,0,.85-1.41C341.11,279.91,340.73,279.72,340.26,280Zm-2.39,7c0-.51-.38-.7-.85-.43l-2.31,1.34a1.83,1.83,0,0,0-.86,1.41c0,.51.39.7.86.43l2.31-1.33A1.83,1.83,0,0,0,337.87,287Zm-13.32-10.36,9.39-5.41a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-9.39,5.41a1.84,1.84,0,0,0-.86,1.42C323.69,276.75,324.08,276.94,324.55,276.67Zm9.39,16.46-9.39,5.41a1.84,1.84,0,0,0-.86,1.42c0,.51.39.7.86.43l9.39-5.41a1.83,1.83,0,0,0,.85-1.42C334.79,293.05,334.41,292.86,333.94,293.13Zm-9.39-11.72,6.14-3.55a1.81,1.81,0,0,0,.85-1.41c0-.51-.38-.7-.85-.43l-6.14,3.54a1.86,1.86,0,0,0-.86,1.42C323.69,281.49,324.08,281.68,324.55,281.41Zm0,4.75,6.14-3.55a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-6.14,3.55a1.83,1.83,0,0,0-.86,1.41C323.69,286.23,324.08,286.43,324.55,286.16Zm0,4.74,9.39-5.41a1.81,1.81,0,0,0,.85-1.41c0-.51-.38-.71-.85-.44l-9.39,5.41a1.84,1.84,0,0,0-.86,1.42C323.69,291,324.08,291.17,324.55,290.9Zm0,4.74,6.14-3.54a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-6.14,3.55a1.83,1.83,0,0,0-.86,1.41C323.69,295.72,324.08,295.92,324.55,295.64Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "332.448px 283.065px",
          }}
          id="elge7jk7tvkkm"
          className="animable"
        />
        <path
          d="M342.59,236.83l-20.37,11.74a3.75,3.75,0,0,0-1.69,2.92v13.89c0,1.07.76,1.51,1.69,1l20.37-11.75a3.75,3.75,0,0,0,1.69-2.92V237.8C344.28,236.72,343.52,236.29,342.59,236.83Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "332.405px 251.595px",
          }}
          id="elalz31r9jgs"
          className="animable"
        />
        <path
          d="M340.26,241.82,338,243.15a1.83,1.83,0,0,0-.85,1.42c0,.51.38.7.85.43l2.31-1.34a1.81,1.81,0,0,0,.85-1.41C341.11,241.74,340.73,241.55,340.26,241.82ZM337,248.43l-2.31,1.33a1.84,1.84,0,0,0-.86,1.42c0,.51.39.7.86.43l2.31-1.34a1.81,1.81,0,0,0,.85-1.41C337.87,248.35,337.49,248.15,337,248.43Zm0,4.73-2.31,1.33a1.86,1.86,0,0,0-.86,1.42c0,.51.39.7.86.43L337,255a1.81,1.81,0,0,0,.85-1.41C337.87,253.08,337.49,252.89,337,253.16Zm-12.47-.43,9.39-5.41a1.83,1.83,0,0,0,.85-1.42c0-.51-.38-.7-.85-.43l-9.39,5.41a1.84,1.84,0,0,0-.86,1.42C323.69,252.81,324.08,253,324.55,252.73Zm6.14-.65-6.14,3.54a1.86,1.86,0,0,0-.86,1.42c0,.51.39.7.86.43l6.14-3.54a1.85,1.85,0,0,0,.85-1.42C331.54,252,331.16,251.81,330.69,252.08Zm0,4.74-6.14,3.55a1.83,1.83,0,0,0-.86,1.41c0,.51.39.71.86.44l6.14-3.55a1.83,1.83,0,0,0,.85-1.42C331.54,256.74,331.16,256.55,330.69,256.82Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "332.415px 252.019px",
          }}
          id="elousq9hjto1f"
          className="animable"
        />
        <path
          d="M352.5,224.45l-3.34,1.93a1.32,1.32,0,0,0-.61,1.05v1.23c0,.38.27.54.61.35l3.34-1.93a1.36,1.36,0,0,0,.61-1.05V224.8C353.11,224.41,352.83,224.26,352.5,224.45Zm0-4.89-3.34,1.93a1.32,1.32,0,0,0-.61,1v1.23c0,.39.27.54.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05v-1.23C353.11,219.52,352.83,219.37,352.5,219.56Zm0-14.47L349.16,207a1.32,1.32,0,0,0-.61,1v1.23c0,.39.27.54.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05v-1.23C353.11,205.05,352.83,204.9,352.5,205.09Zm0,4.89-3.34,1.93a1.32,1.32,0,0,0-.61,1.05v1.23c0,.38.27.54.61.35l3.34-1.93a1.38,1.38,0,0,0,.61-1.05v-1.23C353.11,209.94,352.83,209.78,352.5,210Zm0,37.21-3.34,1.93a1.32,1.32,0,0,0-.61,1v1.23c0,.39.27.54.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1v-1.23C353.11,247.15,352.83,247,352.5,247.19Zm0-47-3.34,1.93a1.34,1.34,0,0,0-.61,1.05v1.23c0,.39.27.54.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05v-1.23C353.11,200.16,352.83,200,352.5,200.2Zm0,42.1-3.34,1.93a1.32,1.32,0,0,0-.61,1.05v1.23c0,.39.27.54.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05v-1.23C353.11,242.26,352.83,242.11,352.5,242.3Zm0-4.89-3.34,1.93a1.35,1.35,0,0,0-.61,1v1.23c0,.39.27.55.61.35L352.5,240a1.35,1.35,0,0,0,.61-1v-1.23A.37.37,0,0,0,352.5,237.41Zm0-4.89-3.34,1.93a1.35,1.35,0,0,0-.61,1.06v1.22c0,.39.27.55.61.35l3.34-1.92a1.38,1.38,0,0,0,.61-1.06v-1.22C353.11,232.49,352.83,232.33,352.5,232.52Zm0-75.93-3.34,1.93a1.35,1.35,0,0,0-.61,1.06v1.22c0,.39.27.55.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05V157C353.11,156.56,352.83,156.4,352.5,156.59Zm0-4.88-3.34,1.93a1.32,1.32,0,0,0-.61,1.05v1.23c0,.38.27.54.61.35l3.34-1.93a1.38,1.38,0,0,0,.61-1.05v-1.23C353.11,151.67,352.83,151.51,352.5,151.71Zm0,9.77-3.34,1.93a1.35,1.35,0,0,0-.61,1.05v1.23c0,.39.27.55.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05v-1.23A.37.37,0,0,0,352.5,161.48Zm0-14.66-3.34,1.93a1.32,1.32,0,0,0-.61,1.05V151c0,.38.27.54.61.35l3.34-1.93a1.36,1.36,0,0,0,.61-1v-1.23C353.11,146.78,352.83,146.63,352.5,146.82Zm0,38.91-3.34,1.93a1.32,1.32,0,0,0-.61,1.05v1.23c0,.39.27.54.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05v-1.23C353.11,185.69,352.83,185.54,352.5,185.73Zm0-4.89-3.34,1.93a1.35,1.35,0,0,0-.61,1v1.23c0,.39.27.54.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05v-1.23A.37.37,0,0,0,352.5,180.84Zm0-9.77L349.16,173a1.32,1.32,0,0,0-.61,1.05v1.22c0,.39.27.55.61.36l3.34-1.93a1.38,1.38,0,0,0,.61-1.06v-1.22C353.11,171,352.83,170.87,352.5,171.07Zm0,24.24-3.34,1.93a1.35,1.35,0,0,0-.61,1v1.23c0,.39.27.55.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05v-1.23A.37.37,0,0,0,352.5,195.31Zm0-19.36-3.34,1.93a1.35,1.35,0,0,0-.61,1.05v1.23c0,.39.27.55.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05V176.3A.37.37,0,0,0,352.5,176Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "350.835px 199.26px",
          }}
          id="elqi7s26vpael"
          className="animable"
        />
        <path
          d="M357.52,160.23l28-16.16c.34-.19.62,0,.62.31a1.31,1.31,0,0,1-.62,1l-28,16.16c-.34.19-.62.05-.62-.31A1.31,1.31,0,0,1,357.52,160.23Z"
          style={{
            fill: "#213E60",
            transformOrigin: "371.52px 152.809px",
          }}
          id="elrv2we0xym9n"
          className="animable"
        />
        <g id="elq3i8nmwagv">
          <path
            d="M357.52,160.23l28-16.16c.34-.19.62,0,.62.31a1.31,1.31,0,0,1-.62,1l-28,16.16c-.34.19-.62.05-.62-.31A1.31,1.31,0,0,1,357.52,160.23Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "371.52px 152.809px",
            }}
            className="animable"
            id="elb59wrejh4d"
          />
        </g>
        <path
          d="M381.79,130.14l-24.25,14a1.3,1.3,0,0,0-.61,1c0,.36.27.5.61.31l24.25-14a1.31,1.31,0,0,0,.62-1C382.41,130.09,382.13,130,381.79,130.14Zm4.08-2.33-1.7,1a1.32,1.32,0,0,0-.61,1c0,.37.28.5.61.31l1.7-.95a1.33,1.33,0,0,0,.61-1C386.48,127.76,386.21,127.62,385.87,127.81Z"
          style={{
            fill: "#213E60",
            transformOrigin: "371.705px 136.631px",
          }}
          id="eli8307pxz469"
          className="animable"
        />
        <g id="elbp29ka37vch">
          <path
            d="M381.79,130.14l-24.25,14a1.3,1.3,0,0,0-.61,1c0,.36.27.5.61.31l24.25-14a1.31,1.31,0,0,0,.62-1C382.41,130.09,382.13,130,381.79,130.14Zm4.08-2.33-1.7,1a1.32,1.32,0,0,0-.61,1c0,.37.28.5.61.31l1.7-.95a1.33,1.33,0,0,0,.61-1C386.48,127.76,386.21,127.62,385.87,127.81Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "371.705px 136.631px",
            }}
            className="animable"
            id="ela64ohyc1hj6"
          />
        </g>
        <g id="elfz47lblwq6h">
          <path
            d="M357.54,149.3l12.28-7.1a1.31,1.31,0,0,0,.62-1c0-.37-.28-.51-.62-.31L357.54,148a1.3,1.3,0,0,0-.61,1C356.93,149.35,357.2,149.49,357.54,149.3Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "363.685px 145.092px",
            }}
            className="animable"
            id="elrjm6ml1icc"
          />
        </g>
        <g id="el54x9pp01suu">
          <path
            d="M357.54,153.1l7.38-4.25a1.3,1.3,0,0,0,.61-1c0-.36-.27-.5-.61-.31l-7.38,4.25a1.3,1.3,0,0,0-.61,1C356.93,153.15,357.2,153.29,357.54,153.1Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "361.23px 150.32px",
            }}
            className="animable"
            id="elzvyednktag7"
          />
        </g>
        <g id="elcpx1d2y8mz">
          <path
            d="M372.2,140.83l13.6-7.91a1.34,1.34,0,0,0,.62-1c0-.37-.28-.51-.62-.31l-13.6,7.91a1.3,1.3,0,0,0-.61,1C371.59,140.88,371.86,141,372.2,140.83Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "379.005px 136.212px",
            }}
            className="animable"
            id="elfosdmrh9vzs"
          />
        </g>
        <g id="elk4m16ao2tmd">
          <path
            d="M379,139.35l-12.15,7.05a1.31,1.31,0,0,0-.62,1c0,.36.28.5.62.31l12.15-7a1.31,1.31,0,0,0,.61-1C379.65,139.29,379.38,139.15,379,139.35Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "372.922px 143.528px",
            }}
            className="animable"
            id="elqojzb0b8olk"
          />
        </g>
        <g id="elpvr01u06xlr">
          <path
            d="M380.81,139c0,.37.27.51.61.31l4.09-2.2a1.33,1.33,0,0,0,.61-1c0-.37-.27-.51-.61-.31l-4.09,2.2A1.33,1.33,0,0,0,380.81,139Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "383.465px 137.555px",
            }}
            className="animable"
            id="elgxsea16yrk7"
          />
        </g>
        <g id="elo13to90f8os">
          <path
            d="M379,143.43l-21.52,12.35a1.32,1.32,0,0,0-.62,1c0,.37.28.51.62.31L379,144.76a1.31,1.31,0,0,0,.61-1C379.65,143.37,379.38,143.23,379,143.43Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "368.237px 150.26px",
            }}
            className="animable"
            id="elgls24qn3dz8"
          />
        </g>
        <g id="ele5fhjh5s4mu">
          <path
            d="M385.51,139.85l-4.09,2.2a1.31,1.31,0,0,0-.61,1c0,.37.27.51.61.31l4.09-2.2a1.33,1.33,0,0,0,.61-1C386.12,139.79,385.85,139.65,385.51,139.85Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "383.465px 141.605px",
            }}
            className="animable"
            id="el3v0z8ifrxnp"
          />
        </g>
        <path
          d="M357.67,190.38l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,190.38Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 190.22px",
          }}
          id="elna10njiqdve"
          className="animable"
        />
        <g id="el5n5gc1c3dm6">
          <path
            d="M357.67,190.38l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,190.38Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 190.22px",
            }}
            className="animable"
            id="el1ay53qt4076"
          />
        </g>
        <path
          d="M357.67,169.58l2.84-1.64c.34-.19.62-.05.62.31a1.31,1.31,0,0,1-.62,1l-2.84,1.64c-.34.19-.61.05-.61-.31A1.3,1.3,0,0,1,357.67,169.58Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 169.415px",
          }}
          id="eln4vshbercfq"
          className="animable"
        />
        <g id="el22s008n161pj">
          <path
            d="M357.67,169.58l2.84-1.64c.34-.19.62-.05.62.31a1.31,1.31,0,0,1-.62,1l-2.84,1.64c-.34.19-.61.05-.61-.31A1.3,1.3,0,0,1,357.67,169.58Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 169.415px",
            }}
            className="animable"
            id="eln02syp1b55"
          />
        </g>
        <path
          d="M357.67,177.76l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.33,1.33,0,0,1,357.67,177.76Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 177.6px",
          }}
          id="el8gdamf2hht3"
          className="animable"
        />
        <g id="el3fxzltcd70c">
          <path
            d="M357.67,177.76l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.33,1.33,0,0,1,357.67,177.76Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 177.6px",
            }}
            className="animable"
            id="elni2o53gmhe"
          />
        </g>
        <path
          d="M357.67,181.57l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,181.57Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 181.41px",
          }}
          id="ell0rdilhqvo"
          className="animable"
        />
        <g id="el26avk3ne01z">
          <path
            d="M357.67,181.57l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,181.57Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 181.41px",
            }}
            className="animable"
            id="ellgcshuem59k"
          />
        </g>
        <path
          d="M357.67,185.38l2.84-1.63c.34-.2.62-.06.62.31a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.19-.61.06-.61-.31A1.3,1.3,0,0,1,357.67,185.38Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 185.218px",
          }}
          id="el5keavhdkweu"
          className="animable"
        />
        <g id="el8rp32wood33">
          <path
            d="M357.67,185.38l2.84-1.63c.34-.2.62-.06.62.31a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.19-.61.06-.61-.31A1.3,1.3,0,0,1,357.67,185.38Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 185.218px",
            }}
            className="animable"
            id="elpljyrq3bnal"
          />
        </g>
        <path
          d="M357.67,193.82l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.33,1.33,0,0,1,357.67,193.82Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 193.66px",
          }}
          id="elhz6pov32auq"
          className="animable"
        />
        <g id="el9vlq022qyp5">
          <path
            d="M357.67,193.82l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.33,1.33,0,0,1,357.67,193.82Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 193.66px",
            }}
            className="animable"
            id="ele8laxg8okie"
          />
        </g>
        <path
          d="M357.67,218.75l2.84-1.63c.34-.2.62-.06.62.31a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,218.75Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 218.59px",
          }}
          id="elqsbgh6llkvm"
          className="animable"
        />
        <g id="elimpo3i5mkrq">
          <path
            d="M357.67,218.75l2.84-1.63c.34-.2.62-.06.62.31a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,218.75Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 218.59px",
            }}
            className="animable"
            id="elvrcgp8ofxg"
          />
        </g>
        <path
          d="M357.67,222.19l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,222.19Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 222.03px",
          }}
          id="elactx2g9dob"
          className="animable"
        />
        <g id="elvoirkf0lrie">
          <path
            d="M357.67,222.19l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,222.19Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 222.03px",
            }}
            className="animable"
            id="el8d7s1nnl0o"
          />
        </g>
        <path
          d="M357.67,202l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,202Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 201.84px",
          }}
          id="elusvtkso119"
          className="animable"
        />
        <g id="elbienfn49qgo">
          <path
            d="M357.67,202l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,202Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 201.84px",
            }}
            className="animable"
            id="el17bqhtk9znh"
          />
        </g>
        <path
          d="M357.67,205.82l2.84-1.63c.34-.2.62-.06.62.31a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.19-.61.06-.61-.31A1.3,1.3,0,0,1,357.67,205.82Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 205.658px",
          }}
          id="el5c06zvny2k2"
          className="animable"
        />
        <g id="elk908zl0603h">
          <path
            d="M357.67,205.82l2.84-1.63c.34-.2.62-.06.62.31a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.19-.61.06-.61-.31A1.3,1.3,0,0,1,357.67,205.82Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 205.658px",
            }}
            className="animable"
            id="elxytylmca50h"
          />
        </g>
        <path
          d="M357.67,209.63l2.84-1.64c.34-.19.62-.05.62.31a1.31,1.31,0,0,1-.62,1L357.67,211c-.34.19-.61,0-.61-.31A1.3,1.3,0,0,1,357.67,209.63Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 209.491px",
          }}
          id="elqpdsabz71ar"
          className="animable"
        />
        <g id="elufjodsu08g7">
          <path
            d="M357.67,209.63l2.84-1.64c.34-.19.62-.05.62.31a1.31,1.31,0,0,1-.62,1L357.67,211c-.34.19-.61,0-.61-.31A1.3,1.3,0,0,1,357.67,209.63Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 209.491px",
            }}
            className="animable"
            id="eld0j36yiibjw"
          />
        </g>
        <path
          d="M357.67,239.22l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,239.22Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 239.06px",
          }}
          id="elrn5hd96nb28"
          className="animable"
        />
        <g id="elbnerbolsvqe">
          <path
            d="M357.67,239.22l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,239.22Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 239.06px",
            }}
            className="animable"
            id="elcdsltlfsm8m"
          />
        </g>
        <path
          d="M357.67,243l2.84-1.63c.34-.2.62-.06.62.31a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,243Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 242.84px",
          }}
          id="elx6cf3tjs5lm"
          className="animable"
        />
        <g id="el60a8gpkvfa2">
          <path
            d="M357.67,243l2.84-1.63c.34-.2.62-.06.62.31a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,243Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 242.84px",
            }}
            className="animable"
            id="eltv3jny3ds6h"
          />
        </g>
        <path
          d="M357.67,231.68l2.84-1.64c.34-.19.62,0,.62.31a1.31,1.31,0,0,1-.62,1L357.67,233c-.34.19-.61.05-.61-.31A1.3,1.3,0,0,1,357.67,231.68Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 231.524px",
          }}
          id="elryaoc69ua9"
          className="animable"
        />
        <g id="el2x5wwz2bdrc">
          <path
            d="M357.67,231.68l2.84-1.64c.34-.19.62,0,.62.31a1.31,1.31,0,0,1-.62,1L357.67,233c-.34.19-.61.05-.61-.31A1.3,1.3,0,0,1,357.67,231.68Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 231.524px",
            }}
            className="animable"
            id="eln4rybog3sm"
          />
        </g>
        <path
          d="M357.67,235.48l2.84-1.63c.34-.19.62,0,.62.31a1.31,1.31,0,0,1-.62,1l-2.84,1.64c-.34.19-.61.05-.61-.32A1.33,1.33,0,0,1,357.67,235.48Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 235.329px",
          }}
          id="eltlwhuzdxlq"
          className="animable"
        />
        <g id="elrxs2rzzp2qn">
          <path
            d="M357.67,235.48l2.84-1.63c.34-.19.62,0,.62.31a1.31,1.31,0,0,1-.62,1l-2.84,1.64c-.34.19-.61.05-.61-.32A1.33,1.33,0,0,1,357.67,235.48Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 235.329px",
            }}
            className="animable"
            id="el6knjlir7xy2"
          />
        </g>
        <path
          d="M363.94,171.62l21.93-12.75a1.31,1.31,0,0,0,.61-1c0-.37-.27-.51-.61-.31l-21.93,12.75a1.34,1.34,0,0,0-.62,1C363.32,171.68,363.6,171.82,363.94,171.62Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.9px 164.59px",
          }}
          id="elrhm3wy9bqt"
          className="animable"
        />
        <path
          d="M363.94,167.83l21.93-12.78a1.3,1.3,0,0,0,.61-1c0-.37-.27-.5-.61-.31L363.94,166.5a1.31,1.31,0,0,0-.62,1C363.32,167.88,363.6,168,363.94,167.83Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.9px 160.779px",
          }}
          id="elt7yw91qmt7"
          className="animable"
        />
        <path
          d="M385.87,161.48l-21.93,12.66a1.32,1.32,0,0,0-.62,1c0,.37.28.51.62.31l21.93-12.66a1.31,1.31,0,0,0,.61-1C386.48,161.42,386.21,161.28,385.87,161.48Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.9px 168.465px",
          }}
          id="elormj28len4"
          className="animable"
        />
        <path
          d="M385.87,165.29,363.94,178a1.31,1.31,0,0,0-.62,1c0,.37.28.5.62.31l21.93-12.66a1.33,1.33,0,0,0,.61-1C386.48,165.23,386.21,165.09,385.87,165.29Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.9px 172.298px",
          }}
          id="el739rsqizkx4"
          className="animable"
        />
        <path
          d="M385.87,169.09l-21.93,12.67a1.31,1.31,0,0,0-.62,1c0,.36.28.5.62.31l21.93-12.66a1.33,1.33,0,0,0,.61-1C386.48,169,386.21,168.9,385.87,169.09Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.9px 176.076px",
          }}
          id="elx7ce5krjc4e"
          className="animable"
        />
        <path
          d="M363.94,188.14l21.93-12.65a1.31,1.31,0,0,0,.61-1c0-.37-.27-.51-.61-.31l-21.93,12.65a1.32,1.32,0,0,0-.62,1C363.32,188.2,363.6,188.34,363.94,188.14Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.9px 181.16px",
          }}
          id="elubrtold4bw"
          className="animable"
        />
        <path
          d="M363.94,191.61l21.93-12.78a1.3,1.3,0,0,0,.61-1c0-.36-.27-.5-.61-.31l-21.93,12.78a1.31,1.31,0,0,0-.62,1C363.32,191.66,363.6,191.8,363.94,191.61Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.9px 184.565px",
          }}
          id="elmfkgdg8dsy"
          className="animable"
        />
        <path
          d="M364.24,216.32l17.55-10.12a1.34,1.34,0,0,0,.62-1c0-.37-.28-.51-.62-.31L364.24,215a1.34,1.34,0,0,0-.61,1C363.63,216.38,363.91,216.52,364.24,216.32Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "373.02px 210.605px",
          }}
          id="ela9exzgtwogh"
          className="animable"
        />
        <path
          d="M364.22,219.61l21.38-12.38a1.34,1.34,0,0,0,.62-1c0-.37-.28-.51-.62-.31l-21.38,12.38a1.33,1.33,0,0,0-.61,1C363.61,219.67,363.88,219.81,364.22,219.61Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.915px 212.765px",
          }}
          id="el9p2nysvk6jk"
          className="animable"
        />
        <path
          d="M385.87,185.82l-21.82,12.56a1.31,1.31,0,0,0-.62,1c0,.36.28.5.62.31l21.82-12.56a1.33,1.33,0,0,0,.61-1C386.48,185.76,386.21,185.62,385.87,185.82Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 192.752px",
          }}
          id="elkz4ipholx88"
          className="animable"
        />
        <path
          d="M385.87,189.58l-21.82,12.56a1.31,1.31,0,0,0-.62,1c0,.37.28.51.62.31l21.82-12.56a1.33,1.33,0,0,0,.61-1C386.48,189.52,386.21,189.38,385.87,189.58Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 196.515px",
          }}
          id="el384bj7bspbt"
          className="animable"
        />
        <path
          d="M385.87,193.4,364.05,206a1.32,1.32,0,0,0-.62,1c0,.37.28.51.62.31l21.82-12.56a1.31,1.31,0,0,0,.61-1C386.48,193.34,386.21,193.2,385.87,193.4Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 200.356px",
          }}
          id="eloxg0o1uopv8"
          className="animable"
        />
        <path
          d="M385.87,223l-21.82,12.56a1.31,1.31,0,0,0-.62,1c0,.37.28.51.62.31l21.82-12.56a1.31,1.31,0,0,0,.61-1C386.48,223,386.21,222.83,385.87,223Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 229.947px",
          }}
          id="elu5n176j8km"
          className="animable"
        />
        <path
          d="M385.87,226.79l-21.82,12.56a1.32,1.32,0,0,0-.62,1c0,.37.28.51.62.31l21.82-12.56a1.31,1.31,0,0,0,.61-1C386.48,226.73,386.21,226.59,385.87,226.79Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 233.725px",
          }}
          id="elbnaixm2iic6"
          className="animable"
        />
        <path
          d="M385.87,215.48,364.05,228a1.34,1.34,0,0,0-.62,1c0,.37.28.51.62.31l21.82-12.56a1.3,1.3,0,0,0,.61-1C386.48,215.43,386.21,215.29,385.87,215.48Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 222.398px",
          }}
          id="elcgokto4hnri"
          className="animable"
        />
        <path
          d="M385.87,219.24l-21.82,12.57a1.31,1.31,0,0,0-.62,1c0,.36.28.5.62.31l21.82-12.57a1.3,1.3,0,0,0,.61-1C386.48,219.19,386.21,219.05,385.87,219.24Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 226.18px",
          }}
          id="elvuxyauklu2h"
          className="animable"
        />
        <path
          d="M385.87,230.61l-21.82,12.56a1.34,1.34,0,0,0-.62,1c0,.37.28.51.62.31l21.82-12.56a1.3,1.3,0,0,0,.61-1C386.48,230.56,386.21,230.42,385.87,230.61Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 237.548px",
          }}
          id="elvoctrgckdog"
          className="animable"
        />
        <path
          d="M357.67,246.84l2.84-1.64c.34-.19.62,0,.62.32a1.31,1.31,0,0,1-.62,1l-2.84,1.64c-.34.19-.61.06-.61-.31A1.3,1.3,0,0,1,357.67,246.84Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 246.686px",
          }}
          id="elwx2g8aji2mi"
          className="animable"
        />
        <g id="elsqrl3pc383j">
          <path
            d="M357.67,246.84l2.84-1.64c.34-.19.62,0,.62.32a1.31,1.31,0,0,1-.62,1l-2.84,1.64c-.34.19-.61.06-.61-.31A1.3,1.3,0,0,1,357.67,246.84Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 246.686px",
            }}
            className="animable"
            id="elo6i09dzxyf"
          />
        </g>
        <path
          d="M352.5,262.15l-3.34,1.93a1.32,1.32,0,0,0-.61,1.05v1.23c0,.39.27.54.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1V262.5C353.11,262.11,352.83,262,352.5,262.15Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "350.83px 264.439px",
          }}
          id="el8htn91nxgiv"
          className="animable"
        />
        <path
          d="M352.5,257.26l-3.34,1.93a1.32,1.32,0,0,0-.61,1.05v1.23c0,.39.27.54.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05v-1.23C353.11,257.22,352.83,257.07,352.5,257.26Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "350.83px 259.54px",
          }}
          id="elz7wdbyto5f"
          className="animable"
        />
        <path
          d="M352.5,284.89l-3.34,1.93a1.32,1.32,0,0,0-.61,1.05v1.23c0,.39.27.54.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1v-1.23C353.11,284.85,352.83,284.7,352.5,284.89Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "350.83px 287.171px",
          }}
          id="eld6s1bhx8sbu"
          className="animable"
        />
        <path
          d="M352.5,280l-3.34,1.93a1.34,1.34,0,0,0-.61,1.05v1.23c0,.39.27.54.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05v-1.23A.37.37,0,0,0,352.5,280Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "350.834px 282.273px",
          }}
          id="el7y7y3ne0aw"
          className="animable"
        />
        <path
          d="M352.5,275.11,349.16,277a1.35,1.35,0,0,0-.61,1v1.23c0,.39.27.55.61.35l3.34-1.93a1.35,1.35,0,0,0,.61-1.05v-1.23A.37.37,0,0,0,352.5,275.11Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "350.83px 277.344px",
          }}
          id="elg9eubxtf18"
          className="animable"
        />
        <path
          d="M352.5,270.23l-3.34,1.92a1.35,1.35,0,0,0-.61,1.06v1.22c0,.39.27.55.61.35l3.34-1.92a1.38,1.38,0,0,0,.61-1.06v-1.22C353.11,270.19,352.83,270,352.5,270.23Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "350.83px 272.498px",
          }}
          id="elsbfrfyc03rq"
          className="animable"
        />
        <path
          d="M357.67,256.45l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,256.45Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 256.29px",
          }}
          id="elw4zzhqwi1lp"
          className="animable"
        />
        <g id="elwo92bc7ea3l">
          <path
            d="M357.67,256.45l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,256.45Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 256.29px",
            }}
            className="animable"
            id="elgf4h1v71rjq"
          />
        </g>
        <path
          d="M357.67,259.89l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.33,1.33,0,0,1,357.67,259.89Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 259.73px",
          }}
          id="elhvc92urkfv"
          className="animable"
        />
        <g id="el006bz3zutahee">
          <path
            d="M357.67,259.89l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.33,1.33,0,0,1,357.67,259.89Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 259.73px",
            }}
            className="animable"
            id="elzo63j7xgjnb"
          />
        </g>
        <path
          d="M357.67,276.92l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.33,1.33,0,0,1,357.67,276.92Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 276.76px",
          }}
          id="eluqtezu6e1q"
          className="animable"
        />
        <g id="eldygolyyqc0j">
          <path
            d="M357.67,276.92l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.33,1.33,0,0,1,357.67,276.92Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 276.76px",
            }}
            className="animable"
            id="elfgoboqp4ghs"
          />
        </g>
        <path
          d="M357.67,280.73l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,280.73Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 280.57px",
          }}
          id="el6k5epekax1b"
          className="animable"
        />
        <g id="elnam9m3pbcp9">
          <path
            d="M357.67,280.73l2.84-1.63c.34-.2.62-.06.62.31a1.32,1.32,0,0,1-.62,1l-2.84,1.63c-.34.2-.61.06-.61-.31A1.31,1.31,0,0,1,357.67,280.73Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 280.57px",
            }}
            className="animable"
            id="ellpujgheot4m"
          />
        </g>
        <path
          d="M357.67,269.38l2.84-1.64c.34-.19.62-.05.62.32a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.19-.61.06-.61-.31A1.3,1.3,0,0,1,357.67,269.38Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 269.216px",
          }}
          id="elhdz9stcqz3v"
          className="animable"
        />
        <g id="elvne34occvoh">
          <path
            d="M357.67,269.38l2.84-1.64c.34-.19.62-.05.62.32a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.19-.61.06-.61-.31A1.3,1.3,0,0,1,357.67,269.38Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 269.216px",
            }}
            className="animable"
            id="elk3jb3wlwmhh"
          />
        </g>
        <path
          d="M357.67,273.19l2.84-1.64c.34-.19.62-.05.62.31a1.31,1.31,0,0,1-.62,1l-2.84,1.64c-.34.19-.61.05-.61-.31A1.3,1.3,0,0,1,357.67,273.19Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 273.025px",
          }}
          id="elm181vri5ap8"
          className="animable"
        />
        <g id="el8kmol1buzxf">
          <path
            d="M357.67,273.19l2.84-1.64c.34-.19.62-.05.62.31a1.31,1.31,0,0,1-.62,1l-2.84,1.64c-.34.19-.61.05-.61-.31A1.3,1.3,0,0,1,357.67,273.19Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 273.025px",
            }}
            className="animable"
            id="ell551okd4teb"
          />
        </g>
        <path
          d="M364.24,254l17.55-10.12a1.34,1.34,0,0,0,.62-1c0-.37-.28-.51-.62-.31l-17.55,10.12a1.34,1.34,0,0,0-.61,1C363.63,254.08,363.91,254.22,364.24,254Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "373.02px 248.291px",
          }}
          id="el9dj4yg2akag"
          className="animable"
        />
        <path
          d="M364.22,257.32l21.38-12.39a1.32,1.32,0,0,0,.62-1c0-.37-.28-.51-.62-.31L364.22,256a1.3,1.3,0,0,0-.61,1C363.61,257.37,363.88,257.51,364.22,257.32Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.915px 250.467px",
          }}
          id="elmbubz3jr31"
          className="animable"
        />
        <path
          d="M385.87,260.73l-21.82,12.56a1.32,1.32,0,0,0-.62,1c0,.37.28.51.62.31l21.82-12.56a1.31,1.31,0,0,0,.61-1C386.48,260.67,386.21,260.53,385.87,260.73Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 267.665px",
          }}
          id="eliuu7qz6eefr"
          className="animable"
        />
        <path
          d="M385.87,264.49l-21.82,12.56a1.32,1.32,0,0,0-.62,1c0,.37.28.51.62.31l21.82-12.56a1.31,1.31,0,0,0,.61-1C386.48,264.43,386.21,264.29,385.87,264.49Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 271.425px",
          }}
          id="eltxcmcpyfu4"
          className="animable"
        />
        <path
          d="M385.87,253.18l-21.82,12.57a1.31,1.31,0,0,0-.62,1c0,.36.28.5.62.31l21.82-12.57a1.3,1.3,0,0,0,.61-1C386.48,253.13,386.21,253,385.87,253.18Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 260.122px",
          }}
          id="elfa3i53lvx5"
          className="animable"
        />
        <path
          d="M385.87,256.94l-21.82,12.57a1.31,1.31,0,0,0-.62,1c0,.36.28.5.62.31l21.82-12.57a1.3,1.3,0,0,0,.61-1C386.48,256.89,386.21,256.75,385.87,256.94Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 263.88px",
          }}
          id="elu0y04sm135"
          className="animable"
        />
        <path
          d="M385.87,268.31l-21.82,12.56a1.34,1.34,0,0,0-.62,1c0,.37.28.51.62.32l21.82-12.57a1.3,1.3,0,0,0,.61-1C386.48,268.26,386.21,268.12,385.87,268.31Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "374.955px 275.25px",
          }}
          id="el6wei04ywzzp"
          className="animable"
        />
        <path
          d="M357.67,284.54l2.84-1.63c.34-.2.62-.06.62.31a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.19-.61.06-.61-.31A1.3,1.3,0,0,1,357.67,284.54Z"
          style={{
            fill: "#213E60",
            transformOrigin: "359.095px 284.378px",
          }}
          id="els4pfxqfd42"
          className="animable"
        />
        <g id="elzjmxopocsqa">
          <path
            d="M357.67,284.54l2.84-1.63c.34-.2.62-.06.62.31a1.34,1.34,0,0,1-.62,1l-2.84,1.63c-.34.19-.61.06-.61-.31A1.3,1.3,0,0,1,357.67,284.54Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "359.095px 284.378px",
            }}
            className="animable"
            id="elhlecvt8rxw4"
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--device-1--inject-835"
      className="animable"
      style={{
        transformOrigin: "154.975px 203.951px",
      }}
    >
      <g
        id="freepik--Device--inject-835"
        className="animable"
        style={{
          transformOrigin: "154.975px 203.951px",
        }}
      >
        <g
          id="freepik--Monitor--inject-835"
          className="animable"
          style={{
            transformOrigin: "154.975px 203.951px",
          }}
        >
          <path
            d="M198.38,338.2,170,321.78c-5.84-3.37-15.67-4.14-22-1.72l-16.87,6.5a97,97,0,0,0-21,11.93L93,352c-2.47,1.94-3.68,4.31-3.68,6.62,0,.65,0,3.26,0,3.92,0,2.61,1.59,5.15,4.66,6.93l28.43,16.41c5.84,3.37,15.3,3.37,21.14,0l54.86-31.68c2.93-1.69,4.38-3.91,4.36-6.12V344.3C202.75,342.09,201.3,339.88,198.38,338.2Z"
            style={{
              fill: "rgb(230, 230, 230)",
              transformOrigin: "146.045px 353.528px",
            }}
            id="elhhzk4lnoo1l"
            className="animable"
          />
          <path
            d="M89.29,362.55c0,2.61,1.59,5.15,4.66,6.93l28.43,16.41A21.66,21.66,0,0,0,133,388.42v-4.06L89.28,359.15C89.28,360.15,89.28,362,89.29,362.55Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "111.14px 373.787px",
            }}
            id="el6xej3ktco5"
            className="animable"
          />
          <g id="elk3nyyet138">
            <path
              d="M89.29,362.55c0,2.61,1.59,5.15,4.66,6.93l28.43,16.41A21.66,21.66,0,0,0,133,388.42v-4.06L89.28,359.15C89.28,360.15,89.28,362,89.29,362.55Z"
              style={{
                opacity: 0.1,
                transformOrigin: "111.14px 373.787px",
              }}
              className="animable"
              id="elm2wm1crmrqg"
            />
          </g>
          <path
            d="M148,320.06l-16.87,6.5a97,97,0,0,0-21,11.93L93,352c-5.29,4.17-4.85,10.28,1,13.65l28.43,16.41c5.84,3.37,15.3,3.37,21.14,0l54.86-31.67c5.84-3.37,5.84-8.83,0-12.2L170,321.78C164.11,318.41,154.28,317.64,148,320.06Z"
            style={{
              fill: "rgb(240, 240, 240)",
              transformOrigin: "146.058px 351.618px",
            }}
            id="el941kb5slz9"
            className="animable"
          />
          <g id="elrum5cvf417">
            <path
              d="M170,321.78c-5.84-3.37-15.67-4.14-22-1.72l-16.87,6.5a97,97,0,0,0-21,11.93L93,352c-2.47,1.94-3.68,4.31-3.68,6.62,0,.65,0,3.26,0,3.92,0,2.61,1.59,5.15,4.66,6.93l15.84,9.14v-3.8l76-43.88Z"
              style={{
                opacity: 0.1,
                transformOrigin: "137.57px 348.63px",
              }}
              className="animable"
              id="elx1eu07mltk"
            />
          </g>
          <path
            d="M143.31,339.05c0-8.38,2.63-34.78,8.13-41l-17.6-1.94c-8.66,9.15-19,31-25.29,43.6,0,0,5.16,2.1,11.54,4.74s15.24,2.63,19.8,0a6.13,6.13,0,0,0,3.41-5.44Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "129.995px 321.268px",
            }}
            id="elliwuxq5d4z"
            className="animable"
          />
          <g id="elwkbbckovaxp">
            <path
              d="M143.31,339.05c0-8.38,2.63-34.78,8.13-41l-17.6-1.94c-8.66,9.15-19,31-25.29,43.6,0,0,5.16,2.1,11.54,4.74s15.24,2.63,19.8,0a6.13,6.13,0,0,0,3.41-5.44Z"
              style={{
                opacity: 0.1,
                transformOrigin: "129.995px 321.268px",
              }}
              className="animable"
              id="el7x7j5s6qxh4"
            />
          </g>
          <path
            d="M140,298.69c3.42,1.41,8.17,1.41,10.62,0s2.44-4.16,0-6.14L146.21,289a50.85,50.85,0,0,0-12.37,7.18S136.61,297.27,140,298.69Z"
            style={{
              fill: "rgb(224, 224, 224)",
              transformOrigin: "143.147px 294.374px",
            }}
            id="el6f7h87ch7uc"
            className="animable"
          />
          <path
            d="M43.76,356.62a10,10,0,0,0,9.07-.17l213.08-123a10.34,10.34,0,0,0,4.67-8.1V28.42a10,10,0,0,0-4.39-7.94,10,10,0,0,0-9.06.17l-213.08,123a10.37,10.37,0,0,0-4.68,8.11V348.68A10.06,10.06,0,0,0,43.76,356.62Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "154.975px 188.551px",
            }}
            id="elql2g9lq2fj"
            className="animable"
          />
          <path
            d="M52.83,356.44l213.08-123a10.35,10.35,0,0,0,4.68-8.11V28.41c0-3-2.1-4.19-4.68-2.7l-213.08,123a10.35,10.35,0,0,0-4.68,8.1V353.74C48.15,356.73,50.25,357.93,52.83,356.44Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "159.37px 191.074px",
            }}
            id="elirfyxk2f3bf"
            className="animable"
          />
          <path
            d="M48.15,337.82v15.92c0,3,2.1,4.19,4.68,2.7l213.08-123a10.35,10.35,0,0,0,4.68-8.11V209.38Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "159.37px 283.231px",
            }}
            id="elxpxhszc6sq8"
            className="animable"
          />
          <path
            d="M54.33,323V158.94a6.36,6.36,0,0,1,2.87-5L261.52,36c1.58-.92,2.87-.17,2.87,1.66V201.72a6.37,6.37,0,0,1-2.88,5l-204.31,118C55.62,325.59,54.33,324.85,54.33,323Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "159.36px 180.345px",
            }}
            id="ely8wihm0rakg"
            className="animable"
          />
          <path
            d="M40.75,147.16l8.78,5.06a9.87,9.87,0,0,0-1.39,4.63V353.74c0,2.72,1.84,4.25,4.68,2.71a10,10,0,0,1-9.07.17,9,9,0,0,1-4.39-7.38V151.79A9.74,9.74,0,0,1,40.75,147.16Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "46.09px 252.392px",
            }}
            id="el1nzchuc63s1"
            className="animable"
          />
          <path
            d="M156.79,284l10.58-6.08c.95-.54,1.72-.16,1.72.87a3.68,3.68,0,0,1-1.72,2.85l-10.58,6.07c-.95.55-1.72.16-1.72-.86A3.66,3.66,0,0,1,156.79,284Z"
            style={{
              fill: "#213E60",
              transformOrigin: "162.08px 282.817px",
            }}
            id="elnwztszu150a"
            className="animable"
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--screen-1--inject-835"
      className="animable"
      style={{
        transformOrigin: "169.63px 190.643px",
      }}
    >
      <g
        id="freepik--window--inject-835"
        className="animable"
        style={{
          transformOrigin: "169.63px 190.643px",
        }}
      >
        <g
          id="freepik--window--inject-835"
          className="animable"
          style={{
            transformOrigin: "169.63px 190.643px",
          }}
        >
          <path
            d="M70,337.06a1.37,1.37,0,0,1-.34,0,.69.69,0,0,1-.19-.07l-.15-.08-.17-.11a1.88,1.88,0,0,1-1-1.66V170.28c0-4,1.68-6.37,3.24-7.28L272.82,47a2.68,2.68,0,0,1,1.3-.41,1.24,1.24,0,0,1,.58.13.91.91,0,0,1,.22.12.71.71,0,0,1,.15.15l0,0,.05,0,.06.1,0,.06,0,0a1.23,1.23,0,0,1,.14.31l0,.16,0,0,.07.19a1,1,0,0,1,0,.21c0,.12,0,.25,0,.39V215.14a7.18,7.18,0,0,1-3.24,5.62l-198,114.06-3.26,1.88-.07,0-.06,0,0,0a1.78,1.78,0,0,1-.86.27Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "171.773px 191.83px",
            }}
            id="el1w7hu4hhedv"
            className="animable"
          />
          <path
            d="M274.12,47.12a.89.89,0,0,1,.39.09l.06,0,0,0,.06,0,.08.11h0v0l.07.11.07.14,0,.05L275,48v0l0,0,0,.06a.34.34,0,0,1,0,.1c0,.11,0,.23,0,.35V215.14a6.72,6.72,0,0,1-3,5.18l-198,114.06-3.23,1.87h0l-.09.06-.09.05a1.32,1.32,0,0,1-.66.2h0l-.23,0-.07,0-.09-.06-.08-.05-.05,0,0,0,0,0a1.38,1.38,0,0,1-.74-1.22v-1.77h0v-163c0-3.77,1.55-6,3-6.84l201.4-116a2.28,2.28,0,0,1,1.06-.34m0-1a3.15,3.15,0,0,0-1.55.47l-201.41,116c-1.92,1.11-3.49,3.83-3.49,7.71v164h0v.76a2.37,2.37,0,0,0,1.26,2.1l.15.1.18.1a1.06,1.06,0,0,0,.3.1,1.74,1.74,0,0,0,.45.06h0a2.23,2.23,0,0,0,1.1-.33l.1-.05h0l3.33-1.92,198-114.06a7.72,7.72,0,0,0,3.49-6.05V48.61c0-.15,0-.3,0-.44a1.13,1.13,0,0,0-.06-.32s0,0,0-.07a1.57,1.57,0,0,0-.08-.31,1.38,1.38,0,0,0-.21-.44.72.72,0,0,0-.11-.19.58.58,0,0,0-.1-.12,1.25,1.25,0,0,0-.23-.23l0,0a1.75,1.75,0,0,0-.29-.18,1.91,1.91,0,0,0-.8-.17Z"
            style={{
              fill: "#213E60",
              transformOrigin: "171.86px 191.91px",
            }}
            id="elzbv0zleil7"
            className="animable"
          />
          <path
            d="M274.92,46.29a2.58,2.58,0,0,0-2.35.3l-201.41,116a7.75,7.75,0,0,0-3.49,6.05v6.77l-4.46-2.61v-6.69a7.7,7.7,0,0,1,3.49-6l201.41-116a2.43,2.43,0,0,1,2.53-.2C271.27,44.24,274.17,45.9,274.92,46.29Z"
            style={{
              fill: "#213E60",
              transformOrigin: "169.065px 109.528px",
            }}
            id="ellaeijrrp65f"
            className="animable"
          />
          <path
            d="M276.05,48.58c0-2.2-1.56-3.09-3.48-2l-201.41,116a7.71,7.71,0,0,0-3.49,6v6.77l208.37-120Z"
            style={{
              fill: "#213E60",
              transformOrigin: "171.86px 110.732px",
            }}
            id="el882kfycbmup"
            className="animable"
          />
          <g id="elhaylkf1g3i7">
            <g
              style={{
                opacity: 0.2,
                transformOrigin: "169.585px 104.392px",
              }}
              className="animable"
              id="elllvzbiwikkp"
            >
              <path
                d="M272.57,46.59l-201.4,116a7.14,7.14,0,0,0-2.46,2.59l-4.44-2.56a7,7,0,0,1,2.43-2.55l201.41-116a2.46,2.46,0,0,1,2.53-.21c.63.39,3.53,2,4.26,2.43A2.51,2.51,0,0,0,272.57,46.59Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  transformOrigin: "169.585px 104.392px",
                }}
                id="elpsu9i6hx44n"
                className="animable"
              />
            </g>
          </g>
          <g id="elrjy5rsi7ok">
            <path
              d="M63.21,172.79v-6.7a7.25,7.25,0,0,1,1.06-3.49l4.45,2.55a7,7,0,0,0-1,3.47v6.77Z"
              style={{
                opacity: 0.15,
                transformOrigin: "65.965px 168.995px",
              }}
              className="animable"
              id="elmzahodvgkfl"
            />
          </g>
          <path
            d="M260.9,56.77a3.54,3.54,0,0,0-1.48,2.83c0,1.09.66,1.59,1.48,1.12a3.54,3.54,0,0,0,1.48-2.83C262.38,56.8,261.72,56.3,260.9,56.77Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "260.9px 58.745px",
            }}
            id="el8jcjbdn2r6r"
            className="animable"
          />
          <path
            d="M266.23,53.69a3.54,3.54,0,0,0-1.48,2.83c0,1.09.66,1.59,1.48,1.12a3.54,3.54,0,0,0,1.48-2.83C267.71,53.72,267.05,53.22,266.23,53.69Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "266.23px 55.665px",
            }}
            id="eluc1owow8c8"
            className="animable"
          />
          <path
            d="M271.57,50.6a3.56,3.56,0,0,0-1.49,2.83c0,1.09.67,1.6,1.49,1.12a3.57,3.57,0,0,0,1.48-2.83C273.05,50.63,272.38,50.13,271.57,50.6Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "271.565px 52.5771px",
            }}
            id="elq07ncqo2krr"
            className="animable"
          />
          <path
            d="M68.93,337.21l-.18-.1L65.07,335a3.7,3.7,0,0,1-1.83-2.7,4.36,4.36,0,0,1,0-.51v-159l4.46,2.61v159.7a2.29,2.29,0,0,0,1.09,2,.67.67,0,0,0,.11.07s0,0,0,0Z"
            style={{
              fill: "#213E60",
              transformOrigin: "66.0813px 255px",
            }}
            id="elr2o81lkc1hg"
            className="animable"
          />
          <g id="elg1goi3km45t">
            <path
              d="M68.93,337.21l-.18-.1L65.07,335a3.7,3.7,0,0,1-1.83-2.7,4.36,4.36,0,0,1,0-.51v-159l4.46,2.61v159.7a2.29,2.29,0,0,0,1.09,2,.67.67,0,0,0,.11.07s0,0,0,0Z"
              style={{
                fill: "rgb(255, 255, 255)",
                opacity: 0.5,
                transformOrigin: "66.0813px 255px",
              }}
              className="animable"
              id="el0pkf803m2lca"
            />
          </g>
        </g>
        <path
          d="M113.91,211,79.18,231a5.14,5.14,0,0,0-2.33,4v52.31c0,1.49,1,2.09,2.33,1.34l34.73-20a5.15,5.15,0,0,0,2.34-4V212.31C116.25,210.82,115.2,210.22,113.91,211Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "96.55px 249.815px",
          }}
          id="el0jpuk73h8g4h"
          className="animable"
        />
        <path
          d="M110.69,250.72l-3.2,1.85a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.59l3.2-1.85a2.52,2.52,0,0,0,1.18-2C111.87,250.61,111.34,250.34,110.69,250.72Zm-3.2-28.44,3.2-1.85a2.52,2.52,0,0,0,1.18-2c0-.71-.53-1-1.18-.6l-3.2,1.85a2.55,2.55,0,0,0-1.18,2C106.31,222.39,106.84,222.66,107.49,222.28Zm-5.67,8.55c0,.71.53,1,1.18.6l3.19-1.85a2.55,2.55,0,0,0,1.19-2c0-.71-.53-1-1.19-.6L103,228.87A2.55,2.55,0,0,0,101.82,230.83Zm5.56,3.34c0-.7-.53-1-1.19-.6L103,235.42a2.55,2.55,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.19-1.85A2.53,2.53,0,0,0,107.38,234.17Zm3.31,3.4-3.2,1.85a2.55,2.55,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.2-1.85a2.52,2.52,0,0,0,1.18-2C111.87,237.47,111.34,237.2,110.69,237.57Zm-8.87,13c0,.71.53,1,1.18.6l3.19-1.85a2.56,2.56,0,0,0,1.19-2c0-.71-.53-1-1.19-.6L103,248.58A2.52,2.52,0,0,0,101.82,250.54ZM82.41,236.76l19.52-11.27a2.54,2.54,0,0,0,1.18-2c0-.71-.53-1-1.18-.6L82.41,234.21a2.49,2.49,0,0,0-1.18,2C81.23,236.87,81.75,237.14,82.41,236.76Zm0,32.85,19.52-11.28a2.52,2.52,0,0,0,1.18-2c0-.7-.53-1-1.18-.6L82.41,267.05a2.51,2.51,0,0,0-1.18,2C81.23,269.72,81.75,270,82.41,269.61Zm0-26.28,15-8.69a2.55,2.55,0,0,0,1.18-2c0-.71-.53-1-1.18-.6l-15,8.69a2.53,2.53,0,0,0-1.18,2C81.23,243.44,81.75,243.71,82.41,243.33Zm0,6.57,15-8.69a2.55,2.55,0,0,0,1.18-2c0-.7-.53-1-1.18-.59l-15,8.69a2.52,2.52,0,0,0-1.18,2C81.23,250,81.75,250.28,82.41,249.9Zm0,6.57,19.52-11.27a2.55,2.55,0,0,0,1.18-2c0-.7-.53-1-1.18-.59L82.41,253.91a2.52,2.52,0,0,0-1.18,2C81.23,256.58,81.75,256.85,82.41,256.47Zm0,6.57,15-8.7a2.52,2.52,0,0,0,1.18-2c0-.7-.53-1-1.18-.59l-15,8.69a2.51,2.51,0,0,0-1.18,2C81.23,263.15,81.75,263.41,82.41,263Zm28.28.89-3.2,1.84a2.55,2.55,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.2-1.85a2.52,2.52,0,0,0,1.18-2C111.87,263.82,111.34,263.55,110.69,263.93Zm-3.31-3.39c0-.71-.53-1-1.19-.6L103,261.79a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.59l3.19-1.84A2.56,2.56,0,0,0,107.38,260.54ZM101.93,269,82.41,280.26a2.49,2.49,0,0,0-1.18,2c0,.7.52,1,1.18.6l19.52-11.28a2.54,2.54,0,0,0,1.18-2C103.11,268.87,102.58,268.61,101.93,269Zm-19.52,7.27,15-8.7a2.52,2.52,0,0,0,1.18-2c0-.7-.53-1-1.18-.59l-15,8.69a2.51,2.51,0,0,0-1.18,2C81.23,276.36,81.75,276.62,82.41,276.25Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "96.55px 250.344px",
          }}
          id="elyee8av4rrc"
          className="animable"
        />
        <path
          d="M113.91,157.16,79.18,177.21a5.14,5.14,0,0,0-2.33,4v40.11c0,1.48,1,2.09,2.33,1.34l34.73-20a5.15,5.15,0,0,0,2.34-4V158.5C116.25,157,115.2,156.41,113.91,157.16Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "96.55px 189.908px",
          }}
          id="elt6z2feahw"
          className="animable"
        />
        <path
          d="M110.69,196.91l-3.2,1.85a2.55,2.55,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.2-1.85a2.54,2.54,0,0,0,1.18-2C111.87,196.8,111.34,196.54,110.69,196.91Zm-3.2-28.43,3.2-1.85a2.55,2.55,0,0,0,1.18-2c0-.71-.53-1-1.18-.6l-3.2,1.85a2.54,2.54,0,0,0-1.18,2C106.31,168.58,106.84,168.85,107.49,168.48ZM101.82,177c0,.7.53,1,1.18.59l3.19-1.84a2.56,2.56,0,0,0,1.19-2c0-.71-.53-1-1.19-.6L103,175.07A2.52,2.52,0,0,0,101.82,177Zm4.37,2.74L103,181.62a2.52,2.52,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.19-1.85a2.56,2.56,0,0,0,1.19-2C107.38,179.66,106.85,179.39,106.19,179.77Zm4.5,4-3.2,1.85a2.54,2.54,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.2-1.85a2.55,2.55,0,0,0,1.18-2C111.87,183.66,111.34,183.39,110.69,183.77Zm-3.31,9.75c0-.7-.53-1-1.19-.6L103,194.77a2.55,2.55,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.19-1.85A2.53,2.53,0,0,0,107.38,193.52ZM82.41,183l19.52-11.28a2.52,2.52,0,0,0,1.18-2c0-.7-.53-1-1.18-.59L82.41,180.4a2.52,2.52,0,0,0-1.18,2C81.23,183.07,81.75,183.34,82.41,183Zm19.52,19L82.41,213.24a2.52,2.52,0,0,0-1.18,2c0,.71.52,1,1.18.6l19.52-11.27a2.55,2.55,0,0,0,1.18-2C103.11,201.86,102.58,201.59,101.93,202ZM82.41,189.53l15-8.7a2.52,2.52,0,0,0,1.18-2c0-.7-.53-1-1.18-.6l-15,8.7a2.51,2.51,0,0,0-1.18,2C81.23,189.64,81.75,189.9,82.41,189.53Zm0,6.57,15-8.7a2.54,2.54,0,0,0,1.18-2c0-.71-.53-1-1.18-.6l-15,8.7a2.51,2.51,0,0,0-1.18,2C81.23,196.21,81.75,196.47,82.41,196.1Zm0,6.56,19.52-11.27a2.54,2.54,0,0,0,1.18-2c0-.71-.53-1-1.18-.6L82.41,200.11a2.49,2.49,0,0,0-1.18,2C81.23,202.77,81.75,203,82.41,202.66Zm0,6.57,15-8.69a2.54,2.54,0,0,0,1.18-2c0-.71-.53-1-1.18-.6l-15,8.7a2.49,2.49,0,0,0-1.18,2C81.23,209.34,81.75,209.61,82.41,209.23Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "96.55px 189.935px",
          }}
          id="elu8i0ai7ly7"
          className="animable"
        />
        <path
          d="M113.91,276.84,79.18,296.89a5.14,5.14,0,0,0-2.33,4v19.22c0,1.49,1,2.09,2.33,1.35l34.73-20.05a5.18,5.18,0,0,0,2.34-4.05V278.19C116.25,276.7,115.2,276.09,113.91,276.84Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "96.55px 299.148px",
          }}
          id="elbnts4qk8wn5"
          className="animable"
        />
        <path
          d="M110.69,283.75l-3.2,1.85a2.54,2.54,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.2-1.85a2.55,2.55,0,0,0,1.18-2C111.87,283.64,111.34,283.37,110.69,283.75Zm-4.5,9.15L103,294.75a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.59l3.19-1.84a2.56,2.56,0,0,0,1.19-2C107.38,292.79,106.85,292.52,106.19,292.9Zm0,6.55L103,301.3a2.54,2.54,0,0,0-1.18,2c0,.71.53,1,1.18.6l3.19-1.85a2.56,2.56,0,0,0,1.19-2C107.38,299.34,106.85,299.07,106.19,299.45Zm-23.78,3.19,19.52-11.28a2.52,2.52,0,0,0,1.18-2c0-.7-.53-1-1.18-.59L82.41,300.08a2.52,2.52,0,0,0-1.18,2C81.23,302.75,81.75,303,82.41,302.64Zm15-4.69-15,8.7a2.51,2.51,0,0,0-1.18,2c0,.71.52,1,1.18.6l15-8.7a2.52,2.52,0,0,0,1.18-2C98.62,297.85,98.09,297.58,97.44,298Zm0,6.57-15,8.7a2.51,2.51,0,0,0-1.18,2c0,.71.52,1,1.18.6l15-8.7a2.54,2.54,0,0,0,1.18-2C98.62,304.41,98.09,304.15,97.44,304.52Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "96.55px 299.789px",
          }}
          id="elnszlbi5f54r"
          className="animable"
        />
        <path
          d="M129.63,258.23l-4.53,2.62a1.8,1.8,0,0,0-.82,1.42v1.67c0,.52.37.73.82.47l4.53-2.61a1.84,1.84,0,0,0,.82-1.43v-1.66C130.45,258.18,130.08,258,129.63,258.23Zm0-6.62-4.53,2.61a1.81,1.81,0,0,0-.82,1.43v1.66c0,.53.37.74.82.48l4.53-2.62a1.82,1.82,0,0,0,.82-1.42v-1.67C130.45,251.56,130.08,251.35,129.63,251.61Zm0-19.61-4.53,2.62a1.8,1.8,0,0,0-.82,1.42v1.67c0,.52.37.73.82.47l4.53-2.61a1.84,1.84,0,0,0,.82-1.43v-1.66C130.45,232,130.08,231.74,129.63,232Zm0,6.63-4.53,2.61a1.8,1.8,0,0,0-.82,1.42v1.67c0,.52.37.74.82.47l4.53-2.61a1.82,1.82,0,0,0,.82-1.42V239.1C130.45,238.58,130.08,238.36,129.63,238.63Zm0,50.41-4.53,2.62a1.8,1.8,0,0,0-.82,1.42v1.67c0,.52.37.73.82.47l4.53-2.61a1.84,1.84,0,0,0,.82-1.43v-1.66C130.45,289,130.08,288.78,129.63,289Zm0-63.66L125.1,228a1.81,1.81,0,0,0-.82,1.43v1.66c0,.53.37.74.82.48l4.53-2.62a1.82,1.82,0,0,0,.82-1.42v-1.66C130.45,225.33,130.08,225.12,129.63,225.38Zm0,57L125.1,285a1.81,1.81,0,0,0-.82,1.43v1.66c0,.53.37.74.82.48l4.53-2.62a1.82,1.82,0,0,0,.82-1.42V282.9C130.45,282.37,130.08,282.16,129.63,282.42Zm0-6.62-4.53,2.61a1.8,1.8,0,0,0-.82,1.43v1.66c0,.52.37.74.82.47l4.53-2.61a1.82,1.82,0,0,0,.82-1.42v-1.67C130.45,275.75,130.08,275.54,129.63,275.8Zm0-6.63-4.53,2.62a1.8,1.8,0,0,0-.82,1.42v1.67c0,.52.37.73.82.47l4.53-2.61a1.82,1.82,0,0,0,.82-1.43v-1.66C130.45,269.13,130.08,268.91,129.63,269.17Zm0-102.87-4.53,2.61a1.8,1.8,0,0,0-.82,1.43V172c0,.52.37.74.82.47l4.53-2.61a1.82,1.82,0,0,0,.82-1.42v-1.67C130.45,166.25,130.08,166,129.63,166.3Zm0-6.63-4.53,2.62a1.8,1.8,0,0,0-.82,1.42v1.67c0,.52.37.73.82.47l4.53-2.61a1.82,1.82,0,0,0,.82-1.43v-1.66C130.45,159.63,130.08,159.41,129.63,159.67Zm0,13.25-4.53,2.61a1.81,1.81,0,0,0-.82,1.43v1.66c0,.53.37.74.82.48l4.53-2.62a1.82,1.82,0,0,0,.82-1.42V173.4C130.45,172.87,130.08,172.66,129.63,172.92Zm0-19.87-4.53,2.62a1.8,1.8,0,0,0-.82,1.42v1.66c0,.53.37.74.82.48l4.53-2.61a1.84,1.84,0,0,0,.82-1.43v-1.66C130.45,153,130.08,152.79,129.63,153.05Zm0,52.72-4.53,2.62a1.8,1.8,0,0,0-.82,1.42v1.67c0,.52.37.73.82.47l4.53-2.61a1.84,1.84,0,0,0,.82-1.43v-1.66C130.45,205.72,130.08,205.51,129.63,205.77Zm0-6.62-4.53,2.61a1.81,1.81,0,0,0-.82,1.43v1.66c0,.53.37.74.82.48l4.53-2.62a1.82,1.82,0,0,0,.82-1.42v-1.66C130.45,199.1,130.08,198.89,129.63,199.15Zm0-13.25-4.53,2.62a1.8,1.8,0,0,0-.82,1.42v1.67c0,.52.37.73.82.47l4.53-2.61a1.82,1.82,0,0,0,.82-1.43v-1.66C130.45,185.85,130.08,185.64,129.63,185.9Zm0,32.86-4.53,2.61a1.8,1.8,0,0,0-.82,1.43v1.66c0,.52.37.74.82.47l4.53-2.61a1.82,1.82,0,0,0,.82-1.42v-1.67C130.45,218.71,130.08,218.5,129.63,218.76Zm0-26.23-4.53,2.61a1.8,1.8,0,0,0-.82,1.43v1.66c0,.52.37.74.82.47l4.53-2.61a1.82,1.82,0,0,0,.82-1.42V193C130.45,192.48,130.08,192.27,129.63,192.53Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "127.365px 224.135px",
          }}
          id="elov3cfwexujc"
          className="animable"
        />
        <path
          d="M141.26,166.38,262.48,96.43c.46-.27.83-.08.83.42a1.8,1.8,0,0,1-.83,1.38l-121.22,70c-.46.26-.84.07-.84-.42A1.78,1.78,0,0,1,141.26,166.38Z"
          style={{
            fill: "#213E60",
            transformOrigin: "201.865px 132.327px",
          }}
          id="eld7333l81ddi"
          className="animable"
        />
        <g id="el1lksqqtm8eb">
          <path
            d="M141.26,166.38,262.48,96.43c.46-.27.83-.08.83.42a1.8,1.8,0,0,1-.83,1.38l-121.22,70c-.46.26-.84.07-.84-.42A1.78,1.78,0,0,1,141.26,166.38Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "201.865px 132.327px",
            }}
            className="animable"
            id="elk16v7scaipb"
          />
        </g>
        <path
          d="M174.15,125.62l-32.86,19a1.77,1.77,0,0,0-.83,1.38c0,.5.37.69.83.42l32.86-19A1.8,1.8,0,0,0,175,126C175,125.54,174.61,125.35,174.15,125.62ZM263,74.4l-85.61,49.35a1.8,1.8,0,0,0-.83,1.38c0,.5.37.69.83.43L263,76.2a1.78,1.78,0,0,0,.83-1.38C263.81,74.32,263.44,74.13,263,74.4Z"
          style={{
            fill: "#213E60",
            transformOrigin: "202.145px 110.41px",
          }}
          id="eld82k3cvlvhb"
          className="animable"
        />
        <g id="elsvvabp9zyt">
          <path
            d="M174.15,125.62l-32.86,19a1.77,1.77,0,0,0-.83,1.38c0,.5.37.69.83.42l32.86-19A1.8,1.8,0,0,0,175,126C175,125.54,174.61,125.35,174.15,125.62ZM263,74.4l-85.61,49.35a1.8,1.8,0,0,0-.83,1.38c0,.5.37.69.83.43L263,76.2a1.78,1.78,0,0,0,.83-1.38C263.81,74.32,263.44,74.13,263,74.4Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "202.145px 110.41px",
            }}
            className="animable"
            id="elpuqm4vimk6h"
          />
        </g>
        <g id="eloxtpeimdl7k">
          <path
            d="M141.29,151.57,157.93,142a1.77,1.77,0,0,0,.83-1.38c0-.5-.37-.69-.83-.42l-16.64,9.62a1.77,1.77,0,0,0-.83,1.38C140.46,151.65,140.83,151.83,141.29,151.57Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "149.61px 145.884px",
            }}
            className="animable"
            id="elw7ktk71mph"
          />
        </g>
        <g id="el9xy09hm2ndn">
          <path
            d="M141.29,156.72l10-5.75a1.8,1.8,0,0,0,.83-1.39c0-.49-.37-.68-.83-.42l-10,5.75a1.8,1.8,0,0,0-.83,1.39C140.46,156.79,140.83,157,141.29,156.72Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "146.29px 152.944px",
            }}
            className="animable"
            id="el7fewke0i674"
          />
        </g>
        <g id="el2zylzjoa5ry">
          <path
            d="M161.15,140.09l19.44-11.31a1.8,1.8,0,0,0,.83-1.38c0-.5-.37-.69-.83-.42l-19.44,11.31a1.77,1.77,0,0,0-.83,1.38C160.32,140.17,160.69,140.36,161.15,140.09Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "170.87px 133.535px",
            }}
            className="animable"
            id="elhd3s9md6v7p"
          />
        </g>
        <g id="el5jimj4jsjvi">
          <path
            d="M170.41,138.09,154,147.64a1.77,1.77,0,0,0-.83,1.38c0,.5.37.69.83.42l16.46-9.55a1.79,1.79,0,0,0,.84-1.38C171.25,138,170.87,137.82,170.41,138.09Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "162.235px 143.764px",
            }}
            className="animable"
            id="el98jticfgk0q"
          />
        </g>
        <g id="eloaj2nczw7yb">
          <path
            d="M172.81,137.61c0,.49.37.68.83.42L262.49,87a1.77,1.77,0,0,0,.83-1.38c0-.5-.37-.68-.83-.42l-88.85,51.05A1.8,1.8,0,0,0,172.81,137.61Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "218.065px 111.614px",
            }}
            className="animable"
            id="elrdh9hwr5wo"
          />
        </g>
        <g id="elw5c1lg3dte">
          <path
            d="M170.41,143.61l-29.15,16.74a1.81,1.81,0,0,0-.84,1.38c0,.5.38.69.84.42l29.15-16.73a1.81,1.81,0,0,0,.84-1.38C171.25,143.54,170.87,143.35,170.41,143.61Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "155.835px 152.883px",
            }}
            className="animable"
            id="eleew11zbl49t"
          />
        </g>
        <g id="elzvd15w2mxk">
          <path
            d="M262.49,90.7l-88.85,51.05a1.8,1.8,0,0,0-.83,1.38c0,.5.37.69.83.42L262.49,92.5a1.77,1.77,0,0,0,.83-1.38C263.32,90.62,263,90.43,262.49,90.7Z"
            style={{
              fill: "rgb(224, 224, 224)",
              opacity: 0.6,
              transformOrigin: "218.065px 117.125px",
            }}
            className="animable"
            id="el5o9ypg8x5pe"
          />
        </g>
        <path
          d="M141.46,207.23l3.85-2.21c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38L141.46,209c-.46.27-.83.08-.83-.42A1.78,1.78,0,0,1,141.46,207.23Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 207.01px",
          }}
          id="elfvgk03yyp5g"
          className="animable"
        />
        <g id="el1fqmj7sektv">
          <path
            d="M141.46,207.23l3.85-2.21c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38L141.46,209c-.46.27-.83.08-.83-.42A1.78,1.78,0,0,1,141.46,207.23Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 207.01px",
            }}
            className="animable"
            id="el1j4fmmyrgrw"
          />
        </g>
        <path
          d="M141.46,179l3.85-2.21c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.8,1.8,0,0,1,141.46,179Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 178.795px",
          }}
          id="elfxx44gmd00g"
          className="animable"
        />
        <g id="elcw8vttjt7tv">
          <path
            d="M141.46,179l3.85-2.21c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.8,1.8,0,0,1,141.46,179Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 178.795px",
            }}
            className="animable"
            id="elshvyy8lq21s"
          />
        </g>
        <path
          d="M141.46,190.14l3.85-2.22c.46-.26.84-.07.84.42a1.81,1.81,0,0,1-.84,1.39l-3.85,2.21c-.46.26-.83.07-.83-.42A1.77,1.77,0,0,1,141.46,190.14Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 189.93px",
          }}
          id="elpuhjuca6avn"
          className="animable"
        />
        <g id="elrh9b9ijpu1">
          <path
            d="M141.46,190.14l3.85-2.22c.46-.26.84-.07.84.42a1.81,1.81,0,0,1-.84,1.39l-3.85,2.21c-.46.26-.83.07-.83-.42A1.77,1.77,0,0,1,141.46,190.14Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 189.93px",
            }}
            className="animable"
            id="elc1idzptxn5q"
          />
        </g>
        <path
          d="M141.46,195.29l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,141.46,195.29Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 195.089px",
          }}
          id="elhpr00vx4546"
          className="animable"
        />
        <g id="elnyfwo6xxk2">
          <path
            d="M141.46,195.29l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,141.46,195.29Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 195.089px",
            }}
            className="animable"
            id="elq4x97e4bwr"
          />
        </g>
        <path
          d="M141.46,200.45l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,141.46,200.45Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 200.249px",
          }}
          id="el77jsdbgchid"
          className="animable"
        />
        <g id="elspdve8akk1">
          <path
            d="M141.46,200.45l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,141.46,200.45Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 200.249px",
            }}
            className="animable"
            id="elj3l55eexm1c"
          />
        </g>
        <path
          d="M141.46,211.89l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,141.46,211.89Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 211.689px",
          }}
          id="el7wfrbr2bpmu"
          className="animable"
        />
        <g id="el5k8so1u5trq">
          <path
            d="M141.46,211.89l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,141.46,211.89Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 211.689px",
            }}
            className="animable"
            id="ellqn1qhvzxej"
          />
        </g>
        <path
          d="M141.46,245.67l3.85-2.22c.46-.26.84-.07.84.43a1.81,1.81,0,0,1-.84,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,141.46,245.67Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 245.463px",
          }}
          id="els8umj06mwrm"
          className="animable"
        />
        <g id="el7o2yxegzmki">
          <path
            d="M141.46,245.67l3.85-2.22c.46-.26.84-.07.84.43a1.81,1.81,0,0,1-.84,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,141.46,245.67Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 245.463px",
            }}
            className="animable"
            id="el6ctlbaa83fh"
          />
        </g>
        <path
          d="M141.46,250.33l3.85-2.21c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.8,1.8,0,0,1,141.46,250.33Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 250.125px",
          }}
          id="elkpo51wsvv3d"
          className="animable"
        />
        <g id="elxylnz70z93">
          <path
            d="M141.46,250.33l3.85-2.21c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.8,1.8,0,0,1,141.46,250.33Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 250.125px",
            }}
            className="animable"
            id="el6jk2fv3miyk"
          />
        </g>
        <path
          d="M141.46,223l3.85-2.21c.46-.27.84-.08.84.42a1.81,1.81,0,0,1-.84,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,141.46,223Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 222.795px",
          }}
          id="elhu57293m4xn"
          className="animable"
        />
        <g id="els8m4gxg4mj8">
          <path
            d="M141.46,223l3.85-2.21c.46-.27.84-.08.84.42a1.81,1.81,0,0,1-.84,1.38l-3.85,2.21c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,141.46,223Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 222.795px",
            }}
            className="animable"
            id="el5gn5guk5kr8"
          />
        </g>
        <path
          d="M141.46,228.15l3.85-2.22c.46-.26.84-.07.84.43a1.81,1.81,0,0,1-.84,1.38L141.46,230c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,141.46,228.15Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 227.968px",
          }}
          id="elzcsmjhkdlbg"
          className="animable"
        />
        <g id="el2nxd8tlbvvz">
          <path
            d="M141.46,228.15l3.85-2.22c.46-.26.84-.07.84.43a1.81,1.81,0,0,1-.84,1.38L141.46,230c-.46.27-.83.08-.83-.42A1.77,1.77,0,0,1,141.46,228.15Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 227.968px",
            }}
            className="animable"
            id="el9kbsru6ma1j"
          />
        </g>
        <path
          d="M141.46,233.31l3.85-2.22c.46-.26.84-.07.84.42a1.81,1.81,0,0,1-.84,1.39l-3.85,2.21c-.46.26-.83.08-.83-.42A1.77,1.77,0,0,1,141.46,233.31Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 233.101px",
          }}
          id="eljq2l7mku2yg"
          className="animable"
        />
        <g id="el48me6xfbr7i">
          <path
            d="M141.46,233.31l3.85-2.22c.46-.26.84-.07.84.42a1.81,1.81,0,0,1-.84,1.39l-3.85,2.21c-.46.26-.83.08-.83-.42A1.77,1.77,0,0,1,141.46,233.31Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 233.101px",
            }}
            className="animable"
            id="elysfa7z18yg"
          />
        </g>
        <path
          d="M141.46,273.41l3.85-2.22c.46-.26.84-.07.84.42a1.81,1.81,0,0,1-.84,1.39l-3.85,2.21c-.46.26-.83.08-.83-.42A1.77,1.77,0,0,1,141.46,273.41Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 273.201px",
          }}
          id="eldagx5io4icw"
          className="animable"
        />
        <g id="elyy67g7ghhj">
          <path
            d="M141.46,273.41l3.85-2.22c.46-.26.84-.07.84.42a1.81,1.81,0,0,1-.84,1.39l-3.85,2.21c-.46.26-.83.08-.83-.42A1.77,1.77,0,0,1,141.46,273.41Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 273.201px",
            }}
            className="animable"
            id="el09s5frqmnupi"
          />
        </g>
        <path
          d="M141.46,278.56l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,141.46,278.56Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 278.359px",
          }}
          id="elooo77djeok"
          className="animable"
        />
        <g id="elelhvyzgyuj8">
          <path
            d="M141.46,278.56l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,141.46,278.56Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 278.359px",
            }}
            className="animable"
            id="eligie0y5o1lk"
          />
        </g>
        <path
          d="M141.46,263.18l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38L141.46,265c-.46.26-.83.07-.83-.43A1.8,1.8,0,0,1,141.46,263.18Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 262.984px",
          }}
          id="el5bmv3qxwvfq"
          className="animable"
        />
        <g id="eluspsk8b1tsr">
          <path
            d="M141.46,263.18l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38L141.46,265c-.46.26-.83.07-.83-.43A1.8,1.8,0,0,1,141.46,263.18Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 262.984px",
            }}
            className="animable"
            id="el0y4ysxhg15gp"
          />
        </g>
        <path
          d="M141.46,268.34l3.85-2.21c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.43A1.8,1.8,0,0,1,141.46,268.34Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 268.137px",
          }}
          id="el3studwsofmm"
          className="animable"
        />
        <g id="elp65k8p3to9t">
          <path
            d="M141.46,268.34l3.85-2.21c.46-.27.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.43A1.8,1.8,0,0,1,141.46,268.34Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 268.137px",
            }}
            className="animable"
            id="el4a8uzjrdgvs"
          />
        </g>
        <path
          d="M150,181.82l113-65.35a1.78,1.78,0,0,0,.84-1.38c0-.5-.38-.69-.84-.42L150,180a1.8,1.8,0,0,0-.83,1.39C149.12,181.89,149.49,182.08,150,181.82Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.503px 148.242px",
          }}
          id="elw2vtdxv6yeo"
          className="animable"
        />
        <path
          d="M150,176.67,263,111.3a1.78,1.78,0,0,0,.83-1.38c0-.5-.37-.69-.83-.42L150,174.87a1.77,1.77,0,0,0-.83,1.38C149.12,176.75,149.49,176.94,150,176.67Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.498px 143.085px",
          }}
          id="elqauyfrf0vc9"
          className="animable"
        />
        <path
          d="M263,120,150,185.23a1.77,1.77,0,0,0-.83,1.38c0,.5.37.69.83.42l113-65.22a1.78,1.78,0,0,0,.84-1.38C263.82,119.93,263.44,119.74,263,120Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.505px 153.518px",
          }}
          id="elrv9etcl2kx"
          className="animable"
        />
        <path
          d="M263,125.17,150,190.39a1.77,1.77,0,0,0-.83,1.38c0,.5.37.68.83.42L263,127a1.79,1.79,0,0,0,.84-1.38C263.82,125.09,263.44,124.9,263,125.17Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.505px 158.678px",
          }}
          id="elppbebjt9sn"
          className="animable"
        />
        <path
          d="M263,130.33,150,195.55a1.77,1.77,0,0,0-.83,1.38c0,.5.37.68.83.42l113-65.22a1.79,1.79,0,0,0,.84-1.38C263.82,130.25,263.44,130.06,263,130.33Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.505px 163.838px",
          }}
          id="elnuzv6sygrsi"
          className="animable"
        />
        <path
          d="M150,204.2,263,139a1.78,1.78,0,0,0,.83-1.38c0-.5-.37-.69-.83-.42l-113,65.2a1.8,1.8,0,0,0-.83,1.39C149.12,204.27,149.49,204.46,150,204.2Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.498px 170.697px",
          }}
          id="elzfbnyetig79"
          className="animable"
        />
        <path
          d="M150,208.89l113-65.37a1.77,1.77,0,0,0,.83-1.38c0-.5-.37-.69-.83-.42L150,207.09a1.8,1.8,0,0,0-.83,1.38C149.12,209,149.49,209.16,150,208.89Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.498px 175.308px",
          }}
          id="ely4hon9jlft"
          className="animable"
        />
        <path
          d="M150.37,242.38l23.78-13.72a1.8,1.8,0,0,0,.83-1.38c0-.5-.37-.69-.83-.42l-23.78,13.71a1.8,1.8,0,0,0-.83,1.39C149.54,242.45,149.91,242.64,150.37,242.38Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "162.26px 234.617px",
          }}
          id="el7v881vfd73l"
          className="animable"
        />
        <path
          d="M150.34,246.84,262.62,182a1.78,1.78,0,0,0,.84-1.38c0-.5-.38-.69-.84-.42L150.34,245a1.77,1.77,0,0,0-.83,1.38C149.51,246.92,149.88,247.11,150.34,246.84Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.485px 213.519px",
          }}
          id="elrco54krsqhk"
          className="animable"
        />
        <path
          d="M263,153,150.1,218.07a1.77,1.77,0,0,0-.83,1.38c0,.5.37.68.83.42L263,154.78a1.78,1.78,0,0,0,.84-1.38C263.82,152.9,263.44,152.72,263,153Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.555px 186.428px",
          }}
          id="elp6lj96w47"
          className="animable"
        />
        <path
          d="M263,158.08,150.1,223.16a1.8,1.8,0,0,0-.83,1.38c0,.5.37.69.83.42L263,159.88a1.79,1.79,0,0,0,.84-1.38C263.82,158,263.44,157.81,263,158.08Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.555px 191.52px",
          }}
          id="elagtsnzvluj6"
          className="animable"
        />
        <path
          d="M263,163.26,150.1,228.34a1.8,1.8,0,0,0-.83,1.38c0,.5.37.69.83.43L263,165.06a1.78,1.78,0,0,0,.84-1.38C263.82,163.18,263.44,163,263,163.26Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.555px 196.704px",
          }}
          id="elb64m577sopg"
          className="animable"
        />
        <path
          d="M263,203.4,150.1,268.48a1.8,1.8,0,0,0-.83,1.39c0,.49.37.68.83.42L263,205.2a1.78,1.78,0,0,0,.84-1.38C263.82,203.32,263.44,203.13,263,203.4Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.555px 236.842px",
          }}
          id="el7wdfbnmpad3"
          className="animable"
        />
        <path
          d="M263,208.49,150.1,273.58a1.77,1.77,0,0,0-.83,1.38c0,.5.37.69.83.42L263,210.3a1.81,1.81,0,0,0,.84-1.38C263.82,208.42,263.44,208.23,263,208.49Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.555px 241.938px",
          }}
          id="el65x1nmavjm7"
          className="animable"
        />
        <path
          d="M263,193.18,150.1,258.26a1.78,1.78,0,0,0-.83,1.38c0,.5.37.69.83.42L263,195a1.79,1.79,0,0,0,.84-1.38C263.82,193.1,263.44,192.91,263,193.18Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.555px 226.62px",
          }}
          id="el3bazsn0cxd"
          className="animable"
        />
        <path
          d="M263,198.27,150.1,263.36a1.77,1.77,0,0,0-.83,1.38c0,.5.37.69.83.42L263,200.08a1.81,1.81,0,0,0,.84-1.39C263.82,198.2,263.44,198,263,198.27Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.555px 231.716px",
          }}
          id="el9pb9amezvig"
          className="animable"
        />
        <path
          d="M263,213.68,150.1,278.76a1.78,1.78,0,0,0-.83,1.38c0,.5.37.69.83.42L263,215.48a1.81,1.81,0,0,0,.84-1.38C263.82,213.6,263.44,213.41,263,213.68Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "206.555px 247.12px",
          }}
          id="elfw58qz4l6mk"
          className="animable"
        />
        <path
          d="M141.46,283.72l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,141.46,283.72Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.39px 283.519px",
          }}
          id="elltucmjctqp"
          className="animable"
        />
        <g id="eld276lpkk0fs">
          <path
            d="M141.46,283.72l3.85-2.21c.46-.26.84-.08.84.42a1.78,1.78,0,0,1-.84,1.38l-3.85,2.22c-.46.26-.83.07-.83-.42A1.8,1.8,0,0,1,141.46,283.72Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.6,
              transformOrigin: "143.39px 283.519px",
            }}
            className="animable"
            id="el5lgh4iscnf"
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--gears-3--inject-835"
      className="animable"
      style={{
        transformOrigin: "424.797px 187.018px",
      }}
    >
      <g
        id="freepik--Gears--inject-835"
        className="animable"
        style={{
          transformOrigin: "424.797px 187.018px",
        }}
      >
        <path
          d="M385.45,250l-1.92-1.11a2.43,2.43,0,0,1-1.09-1.9V164.34a2.44,2.44,0,0,1,1.1-1.9L450.06,124a2.44,2.44,0,0,1,2.2,0l1.92,1.11a2.42,2.42,0,0,1,1.1,1.9v82.69a2.42,2.42,0,0,1-1.1,1.9L387.65,250A2.44,2.44,0,0,1,385.45,250Z"
          style={{
            fill: "#213E60",
            transformOrigin: "418.86px 187px",
          }}
          id="el31n4djj93x2"
          className="animable"
        />
        <g id="el1enxwstcf6m">
          <path
            d="M385.45,250l-1.92-1.11a2.43,2.43,0,0,1-1.09-1.9V164.34a2.44,2.44,0,0,1,1.1-1.9L450.06,124a2.44,2.44,0,0,1,2.2,0l1.92,1.11a2.42,2.42,0,0,1,1.1,1.9v82.69a2.42,2.42,0,0,1-1.1,1.9L387.65,250A2.44,2.44,0,0,1,385.45,250Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.8,
              transformOrigin: "418.86px 187px",
            }}
            className="animable"
            id="elidturdz67pm"
          />
        </g>
        <g id="eljgmln7eqizk">
          <path
            d="M455.26,126.86c-.07-.56-.53-.77-1.08-.45l-66.53,38.4a2.37,2.37,0,0,0-.78.82l-4.11-2.37a2.18,2.18,0,0,1,.77-.82L450.06,124a2.44,2.44,0,0,1,2.2,0l1.92,1.11A2.45,2.45,0,0,1,455.26,126.86Z"
            style={{
              fill: "#213E60",
              opacity: 0.3,
              transformOrigin: "419.01px 144.684px",
            }}
            className="animable"
            id="el251hcgsa8bq"
          />
        </g>
        <g id="elztvykbobs5">
          <path
            d="M387.39,250.15a2.42,2.42,0,0,1-1.94-.12l-1.92-1.11a2.42,2.42,0,0,1-1.1-1.9V164.34a2.22,2.22,0,0,1,.33-1.08l4.11,2.37a2.24,2.24,0,0,0-.32,1.08V249.4C386.55,250,386.91,250.29,387.39,250.15Z"
            style={{
              fill: "#213E60",
              opacity: 0.5,
              transformOrigin: "384.91px 206.779px",
            }}
            className="animable"
            id="elz189v74w4f"
          />
        </g>
        <g id="elrqfx6ugg6j">
          <g
            style={{
              opacity: 0.3,
              transformOrigin: "420.902px 188.22px",
            }}
            className="animable"
            id="el618dia2wsk"
          >
            <path
              d="M454.67,126.76s.07,0,.09.15l0,.08v82.74a1.93,1.93,0,0,1-.85,1.46l-66.51,38.4-.16.08h-.1c-.1,0-.1-.22-.1-.28V166.72a1.93,1.93,0,0,1,.23-.83,1.8,1.8,0,0,1,.61-.64l66.52-38.41a.57.57,0,0,1,.25-.08m0-.5a1,1,0,0,0-.49.15l-66.53,38.41a2.37,2.37,0,0,0-1.09,1.9V249.4c0,.5.24.78.6.78l.24,0,.25-.11,66.53-38.41a2.42,2.42,0,0,0,1.1-1.9V127.05a1.09,1.09,0,0,0,0-.18.06.06,0,0,0,0,0,.6.6,0,0,0-.59-.57Z"
              style={{
                fill: "#213E60",
                transformOrigin: "420.902px 188.22px",
              }}
              id="el2mw3qksmi4r"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M463.72,177.66a.45.45,0,0,0-.48.05l-1,.67L462,179a1.12,1.12,0,0,0,.27,1.11c.16.18.31.36.46.56a.67.67,0,0,0,.93.22l2.35-1.54a.42.42,0,0,1,.46,0h0Zm-.78-2.65h0l-2.78-1.6-.18-.07-1.77-.39a1,1,0,0,0-1,.46l-1.66,3.17a1.63,1.63,0,0,1-.66.61l.52,1.72a.6.6,0,0,0,.84.38,7.72,7.72,0,0,1,1.09-.36,1.7,1.7,0,0,0,1-.75L460,175a.93.93,0,0,1,1-.45l1.77.39ZM457,183.54a4.87,4.87,0,0,1,.33,1.11c.51,3-1.39,7.29-4.25,9.53a5.85,5.85,0,0,1-3,1.35c.93,2,3.31,2.21,5.79.26,2.87-2.26,4.77-6.52,4.25-9.53C459.8,184.36,458.58,183.41,457,183.54Zm-1.74,20.54h0l-.07,0Zm-.83-2.3a.61.61,0,0,0-.84-.38,8.17,8.17,0,0,1-1.09.36,1.22,1.22,0,0,0-.34.14l.08.25a.45.45,0,0,0,.23.31L455.2,204a.6.6,0,0,1-.17-.27Zm-3.35-19.38-.16-2.52a1.47,1.47,0,0,1,.5-1.12l2.65-2.08a.45.45,0,0,1,.53-.06h0L451.82,175a.41.41,0,0,0-.19,0,.52.52,0,0,0-.33.12l-2.65,2.08a1.54,1.54,0,0,0-.51,1.11l.17,2.53a2,2,0,0,1-.41,1.21,20,20,0,0,0-1.24,1.63,1.34,1.34,0,0,1-1.07.55l-1.7-.09a1.07,1.07,0,0,0-1,.6l-1.6,3.58a.67.67,0,0,0,.26.86h0l1.9,1.09a.87.87,0,0,1,0,.48,15.28,15.28,0,0,0-.29,1.71,2.2,2.2,0,0,1-.57,1.16l-2.35,2.16a1.42,1.42,0,0,0-.39,1.15l.44,2.56a.49.49,0,0,0,.21.34l2.8,1.62h0a.41.41,0,0,1-.22-.35l-.44-2.55a1.42,1.42,0,0,1,.39-1.16l2.34-2.15A2.21,2.21,0,0,0,446,194a14.54,14.54,0,0,1,.29-1.71.85.85,0,0,0-.48-1l-1.37-.59a.67.67,0,0,1-.35-.9l1.6-3.58a1.1,1.1,0,0,1,1-.61l1.7.09a1.41,1.41,0,0,0,1.08-.54c.39-.57.8-1.11,1.23-1.63A2.06,2.06,0,0,0,451.09,182.4Zm-4,17.63a.68.68,0,0,0-.94-.21l-1.32.88-1,2.63a.59.59,0,0,0,.23.72l2.77,1.59a.57.57,0,0,1-.21-.7l1.18-3.23a1.14,1.14,0,0,0-.27-1.11A5.2,5.2,0,0,1,447.11,200Z"
          style={{
            fill: "#213E60",
            transformOrigin: "453.155px 189.289px",
          }}
          id="elphfpx4t0fjc"
          className="animable"
        />
        <g id="elpolobwe5iph">
          <g
            style={{
              opacity: 0.2,
              transformOrigin: "453.155px 189.289px",
            }}
            className="animable"
            id="el845o8krco88"
          >
            <path
              d="M463.72,177.66a.45.45,0,0,0-.48.05l-1,.67L462,179a1.12,1.12,0,0,0,.27,1.11c.16.18.31.36.46.56a.67.67,0,0,0,.93.22l2.35-1.54a.42.42,0,0,1,.46,0h0Zm-.78-2.65h0l-2.78-1.6-.18-.07-1.77-.39a1,1,0,0,0-1,.46l-1.66,3.17a1.63,1.63,0,0,1-.66.61l.52,1.72a.6.6,0,0,0,.84.38,7.72,7.72,0,0,1,1.09-.36,1.7,1.7,0,0,0,1-.75L460,175a.93.93,0,0,1,1-.45l1.77.39ZM457,183.54a4.87,4.87,0,0,1,.33,1.11c.51,3-1.39,7.29-4.25,9.53a5.85,5.85,0,0,1-3,1.35c.93,2,3.31,2.21,5.79.26,2.87-2.26,4.77-6.52,4.25-9.53C459.8,184.36,458.58,183.41,457,183.54Zm-1.74,20.54h0l-.07,0Zm-.83-2.3a.61.61,0,0,0-.84-.38,8.17,8.17,0,0,1-1.09.36,1.22,1.22,0,0,0-.34.14l.08.25a.45.45,0,0,0,.23.31L455.2,204a.6.6,0,0,1-.17-.27Zm-3.35-19.38-.16-2.52a1.47,1.47,0,0,1,.5-1.12l2.65-2.08a.45.45,0,0,1,.53-.06h0L451.82,175a.41.41,0,0,0-.19,0,.52.52,0,0,0-.33.12l-2.65,2.08a1.54,1.54,0,0,0-.51,1.11l.17,2.53a2,2,0,0,1-.41,1.21,20,20,0,0,0-1.24,1.63,1.34,1.34,0,0,1-1.07.55l-1.7-.09a1.07,1.07,0,0,0-1,.6l-1.6,3.58a.67.67,0,0,0,.26.86h0l1.9,1.09a.87.87,0,0,1,0,.48,15.28,15.28,0,0,0-.29,1.71,2.2,2.2,0,0,1-.57,1.16l-2.35,2.16a1.42,1.42,0,0,0-.39,1.15l.44,2.56a.49.49,0,0,0,.21.34l2.8,1.62h0a.41.41,0,0,1-.22-.35l-.44-2.55a1.42,1.42,0,0,1,.39-1.16l2.34-2.15A2.21,2.21,0,0,0,446,194a14.54,14.54,0,0,1,.29-1.71.85.85,0,0,0-.48-1l-1.37-.59a.67.67,0,0,1-.35-.9l1.6-3.58a1.1,1.1,0,0,1,1-.61l1.7.09a1.41,1.41,0,0,0,1.08-.54c.39-.57.8-1.11,1.23-1.63A2.06,2.06,0,0,0,451.09,182.4Zm-4,17.63a.68.68,0,0,0-.94-.21l-1.32.88-1,2.63a.59.59,0,0,0,.23.72l2.77,1.59a.57.57,0,0,1-.21-.7l1.18-3.23a1.14,1.14,0,0,0-.27-1.11A5.2,5.2,0,0,1,447.11,200Z"
              id="elutuv2umr30g"
              className="animable"
              style={{
                transformOrigin: "453.155px 189.289px",
              }}
            />
          </g>
        </g>
        <path
          d="M445.59,184.19l-1.7-.09a1.12,1.12,0,0,0-.71.25L446,186a1.13,1.13,0,0,1,.7-.26l1.7.09a1.15,1.15,0,0,0,.5-.1l-2.79-1.61A1.28,1.28,0,0,1,445.59,184.19Zm5.71-9.11-2.65,2.08a1.43,1.43,0,0,0-.43.69l2.78,1.6a1.43,1.43,0,0,1,.43-.69l2.65-2.08a.45.45,0,0,1,.53-.06h0L451.82,175A.47.47,0,0,0,451.3,175.08Zm-11,20.67a1.32,1.32,0,0,0-.35.66l2.78,1.61a1.41,1.41,0,0,1,.36-.67l2.31-2.12-2.77-1.61Zm23.42-18.09a.43.43,0,0,0-.48.05l-1,.67L462,179a1,1,0,0,0,0,.74,1.23,1.23,0,0,0,.19.32l0,0,0,0,.13.14c.12.13.23.28.34.42a.65.65,0,0,0,.41.3.57.57,0,0,0,.26,0,.14.14,0,0,0,.09,0,.65.65,0,0,0,.17-.08l2.35-1.54a.51.51,0,0,1,.29-.1l.14,0,0,0Zm-.78-2.65h0l-2.78-1.6-.18-.07-1.77-.39a1,1,0,0,0-1,.46l-1.66,3.17a1.46,1.46,0,0,1-.38.42l2.79,1.6a1.22,1.22,0,0,0,.37-.42L460,175a.93.93,0,0,1,1-.45l1.77.39Z"
          style={{
            fill: "#213E60",
            transformOrigin: "453.16px 185.479px",
          }}
          id="elfhvbggjpzwo"
          className="animable"
        />
        <g id="elx80yxpgz6mc">
          <path
            d="M445.59,184.19l-1.7-.09a1.12,1.12,0,0,0-.71.25L446,186a1.13,1.13,0,0,1,.7-.26l1.7.09a1.15,1.15,0,0,0,.5-.1l-2.79-1.61A1.28,1.28,0,0,1,445.59,184.19Zm5.71-9.11-2.65,2.08a1.43,1.43,0,0,0-.43.69l2.78,1.6a1.43,1.43,0,0,1,.43-.69l2.65-2.08a.45.45,0,0,1,.53-.06h0L451.82,175A.47.47,0,0,0,451.3,175.08Zm-11,20.67a1.32,1.32,0,0,0-.35.66l2.78,1.61a1.41,1.41,0,0,1,.36-.67l2.31-2.12-2.77-1.61Zm23.42-18.09a.43.43,0,0,0-.48.05l-1,.67L462,179a1,1,0,0,0,0,.74,1.23,1.23,0,0,0,.19.32l0,0,0,0,.13.14c.12.13.23.28.34.42a.65.65,0,0,0,.41.3.57.57,0,0,0,.26,0,.14.14,0,0,0,.09,0,.65.65,0,0,0,.17-.08l2.35-1.54a.51.51,0,0,1,.29-.1l.14,0,0,0Zm-.78-2.65h0l-2.78-1.6-.18-.07-1.77-.39a1,1,0,0,0-1,.46l-1.66,3.17a1.46,1.46,0,0,1-.38.42l2.79,1.6a1.22,1.22,0,0,0,.37-.42L460,175a.93.93,0,0,1,1-.45l1.77.39Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.2,
              transformOrigin: "453.16px 185.479px",
            }}
            className="animable"
            id="eluvmk946vje"
          />
        </g>
        <path
          d="M467.16,182.17l-.44-2.55a.42.42,0,0,0-.7-.3l-2.34,1.54a.68.68,0,0,1-.94-.22,4.89,4.89,0,0,0-.45-.55A1.17,1.17,0,0,1,462,179l1.2-3.23a.59.59,0,0,0-.44-.8l-1.77-.4a1,1,0,0,0-1,.47l-1.65,3.16a1.74,1.74,0,0,1-1,.75,8,8,0,0,0-1.08.36.6.6,0,0,1-.84-.38l-.6-2a.44.44,0,0,0-.74-.24l-2.65,2.08a1.51,1.51,0,0,0-.5,1.13l.16,2.51a2.08,2.08,0,0,1-.41,1.22,19.17,19.17,0,0,0-1.23,1.62,1.36,1.36,0,0,1-1.08.55l-1.7-.08a1.08,1.08,0,0,0-1,.6l-1.6,3.58a.68.68,0,0,0,.36.91l1.37.58a.86.86,0,0,1,.47,1A14.9,14.9,0,0,0,446,194a2.21,2.21,0,0,1-.58,1.16l-2.34,2.15a1.42,1.42,0,0,0-.39,1.16l.44,2.55a.41.41,0,0,0,.69.3l2.35-1.54a.68.68,0,0,1,.94.22,6.12,6.12,0,0,0,.45.56,1.14,1.14,0,0,1,.28,1.11l-1.2,3.23a.59.59,0,0,0,.44.8l1.76.4a1,1,0,0,0,1-.47l1.66-3.16a1.71,1.71,0,0,1,1-.75,8.54,8.54,0,0,0,1.08-.36.6.6,0,0,1,.84.38l.59,2a.45.45,0,0,0,.75.24l2.64-2.08a1.48,1.48,0,0,0,.51-1.12l-.16-2.52a2,2,0,0,1,.41-1.22q.65-.78,1.23-1.62a1.34,1.34,0,0,1,1.07-.55l1.7.08a1.09,1.09,0,0,0,1-.6l1.6-3.58a.68.68,0,0,0-.36-.91L464,189.3a.85.85,0,0,1-.47-1,14.9,14.9,0,0,0,.29-1.71,2.14,2.14,0,0,1,.58-1.16l2.34-2.15A1.42,1.42,0,0,0,467.16,182.17Zm-11.29,13.62c-2.87,2.25-5.61,1.64-6.13-1.37s1.38-7.28,4.25-9.53,5.61-1.64,6.13,1.37S458.73,193.54,455.87,195.79Z"
          style={{
            fill: "#213E60",
            transformOrigin: "454.922px 190.335px",
          }}
          id="elz9shzg8t188"
          className="animable"
        />
        <path
          d="M413,171.7a2.26,2.26,0,0,0,.63-1.27l.61-6.77a1.63,1.63,0,0,1,.73-1.14L421,159a.52.52,0,0,1,.46-.06l-3-1.71a.46.46,0,0,0-.2-.05.57.57,0,0,0-.29.09l-6.09,3.52a1.62,1.62,0,0,0-.72,1.13l-.61,6.78A2.25,2.25,0,0,1,410,170a38.44,38.44,0,0,0-3.38,3.58,1.15,1.15,0,0,1-1.2.34l-3.9-1.36a1,1,0,0,0-1.1.41l-4.48,7.75a1,1,0,0,0,.2,1.15l3.13,2.7a1.19,1.19,0,0,1,.31,1.21,36.74,36.74,0,0,0-1.41,4.72,2.26,2.26,0,0,1-.78,1.18l-5.56,3.92a1.6,1.6,0,0,0-.62,1.19v7a.51.51,0,0,0,.21.46l3,1.73a.52.52,0,0,1-.22-.46v-7a1.65,1.65,0,0,1,.62-1.2l5.56-3.91a2.21,2.21,0,0,0,.78-1.18,37.9,37.9,0,0,1,1.41-4.72,1.16,1.16,0,0,0-.3-1.21l-3.14-2.7a.94.94,0,0,1-.19-1.15l4.47-7.76a1,1,0,0,1,1.1-.41l3.91,1.37a1.16,1.16,0,0,0,1.19-.34A36.11,36.11,0,0,1,413,171.7Zm-11.78,32.24a.64.64,0,0,0-.91-.41l-1.31.59c.14.27.28.54.43.78a1.5,1.5,0,0,1,.08,1.32l-3.61,7.28a.82.82,0,0,0,.32,1.06l3,1.73a.83.83,0,0,1-.32-1.06l3.62-7.29a1.51,1.51,0,0,0-.09-1.31A12,12,0,0,1,401.18,203.94Zm13,13.19-.59-5.91a.64.64,0,0,0-.81-.57,12.47,12.47,0,0,1-2,.28l.45,4.48a.51.51,0,0,0,.23.41l3,1.73A.5.5,0,0,1,414.19,217.13Zm24.38-48.32h0a.49.49,0,0,0-.47,0l-4.1,1.85a12.57,12.57,0,0,1,.78,1.9.64.64,0,0,0,.9.42l5.42-2.44a.48.48,0,0,1,.48,0v0Zm-9.8-12.32-4.5,6.77a1.5,1.5,0,0,1-1.18.59,8.84,8.84,0,0,0-.89,0l.14,1.44a.65.65,0,0,0,.82.57,12.63,12.63,0,0,1,2.93-.3,1.48,1.48,0,0,0,1.18-.58l4.5-6.77a.82.82,0,0,1,1.08-.25l-3-1.73A.82.82,0,0,0,428.77,156.49Zm-4.84,18.65a9.37,9.37,0,0,1,1.33,5.45c0,6.56-4.6,14.54-10.28,17.82-2.22,1.28-4.11,1.71-5.59,1.35,1.84,2.15,5,2.45,8.58.38,5.68-3.28,10.29-11.26,10.29-17.82C428.26,178.33,426.55,175.78,423.93,175.14Z"
          style={{
            fill: "#213E60",
            transformOrigin: "416.409px 186.832px",
          }}
          id="el9h2qfdy5mdq"
          className="animable"
        />
        <g id="elvp1f5qf9cwh">
          <path
            d="M413,171.7a2.26,2.26,0,0,0,.63-1.27l.61-6.77a1.63,1.63,0,0,1,.73-1.14L421,159a.52.52,0,0,1,.46-.06l-3-1.71a.46.46,0,0,0-.2-.05.57.57,0,0,0-.29.09l-6.09,3.52a1.62,1.62,0,0,0-.72,1.13l-.61,6.78A2.25,2.25,0,0,1,410,170a38.44,38.44,0,0,0-3.38,3.58,1.15,1.15,0,0,1-1.2.34l-3.9-1.36a1,1,0,0,0-1.1.41l-4.48,7.75a1,1,0,0,0,.2,1.15l3.13,2.7a1.19,1.19,0,0,1,.31,1.21,36.74,36.74,0,0,0-1.41,4.72,2.26,2.26,0,0,1-.78,1.18l-5.56,3.92a1.6,1.6,0,0,0-.62,1.19v7a.51.51,0,0,0,.21.46l3,1.73a.52.52,0,0,1-.22-.46v-7a1.65,1.65,0,0,1,.62-1.2l5.56-3.91a2.21,2.21,0,0,0,.78-1.18,37.9,37.9,0,0,1,1.41-4.72,1.16,1.16,0,0,0-.3-1.21l-3.14-2.7a.94.94,0,0,1-.19-1.15l4.47-7.76a1,1,0,0,1,1.1-.41l3.91,1.37a1.16,1.16,0,0,0,1.19-.34A36.11,36.11,0,0,1,413,171.7Zm-11.78,32.24a.64.64,0,0,0-.91-.41l-1.31.59c.14.27.28.54.43.78a1.5,1.5,0,0,1,.08,1.32l-3.61,7.28a.82.82,0,0,0,.32,1.06l3,1.73a.83.83,0,0,1-.32-1.06l3.62-7.29a1.51,1.51,0,0,0-.09-1.31A12,12,0,0,1,401.18,203.94Zm13,13.19-.59-5.91a.64.64,0,0,0-.81-.57,12.47,12.47,0,0,1-2,.28l.45,4.48a.51.51,0,0,0,.23.41l3,1.73A.5.5,0,0,1,414.19,217.13Zm24.38-48.32h0a.49.49,0,0,0-.47,0l-4.1,1.85a12.57,12.57,0,0,1,.78,1.9.64.64,0,0,0,.9.42l5.42-2.44a.48.48,0,0,1,.48,0v0Zm-9.8-12.32-4.5,6.77a1.5,1.5,0,0,1-1.18.59,8.84,8.84,0,0,0-.89,0l.14,1.44a.65.65,0,0,0,.82.57,12.63,12.63,0,0,1,2.93-.3,1.48,1.48,0,0,0,1.18-.58l4.5-6.77a.82.82,0,0,1,1.08-.25l-3-1.73A.82.82,0,0,0,428.77,156.49Zm-4.84,18.65a9.37,9.37,0,0,1,1.33,5.45c0,6.56-4.6,14.54-10.28,17.82-2.22,1.28-4.11,1.71-5.59,1.35,1.84,2.15,5,2.45,8.58.38,5.68-3.28,10.29-11.26,10.29-17.82C428.26,178.33,426.55,175.78,423.93,175.14Z"
            style={{
              opacity: 0.2,
              transformOrigin: "416.409px 186.832px",
            }}
            className="animable"
            id="elp14fnv3pkus"
          />
        </g>
        <path
          d="M441.79,178v-7a.46.46,0,0,0-.7-.45L435.67,173a.65.65,0,0,1-.9-.42,12.18,12.18,0,0,0-1.21-2.68,1.5,1.5,0,0,1-.08-1.32l3.61-7.28a.82.82,0,0,0-.32-1.06L432.85,158a.83.83,0,0,0-1.08.26l-4.5,6.77a1.49,1.49,0,0,1-1.18.58,12.63,12.63,0,0,0-2.93.3.64.64,0,0,1-.81-.57l-.6-5.92A.45.45,0,0,0,421,159l-6.09,3.51a1.67,1.67,0,0,0-.73,1.14l-.61,6.77a2.23,2.23,0,0,1-.63,1.27,36,36,0,0,0-3.38,3.58,1.17,1.17,0,0,1-1.2.34l-3.91-1.37a1,1,0,0,0-1.09.41l-4.48,7.75a1,1,0,0,0,.2,1.16l3.13,2.7a1.18,1.18,0,0,1,.31,1.21,35.82,35.82,0,0,0-1.41,4.72,2.26,2.26,0,0,1-.78,1.18l-5.56,3.91a1.63,1.63,0,0,0-.63,1.2v7a.46.46,0,0,0,.7.45l5.42-2.45a.65.65,0,0,1,.9.42,12.06,12.06,0,0,0,1.21,2.69,1.48,1.48,0,0,1,.08,1.31l-3.61,7.29a.81.81,0,0,0,.32,1.06l3.92,2.26a.82.82,0,0,0,1.08-.25l4.5-6.77a1.5,1.5,0,0,1,1.18-.59,11.63,11.63,0,0,0,2.93-.3.64.64,0,0,1,.81.58l.6,5.91a.45.45,0,0,0,.73.38L421,214a1.67,1.67,0,0,0,.73-1.13l.61-6.78a2.17,2.17,0,0,1,.63-1.26,37.16,37.16,0,0,0,3.38-3.58,1.15,1.15,0,0,1,1.2-.34l3.91,1.36a.94.94,0,0,0,1.09-.41l4.48-7.75a1,1,0,0,0-.2-1.15l-3.13-2.7a1.19,1.19,0,0,1-.31-1.21,36.74,36.74,0,0,0,1.41-4.72,2.26,2.26,0,0,1,.78-1.18l5.56-3.92A1.61,1.61,0,0,0,441.79,178ZM418,200.14c-5.69,3.28-10.29.62-10.29-5.94s4.6-14.54,10.29-17.82,10.28-.62,10.28,5.94S423.66,196.86,418,200.14Z"
          style={{
            fill: "#213E60",
            transformOrigin: "417.965px 188.258px",
          }}
          id="elwqaxth6hagb"
          className="animable"
        />
        <path
          d="M400.38,172.94l-4.48,7.75a.91.91,0,0,0-.1.56l3,1.73a.92.92,0,0,1,.11-.56l4.47-7.76a.92.92,0,0,1,.76-.44l-3-1.74A.93.93,0,0,0,400.38,172.94Zm-3,18.71-5.56,3.92a1.53,1.53,0,0,0-.37.42l3,1.72a1.56,1.56,0,0,1,.38-.42l5.56-3.91a2.1,2.1,0,0,0,.44-.45l-3-1.74A1.92,1.92,0,0,1,397.35,191.65ZM418,157.28l-6.09,3.52a1.65,1.65,0,0,0-.61.73l3,1.73a1.62,1.62,0,0,1,.62-.74L421,159a.52.52,0,0,1,.46-.06l-3-1.71A.49.49,0,0,0,418,157.28Zm10.75-.79-4.5,6.77a1,1,0,0,1-.3.29l3,1.73a1.18,1.18,0,0,0,.3-.29l4.5-6.77a.82.82,0,0,1,1.08-.25l-3-1.73A.82.82,0,0,0,428.77,156.49Zm12.77,14,0,0h0Zm-3-1.71a.52.52,0,0,0-.47,0l-4.1,1.85a9.28,9.28,0,0,1,.45,1,8.35,8.35,0,0,1,.32.88.7.7,0,0,0,.25.35.62.62,0,0,0,.66.07l5.42-2.44a.62.62,0,0,1,.26-.06.4.4,0,0,1,.15,0h0l-3-1.72Z"
          style={{
            fill: "#213E60",
            transformOrigin: "416.485px 176.926px",
          }}
          id="elyiwhzea2gu"
          className="animable"
        />
        <g id="el559afx1h8t9">
          <path
            d="M400.38,172.94l-4.48,7.75a.91.91,0,0,0-.1.56l3,1.73a.92.92,0,0,1,.11-.56l4.47-7.76a.92.92,0,0,1,.76-.44l-3-1.74A.93.93,0,0,0,400.38,172.94Zm-3,18.71-5.56,3.92a1.53,1.53,0,0,0-.37.42l3,1.72a1.56,1.56,0,0,1,.38-.42l5.56-3.91a2.1,2.1,0,0,0,.44-.45l-3-1.74A1.92,1.92,0,0,1,397.35,191.65ZM418,157.28l-6.09,3.52a1.65,1.65,0,0,0-.61.73l3,1.73a1.62,1.62,0,0,1,.62-.74L421,159a.52.52,0,0,1,.46-.06l-3-1.71A.49.49,0,0,0,418,157.28Zm10.75-.79-4.5,6.77a1,1,0,0,1-.3.29l3,1.73a1.18,1.18,0,0,0,.3-.29l4.5-6.77a.82.82,0,0,1,1.08-.25l-3-1.73A.82.82,0,0,0,428.77,156.49Zm12.77,14,0,0h0Zm-3-1.71a.52.52,0,0,0-.47,0l-4.1,1.85a9.28,9.28,0,0,1,.45,1,8.35,8.35,0,0,1,.32.88.7.7,0,0,0,.25.35.62.62,0,0,0,.66.07l5.42-2.44a.62.62,0,0,1,.26-.06.4.4,0,0,1,.15,0h0l-3-1.72Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.2,
              transformOrigin: "416.485px 176.926px",
            }}
            className="animable"
            id="elrwj0vrai4us"
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--gears-2--inject-835"
      className="animable"
      style={{
        transformOrigin: "92.2889px 73.6051px",
      }}
    >
      <g
        id="freepik--gears--inject-835"
        className="animable"
        style={{
          transformOrigin: "92.2889px 73.6051px",
        }}
      >
        <path
          d="M54.9,116.39a2,2,0,0,1-.42-.07l-4.21-1.07A2.45,2.45,0,0,1,48.69,114a2.4,2.4,0,0,1-.06-2l3.1-7.68a1.85,1.85,0,0,0-.41-1.7,13,13,0,0,1-1.14-1.49.71.71,0,0,0-1-.29l-5.73,3.54a2,2,0,0,1-3.1-1.46l-.88-6.17a4.39,4.39,0,0,1,1.35-3.6l5.79-5A4.23,4.23,0,0,0,47.8,86a37.06,37.06,0,0,1,.85-4.19,1.1,1.1,0,0,0-.55-1.2l-3.25-1.51a2.57,2.57,0,0,1-1.36-1.48,2.53,2.53,0,0,1,.11-2l4.09-8.5A3.55,3.55,0,0,1,51,65.21l4.07.32a2.34,2.34,0,0,0,1.78-.84c1-1.37,2.05-2.68,3.13-3.89a3.91,3.91,0,0,0,.83-2.24l-.2-6.05a4.49,4.49,0,0,1,1.68-3.46l6.5-4.8a2,2,0,0,1,3.26,1.13l1.29,4.8a.53.53,0,0,0,.24.33.59.59,0,0,0,.49,0,21.52,21.52,0,0,1,2.76-.82,3.3,3.3,0,0,0,1.84-1.27l4.21-7.48a3.27,3.27,0,0,1,3.5-1.5l4.21,1.07a2.37,2.37,0,0,1,1.64,3.25l-3.09,7.67a1.83,1.83,0,0,0,.4,1.7,12,12,0,0,1,1.14,1.49.7.7,0,0,0,1,.29l5.73-3.53a2.08,2.08,0,0,1,2-.19,2.05,2.05,0,0,1,1.11,1.64l.88,6.17A4.34,4.34,0,0,1,100,62.6l-5.78,5a4.16,4.16,0,0,0-1.14,2.16A39.89,39.89,0,0,1,92.24,74a1.1,1.1,0,0,0,.54,1.21L96,76.67a2.6,2.6,0,0,1,1.25,3.48l-4.1,8.5a3.57,3.57,0,0,1-3.32,1.91l-4.08-.33a2.37,2.37,0,0,0-1.78.85c-1,1.36-2,2.67-3.12,3.89a3.82,3.82,0,0,0-.84,2.23l.2,6a4.5,4.5,0,0,1-1.67,3.46l-6.5,4.81a2,2,0,0,1-3.27-1.14l-1.29-4.8a.47.47,0,0,0-.24-.33.57.57,0,0,0-.48,0,22.51,22.51,0,0,1-2.76.82,3.25,3.25,0,0,0-1.85,1.28L58,114.82A3.27,3.27,0,0,1,54.9,116.39ZM49.8,98.86a2.67,2.67,0,0,1,2,1.23,11.47,11.47,0,0,0,1,1.27,3.75,3.75,0,0,1,.76,3.69l-3.1,7.67a.5.5,0,0,0,0,.43.55.55,0,0,0,.35.25L55,114.47a1.33,1.33,0,0,0,1.37-.58l4.21-7.48a5.1,5.1,0,0,1,3.09-2.2,18.24,18.24,0,0,0,2.51-.75,2.49,2.49,0,0,1,2,.1,2.38,2.38,0,0,1,1.21,1.52l1.29,4.8a.44.44,0,0,0,.1.2.38.38,0,0,0,.19-.1l6.5-4.8a2.66,2.66,0,0,0,.91-1.86l-.2-6.06a5.71,5.71,0,0,1,1.31-3.56c1-1.17,2.05-2.43,3-3.74a4.25,4.25,0,0,1,3.47-1.63l4.08.33a1.67,1.67,0,0,0,1.45-.84l4.1-8.49a.72.72,0,0,0,0-.54.69.69,0,0,0-.36-.39L92,76.9a3,3,0,0,1-1.59-3.42,36,36,0,0,0,.81-4A6,6,0,0,1,93,66.17l5.78-5a2.42,2.42,0,0,0,.71-1.89h0L98.6,53.1a.44.44,0,0,0-.06-.18l-.16.08-5.73,3.53a2.57,2.57,0,0,1-3.54-.86,9.36,9.36,0,0,0-1-1.26,3.74,3.74,0,0,1-.75-3.7L90.49,43a.53.53,0,0,0,0-.43.5.5,0,0,0-.35-.25l-4.21-1.07a1.35,1.35,0,0,0-1.37.58l-4.21,7.48a5.08,5.08,0,0,1-3.09,2.2,21.51,21.51,0,0,0-2.51.75,2.48,2.48,0,0,1-2-.09,2.37,2.37,0,0,1-1.21-1.53l-1.29-4.8a.33.33,0,0,0-.1-.2.62.62,0,0,0-.19.1l-6.5,4.8a2.65,2.65,0,0,0-.9,1.87l.2,6a5.73,5.73,0,0,1-1.32,3.56c-1,1.17-2.05,2.43-3,3.75a4.22,4.22,0,0,1-3.47,1.62l-4.07-.32a1.67,1.67,0,0,0-1.46.83l-4.1,8.5a.7.7,0,0,0,0,.53.76.76,0,0,0,.36.39l3.26,1.51a3,3,0,0,1,1.59,3.41,38,38,0,0,0-.81,4,6,6,0,0,1-1.78,3.33l-5.78,5a2.52,2.52,0,0,0-.71,1.89l.88,6.17a.68.68,0,0,0,.05.19l.16-.09,5.73-3.53A2.54,2.54,0,0,1,49.8,98.86ZM63.7,95a7.71,7.71,0,0,1-2.21-.55c-2.58-1.08-4.27-3.56-4.75-7C55.67,79.88,60.72,69.34,68,64c4.06-3,8.21-4,11.39-2.63,2.57,1.08,4.26,3.56,4.74,7,1.08,7.56-4,18.1-11.27,23.49h0C69.7,94.16,66.47,95.25,63.7,95ZM77,62.67c-2.3-.22-5.06.75-7.85,2.82-6.78,5-11.5,14.74-10.51,21.69.39,2.78,1.63,4.68,3.59,5.5,2.55,1.06,6,.19,9.52-2.4,6.78-5,11.5-14.75,10.52-21.7-.4-2.78-1.64-4.68-3.6-5.5A5.46,5.46,0,0,0,77,62.67Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "70.434px 77.8836px",
          }}
          id="el85m8kkf9ua"
          className="animable"
        />
        <path
          d="M114.05,82.25a1.57,1.57,0,0,1-.3,0L111,81.49a1.73,1.73,0,0,1-1.2-2.36L111.82,74a1.06,1.06,0,0,0-.24-1,9.79,9.79,0,0,1-.77-1c-.07-.11-.25-.27-.43-.15l-3.8,2.35a1.57,1.57,0,0,1-1.46.13,1.52,1.52,0,0,1-.83-1.21l-.58-4.1a3,3,0,0,1,1-2.52l3.84-3.33a2.63,2.63,0,0,0,.7-1.34,27.28,27.28,0,0,1,.57-2.8.56.56,0,0,0-.28-.62l-2.16-1a1.87,1.87,0,0,1-.9-2.52l2.72-5.64A2.53,2.53,0,0,1,111.5,48l2.71.21a1.39,1.39,0,0,0,1.05-.5c.65-.9,1.36-1.77,2.08-2.59a2.4,2.4,0,0,0,.52-1.38l-.13-4a3.11,3.11,0,0,1,1.17-2.42l4.32-3.19a1.55,1.55,0,0,1,1.44-.27,1.59,1.59,0,0,1,1,1.11l.86,3.18c.13.15.2.15.28.12a14.23,14.23,0,0,1,1.85-.55,2,2,0,0,0,1.13-.78l2.8-5A2.29,2.29,0,0,1,135,30.85l2.8.71a1.75,1.75,0,0,1,1.14.91,1.78,1.78,0,0,1,.05,1.45L137,39a1.09,1.09,0,0,0,.24,1,7.08,7.08,0,0,1,.77,1c.08.1.24.26.43.14l3.81-2.34a1.44,1.44,0,0,1,2.28,1.07l.58,4.1a3,3,0,0,1-.94,2.52l-3.84,3.33a2.57,2.57,0,0,0-.71,1.34A24.84,24.84,0,0,1,139,54a.59.59,0,0,0,.28.63l2.16,1a1.86,1.86,0,0,1,.9,2.51l-2.72,5.64a2.48,2.48,0,0,1-2.35,1.35l-2.71-.21a1.42,1.42,0,0,0-1,.5A32.72,32.72,0,0,1,131.44,68a2.48,2.48,0,0,0-.52,1.38l.13,4a3.11,3.11,0,0,1-1.17,2.42L125.57,79a1.56,1.56,0,0,1-1.44.26,1.59,1.59,0,0,1-1-1.1L122.31,75c-.14-.15-.21-.15-.29-.12a13.37,13.37,0,0,1-1.85.55,2,2,0,0,0-1.12.78l-2.8,5A2.33,2.33,0,0,1,114.05,82.25ZM110.7,70.31a1.94,1.94,0,0,1,1.42.88,6.47,6.47,0,0,0,.63.83,2.65,2.65,0,0,1,.53,2.6l-2.06,5.1.13.25,2.79.71a.74.74,0,0,0,.74-.31l2.8-5a3.56,3.56,0,0,1,2.15-1.53,14.61,14.61,0,0,0,1.65-.5,1.77,1.77,0,0,1,1.46.08,1.69,1.69,0,0,1,.88,1.1l.86,3.19L129,74.53a1.64,1.64,0,0,0,.54-1.11l-.13-4a4,4,0,0,1,.91-2.47c.69-.78,1.36-1.61,2-2.47a3,3,0,0,1,2.44-1.14l2.7.21a1,1,0,0,0,.82-.47L141,57.42a.34.34,0,0,0,0-.24.35.35,0,0,0-.16-.17l-2.17-1a2.14,2.14,0,0,1-1.13-2.44,24,24,0,0,0,.53-2.63,4.28,4.28,0,0,1,1.23-2.31l3.84-3.32a1.51,1.51,0,0,0,.42-1.12h0l-.58-4.1-3.72,2.39a1.87,1.87,0,0,1-2.56-.62A6.52,6.52,0,0,0,136,41a2.62,2.62,0,0,1-.53-2.61l2.06-5.1.06-.2-.19-.05-2.8-.71a.72.72,0,0,0-.74.31l-2.8,5A3.57,3.57,0,0,1,129,39.19a12.27,12.27,0,0,0-1.65.49,1.83,1.83,0,0,1-1.47-.07A1.79,1.79,0,0,1,125,38.5l-.85-3.19-4.28,3.21a1.64,1.64,0,0,0-.54,1.11l.13,4a3.92,3.92,0,0,1-.91,2.47,30.3,30.3,0,0,0-2,2.48,3,3,0,0,1-2.44,1.13l-2.71-.21a1,1,0,0,0-.82.47l-2.72,5.64a.29.29,0,0,0,0,.24A.29.29,0,0,0,108,56l2.16,1a2.16,2.16,0,0,1,1.14,2.44,26.73,26.73,0,0,0-.54,2.63,4.21,4.21,0,0,1-1.23,2.31l-3.84,3.32a1.53,1.53,0,0,0-.42,1.13l.58,4.09,3.72-2.38A1.81,1.81,0,0,1,110.7,70.31ZM119.9,68a5.08,5.08,0,0,1-1.51-.38,5.67,5.67,0,0,1-3.25-4.76c-.72-5.08,2.67-12.14,7.55-15.74,2.74-2,5.55-2.68,7.71-1.77a5.69,5.69,0,0,1,3.24,4.76c.72,5.08-2.66,12.14-7.54,15.75h0A9.3,9.3,0,0,1,119.9,68Zm8.82-21.47a7.82,7.82,0,0,0-5.1,1.84c-4.47,3.3-7.58,9.7-6.93,14.27a4.17,4.17,0,0,0,2.3,3.54c1.64.69,3.89.11,6.18-1.58h0c4.46-3.3,7.57-9.7,6.92-14.27a4.15,4.15,0,0,0-2.3-3.54A3.73,3.73,0,0,0,128.72,46.57Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "124.412px 56.5351px",
          }}
          id="eluqg7hhpidt"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--gears-1--inject-835"
      className="animable"
      style={{
        transformOrigin: "142.693px 428.013px",
      }}
    >
      <g
        id="freepik--Gear--inject-835"
        className="animable"
        style={{
          transformOrigin: "101.749px 414.815px",
        }}
      >
        <path
          d="M112.89,400.1a1.58,1.58,0,0,1-1.08-1.62l.34-2.73a1.26,1.26,0,0,0-1.12-1.4l-7.19-.75a2,2,0,0,0-1.85,1l-1.43,2.79a2.5,2.5,0,0,1-1.86,1.21c-1.25.1-2.5.25-3.72.46a3.61,3.61,0,0,1-2.32-.46L88.79,396a2.73,2.73,0,0,0-2.25-.23l-5.75,2.3a.84.84,0,0,0-.59.74h0v.07h0v5.87h0a.94.94,0,0,0,.28.64l.33.36a3,3,0,0,1-1.58.49L72.67,406A1.75,1.75,0,0,0,71,407.17l-1,3.18a1.29,1.29,0,0,0,0,.39h0v5.93h0a1.07,1.07,0,0,0,.93,1l5.09.87-2,1a.82.82,0,0,0-.51.72h0v5.94h0a.86.86,0,0,0,.35.65l3.67,3.06a2.62,2.62,0,0,0,2.2.43l5.59-1.75a4,4,0,0,1,2.38.15,28.08,28.08,0,0,0,3,1.11,1.6,1.6,0,0,1,.74.52v4h0a1.25,1.25,0,0,0,1.12,1.23l7.18.75a2,2,0,0,0,1.86-1l1.43-2.79a2.5,2.5,0,0,1,1.86-1.21c1.25-.1,2.5-.25,3.72-.46a3.61,3.61,0,0,1,2.32.46l3.87,2.57a2.73,2.73,0,0,0,2.25.23l5.74-2.3a.84.84,0,0,0,.6-.77h0v-5.92h0a1,1,0,0,0-.28-.64l-.34-.35a3,3,0,0,1,1.59-.49l6.56.26a1.75,1.75,0,0,0,1.66-1.16l1-3.18a1.12,1.12,0,0,0,0-.36h0v-5.9h0a1.06,1.06,0,0,0-.91-1.1l-5.09-.87,2-1a.8.8,0,0,0,.52-.73h0v-5.9h0a.86.86,0,0,0-.35-.68L126.06,400a2.64,2.64,0,0,0-2.21-.43l-5.59,1.75a3.92,3.92,0,0,1-2.37-.16A30.39,30.39,0,0,0,112.89,400.1ZM89.05,415a10.74,10.74,0,0,1,4.9-3.55c6.23-2.5,14.79-1.6,19.11,2a8.3,8.3,0,0,1,1.46,1.54,10.6,10.6,0,0,1-4.92,3.57c-6.22,2.49-14.78,1.6-19.1-2A7.77,7.77,0,0,1,89.05,415Z"
          style={{
            fill: "#213E60",
            transformOrigin: "101.79px 414.975px",
          }}
          id="ely68sw9h389q"
          className="animable"
        />
        <g id="elocaseysnbh">
          <path
            d="M112.89,400.1a1.58,1.58,0,0,1-1.08-1.62l.34-2.73a1.26,1.26,0,0,0-1.12-1.4l-7.19-.75a2,2,0,0,0-1.85,1l-1.43,2.79a2.5,2.5,0,0,1-1.86,1.21c-1.25.1-2.5.25-3.72.46a3.61,3.61,0,0,1-2.32-.46L88.79,396a2.73,2.73,0,0,0-2.25-.23l-5.75,2.3a.84.84,0,0,0-.59.74h0v.07h0v5.87h0a.94.94,0,0,0,.28.64l.33.36a3,3,0,0,1-1.58.49L72.67,406A1.75,1.75,0,0,0,71,407.17l-1,3.18a1.29,1.29,0,0,0,0,.39h0v5.93h0a1.07,1.07,0,0,0,.93,1l5.09.87-2,1a.82.82,0,0,0-.51.72h0v5.94h0a.86.86,0,0,0,.35.65l3.67,3.06a2.62,2.62,0,0,0,2.2.43l5.59-1.75a4,4,0,0,1,2.38.15,28.08,28.08,0,0,0,3,1.11,1.6,1.6,0,0,1,.74.52v4h0a1.25,1.25,0,0,0,1.12,1.23l7.18.75a2,2,0,0,0,1.86-1l1.43-2.79a2.5,2.5,0,0,1,1.86-1.21c1.25-.1,2.5-.25,3.72-.46a3.61,3.61,0,0,1,2.32.46l3.87,2.57a2.73,2.73,0,0,0,2.25.23l5.74-2.3a.84.84,0,0,0,.6-.77h0v-5.92h0a1,1,0,0,0-.28-.64l-.34-.35a3,3,0,0,1,1.59-.49l6.56.26a1.75,1.75,0,0,0,1.66-1.16l1-3.18a1.12,1.12,0,0,0,0-.36h0v-5.9h0a1.06,1.06,0,0,0-.91-1.1l-5.09-.87,2-1a.8.8,0,0,0,.52-.73h0v-5.9h0a.86.86,0,0,0-.35-.68L126.06,400a2.64,2.64,0,0,0-2.21-.43l-5.59,1.75a3.92,3.92,0,0,1-2.37-.16A30.39,30.39,0,0,0,112.89,400.1ZM89.05,415a10.74,10.74,0,0,1,4.9-3.55c6.23-2.5,14.79-1.6,19.11,2a8.3,8.3,0,0,1,1.46,1.54,10.6,10.6,0,0,1-4.92,3.57c-6.22,2.49-14.78,1.6-19.1-2A7.77,7.77,0,0,1,89.05,415Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.2,
              transformOrigin: "101.79px 414.975px",
            }}
            className="animable"
            id="eljzzq883wf6f"
          />
        </g>
        <g id="ela7prpv2u4w9">
          <path
            d="M78.66,414.31a2.15,2.15,0,0,0-1.52-1.46l-6.25-1.07a1.07,1.07,0,0,1-.93-1v5.86a1.09,1.09,0,0,0,.92,1l5.09.87,2.63-1.32a1.24,1.24,0,0,0,.53-1.69A8.62,8.62,0,0,1,78.66,414.31Zm1.53-9.54h0a1,1,0,0,0,.28.65l.33.35a2.63,2.63,0,0,0,.55-.41,12.6,12.6,0,0,1,1.57-1.4,1.12,1.12,0,0,0,.16-1.69l-2.61-2.77a.94.94,0,0,1-.28-.64Z"
            style={{
              opacity: 0.1,
              transformOrigin: "76.6763px 408.685px",
            }}
            className="animable"
            id="el3kep5t4zocn"
          />
        </g>
        <g id="elniewa1o3hss">
          <path
            d="M94,405.52c-5.38,2.15-7.27,6.11-4.9,9.47A10.54,10.54,0,0,1,94,411.43c6.23-2.49,14.79-1.61,19.11,2a8.23,8.23,0,0,1,1.45,1.55c1.67-2.38,1.28-5.19-1.44-7.46C108.74,403.91,100.19,403,94,405.52Z"
            style={{
              opacity: 0.1,
              transformOrigin: "101.826px 409.541px",
            }}
            className="animable"
            id="elszn7smhg7dg"
          />
        </g>
        <path
          d="M103.6,426a2.11,2.11,0,0,0-.59.69l-1.44,2.79a2,2,0,0,1-1.06.89v5.92a2,2,0,0,0,1-.89l1.44-2.79a2.17,2.17,0,0,1,.61-.68Zm19.76-.78h0a.83.83,0,0,1-.6.77l-5.74,2.3a2.56,2.56,0,0,1-1.51.06v5.92a2.74,2.74,0,0,0,1.51-.06l5.75-2.31a.82.82,0,0,0,.59-.76Zm-38.14-2.48-5.51,1.73a2.44,2.44,0,0,1-1.39,0v5.9a2.54,2.54,0,0,0,1.39,0l5.53-1.73Zm48.39-9.35a2.21,2.21,0,0,1-.06.34l-1,3.18a1.77,1.77,0,0,1-1.66,1.17l-6.57-.27a2.74,2.74,0,0,0-1,.21v5.92a2.63,2.63,0,0,1,1-.21l6.56.26a1.75,1.75,0,0,0,1.66-1.16l1-3.18a.91.91,0,0,0,.06-.36Zm-3.51-9.58a.84.84,0,0,1,0,.2.64.64,0,0,1-.2.3,1.08,1.08,0,0,1-.29.21L125,406.8a1.26,1.26,0,0,0-.28.2,1.14,1.14,0,0,0-.31.48,1.2,1.2,0,0,0-.07.46,2,2,0,0,0,0,.24,2,2,0,0,0,.11.32,8.39,8.39,0,0,1,.47,1.23,2.16,2.16,0,0,0,1.52,1.48l1.16.19,2-1a.85.85,0,0,0,.52-.74h0Z"
          style={{
            fill: "#213E60",
            transformOrigin: "105.965px 420.05px",
          }}
          id="el1ne0e0agf4s"
          className="animable"
        />
        <g id="elgh4zz7ftxnl">
          <path
            d="M103.6,426a2.11,2.11,0,0,0-.59.69l-1.44,2.79a2,2,0,0,1-1.06.89v5.92a2,2,0,0,0,1-.89l1.44-2.79a2.17,2.17,0,0,1,.61-.68Zm19.76-.78h0a.83.83,0,0,1-.6.77l-5.74,2.3a2.56,2.56,0,0,1-1.51.06v5.92a2.74,2.74,0,0,0,1.51-.06l5.75-2.31a.82.82,0,0,0,.59-.76Zm-38.14-2.48-5.51,1.73a2.44,2.44,0,0,1-1.39,0v5.9a2.54,2.54,0,0,0,1.39,0l5.53-1.73Zm48.39-9.35a2.21,2.21,0,0,1-.06.34l-1,3.18a1.77,1.77,0,0,1-1.66,1.17l-6.57-.27a2.74,2.74,0,0,0-1,.21v5.92a2.63,2.63,0,0,1,1-.21l6.56.26a1.75,1.75,0,0,0,1.66-1.16l1-3.18a.91.91,0,0,0,.06-.36Zm-3.51-9.58a.84.84,0,0,1,0,.2.64.64,0,0,1-.2.3,1.08,1.08,0,0,1-.29.21L125,406.8a1.26,1.26,0,0,0-.28.2,1.14,1.14,0,0,0-.31.48,1.2,1.2,0,0,0-.07.46,2,2,0,0,0,0,.24,2,2,0,0,0,.11.32,8.39,8.39,0,0,1,.47,1.23,2.16,2.16,0,0,0,1.52,1.48l1.16.19,2-1a.85.85,0,0,0,.52-.74h0Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.7,
              transformOrigin: "105.965px 420.05px",
            }}
            className="animable"
            id="el0wald9z5e37h"
          />
        </g>
        <path
          d="M123.85,399.61l-5.59,1.75a3.92,3.92,0,0,1-2.37-.16,30.39,30.39,0,0,0-3-1.1,1.58,1.58,0,0,1-1.08-1.62l.34-2.73a1.26,1.26,0,0,0-1.12-1.4l-7.19-.75a2,2,0,0,0-1.85,1l-1.43,2.79a2.5,2.5,0,0,1-1.86,1.21c-1.25.1-2.5.25-3.72.46a3.61,3.61,0,0,1-2.32-.46L88.79,396a2.73,2.73,0,0,0-2.25-.23l-5.75,2.3a.82.82,0,0,0-.31,1.41l2.61,2.77a1.11,1.11,0,0,1-.16,1.68,14.39,14.39,0,0,0-1.57,1.41,3.23,3.23,0,0,1-2.13.9L72.67,406A1.75,1.75,0,0,0,71,407.17l-1,3.18a1.08,1.08,0,0,0,.88,1.43l6.25,1.07a2.14,2.14,0,0,1,1.52,1.47,9,9,0,0,0,.47,1.24,1.24,1.24,0,0,1-.52,1.69L74,419.57a.77.77,0,0,0-.16,1.39L77.5,424a2.63,2.63,0,0,0,2.2.44l5.6-1.76a3.92,3.92,0,0,1,2.37.16,30.39,30.39,0,0,0,3,1.1,1.56,1.56,0,0,1,1.07,1.63l-.33,2.72a1.27,1.27,0,0,0,1.12,1.41l7.19.75a2,2,0,0,0,1.85-1l1.43-2.79a2.52,2.52,0,0,1,1.86-1.21c1.25-.09,2.5-.25,3.72-.46a3.67,3.67,0,0,1,2.32.46l3.87,2.57a2.69,2.69,0,0,0,2.25.23l5.75-2.3a.82.82,0,0,0,.31-1.41l-2.61-2.77a1.11,1.11,0,0,1,.16-1.68,15.44,15.44,0,0,0,1.57-1.4,3.18,3.18,0,0,1,2.13-.91l6.56.27a1.76,1.76,0,0,0,1.66-1.17l1-3.18a1.08,1.08,0,0,0-.88-1.43l-6.25-1.07a2.15,2.15,0,0,1-1.52-1.46,9.08,9.08,0,0,0-.47-1.25,1.24,1.24,0,0,1,.52-1.69l4.62-2.31a.78.78,0,0,0,.16-1.39L126.06,400A2.64,2.64,0,0,0,123.85,399.61Zm-10.79,7.9c4.32,3.6,2.78,8.53-3.46,11s-14.78,1.6-19.1-2-2.78-8.53,3.45-11S108.74,403.91,113.06,407.51Z"
          style={{
            fill: "#213E60",
            transformOrigin: "101.775px 412.025px",
          }}
          id="elj8nenpvmgl8"
          className="animable"
        />
        <g id="elegzzhbg5t4j">
          <g
            style={{
              opacity: 0.55,
              transformOrigin: "101.749px 412.048px",
            }}
            className="animable"
            id="elw18pk6fbl2r"
          >
            <path
              d="M123.85,399.61l-5.59,1.75a3.92,3.92,0,0,1-2.37-.16,30.39,30.39,0,0,0-3-1.1,1.58,1.58,0,0,1-1.08-1.62l.34-2.73a1.26,1.26,0,0,0-1.12-1.4l-7.19-.75a2,2,0,0,0-1.85,1l-1.43,2.79a2.5,2.5,0,0,1-1.86,1.21c-1.25.1-2.5.25-3.72.46a3.61,3.61,0,0,1-2.32-.46L88.79,396a2.73,2.73,0,0,0-2.25-.23l-5.75,2.3a.82.82,0,0,0-.31,1.41l2.61,2.77a1.11,1.11,0,0,1-.16,1.68,14.39,14.39,0,0,0-1.57,1.41,3.23,3.23,0,0,1-2.13.9L72.67,406A1.75,1.75,0,0,0,71,407.17l-1,3.18a1.08,1.08,0,0,0,.88,1.43l6.25,1.07a2.14,2.14,0,0,1,1.52,1.47,9,9,0,0,0,.47,1.24,1.24,1.24,0,0,1-.52,1.69L74,419.57a.77.77,0,0,0-.16,1.39L77.5,424a2.63,2.63,0,0,0,2.2.44l5.6-1.76a3.92,3.92,0,0,1,2.37.16,30.39,30.39,0,0,0,3,1.1,1.56,1.56,0,0,1,1.07,1.63l-.33,2.72a1.27,1.27,0,0,0,1.12,1.41l7.19.75a2,2,0,0,0,1.85-1l1.43-2.79a2.52,2.52,0,0,1,1.86-1.21c1.25-.09,2.5-.25,3.72-.46a3.67,3.67,0,0,1,2.32.46l3.87,2.57a2.69,2.69,0,0,0,2.25.23l5.75-2.3a.82.82,0,0,0,.31-1.41l-2.61-2.77a1.11,1.11,0,0,1,.16-1.68,15.44,15.44,0,0,0,1.57-1.4,3.18,3.18,0,0,1,2.13-.91l6.56.27a1.76,1.76,0,0,0,1.66-1.17l1-3.18a1.08,1.08,0,0,0-.88-1.43l-6.25-1.07a2.15,2.15,0,0,1-1.52-1.46,9.08,9.08,0,0,0-.47-1.25,1.24,1.24,0,0,1,.52-1.69l4.62-2.31a.78.78,0,0,0,.16-1.39L126.06,400A2.64,2.64,0,0,0,123.85,399.61Zm-10.79,7.9c4.32,3.6,2.78,8.53-3.46,11s-14.78,1.6-19.1-2-2.78-8.53,3.45-11S108.74,403.91,113.06,407.51Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "101.775px 412.025px",
              }}
              id="elx7bo1gyipdg"
              className="animable"
            />
            <path
              d="M99.87,430.82h-.19l-7.18-.75a1.58,1.58,0,0,1-1.1-.6,1.61,1.61,0,0,1-.34-1.2l.33-2.73a1.22,1.22,0,0,0-.83-1.24,30.08,30.08,0,0,1-3-1.11A3.63,3.63,0,0,0,85.4,423l-5.59,1.76a3,3,0,0,1-2.54-.51l-3.66-3a1.21,1.21,0,0,1-.49-1.06,1.19,1.19,0,0,1,.71-.92l4.61-2.32a.89.89,0,0,0,.37-1.22,9.21,9.21,0,0,1-.49-1.29,1.75,1.75,0,0,0-1.24-1.21l-6.25-1.07a1.46,1.46,0,0,1-1.16-1.9l1-3.17a2.11,2.11,0,0,1,2-1.42l6.57.26a2.79,2.79,0,0,0,1.85-.79,17.33,17.33,0,0,1,1.61-1.44.83.83,0,0,0,.34-.58.74.74,0,0,0-.22-.57l-2.61-2.78a1.26,1.26,0,0,1-.36-1.12,1.29,1.29,0,0,1,.8-.86l5.75-2.3a3.08,3.08,0,0,1,2.58.26l3.87,2.57a3.3,3.3,0,0,0,2.06.41c1.22-.21,2.48-.37,3.75-.46a2.2,2.2,0,0,0,1.57-1l1.43-2.79a2.37,2.37,0,0,1,2.21-1.2l7.18.75a1.61,1.61,0,0,1,1.44,1.8l-.33,2.73a1.22,1.22,0,0,0,.83,1.24,28.4,28.4,0,0,1,3,1.12,3.63,3.63,0,0,0,2.13.14l5.59-1.75a3,3,0,0,1,2.54.5l3.66,3.05a1.13,1.13,0,0,1-.22,2l-4.62,2.31a.89.89,0,0,0-.36,1.22,8.88,8.88,0,0,1,.49,1.3,1.79,1.79,0,0,0,1.24,1.21l6.25,1.07a1.43,1.43,0,0,1,1,.67,1.48,1.48,0,0,1,.14,1.22l-1,3.18a2.1,2.1,0,0,1-2,1.41l-6.57-.26a2.83,2.83,0,0,0-1.85.8,17.25,17.25,0,0,1-1.61,1.43.85.85,0,0,0-.34.58.77.77,0,0,0,.22.58l2.61,2.77a1.16,1.16,0,0,1-.44,2l-5.75,2.3a3.08,3.08,0,0,1-2.58-.26l-3.87-2.57a3.3,3.3,0,0,0-2.06-.41c-1.21.21-2.48.37-3.75.47a2.14,2.14,0,0,0-1.57,1l-1.43,2.78A2.37,2.37,0,0,1,99.87,430.82Zm-13.68-8.6a4.26,4.26,0,0,1,1.63.3,29.34,29.34,0,0,0,3,1.09,1.94,1.94,0,0,1,1.32,2l-.33,2.73A.9.9,0,0,0,92,429a.87.87,0,0,0,.61.33l7.18.75a1.64,1.64,0,0,0,1.5-.81l1.43-2.79a2.91,2.91,0,0,1,2.15-1.41,36.12,36.12,0,0,0,3.69-.45,4,4,0,0,1,2.58.52l3.86,2.56a2.38,2.38,0,0,0,1.93.2l5.74-2.3a.53.53,0,0,0,.37-.36.55.55,0,0,0-.18-.47L120.21,422a1.45,1.45,0,0,1-.41-1.12,1.53,1.53,0,0,1,.61-1.09,17.23,17.23,0,0,0,1.54-1.37,3.61,3.61,0,0,1,2.39-1l6.57.26a1.4,1.4,0,0,0,1.3-.92l1-3.17a.74.74,0,0,0-.6-1l-6.25-1.07a2.45,2.45,0,0,1-1.8-1.71,8.14,8.14,0,0,0-.46-1.19,1.62,1.62,0,0,1,.69-2.17l4.62-2.31a.54.54,0,0,0,.32-.37.52.52,0,0,0-.23-.43l-3.67-3.05A2.23,2.23,0,0,0,124,400l-5.59,1.75a4.33,4.33,0,0,1-2.63-.17,28.47,28.47,0,0,0-3-1.09,1.93,1.93,0,0,1-1.32-2l.33-2.72a.88.88,0,0,0-.19-.67.92.92,0,0,0-.61-.34l-7.18-.75a1.68,1.68,0,0,0-1.5.81l-1.43,2.79A2.88,2.88,0,0,1,98.73,399a36.82,36.82,0,0,0-3.69.46,4.1,4.1,0,0,1-2.58-.52l-3.87-2.57a2.35,2.35,0,0,0-1.92-.2l-5.74,2.3c-.21.09-.34.21-.37.36a.54.54,0,0,0,.18.47L83.35,402a1.43,1.43,0,0,1,.41,1.11,1.55,1.55,0,0,1-.61,1.1,15.72,15.72,0,0,0-1.54,1.36,3.49,3.49,0,0,1-2.39,1l-6.57-.27a1.38,1.38,0,0,0-1.3.92l-1,3.18a.73.73,0,0,0,.07.63.76.76,0,0,0,.53.34l6.25,1.07a2.48,2.48,0,0,1,1.8,1.72,8.32,8.32,0,0,0,.46,1.19,1.6,1.6,0,0,1-.69,2.16l-4.62,2.32a.51.51,0,0,0-.32.36.52.52,0,0,0,.23.43l3.67,3.06a2.26,2.26,0,0,0,1.87.36l5.59-1.75A3.37,3.37,0,0,1,86.19,422.22Zm15.62-1.92c-4.44,0-8.82-1.21-11.54-3.48-1.93-1.61-2.83-3.59-2.52-5.57.39-2.47,2.61-4.68,6.07-6.07,6.33-2.53,15.06-1.61,19.47,2.05,1.93,1.62,2.83,3.59,2.52,5.57-.39,2.47-2.61,4.68-6.07,6.07A21.59,21.59,0,0,1,101.81,420.3Zm0-15.85a21.1,21.1,0,0,0-7.68,1.39c-3.23,1.3-5.28,3.31-5.63,5.53a5.35,5.35,0,0,0,2.27,4.9c4.22,3.52,12.63,4.39,18.74,1.94,3.23-1.29,5.28-3.31,5.63-5.52.27-1.72-.53-3.46-2.27-4.91C110.23,405.62,106,404.45,101.77,404.45Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "101.749px 412.048px",
              }}
              id="eldrcnnijyq08"
              className="animable"
            />
          </g>
        </g>
      </g>
      <g
        id="freepik--gear--inject-835"
        className="animable"
        style={{
          transformOrigin: "172.535px 434.47px",
        }}
      >
        <path
          d="M206.78,416,199,411.48a2.08,2.08,0,0,0-1.71-.08l-7.87,3.65a2.92,2.92,0,0,1-1.8.11,46.14,46.14,0,0,0-6.11-1.46,1.46,1.46,0,0,1-1.14-1.1l-1-5.19a1.23,1.23,0,0,0-1.15-1H166.83a1.23,1.23,0,0,0-1.15,1l-1,5.19a1.46,1.46,0,0,1-1.14,1.1,46.14,46.14,0,0,0-6.11,1.46,2.92,2.92,0,0,1-1.8-.11l-7.87-3.65a2.08,2.08,0,0,0-1.71.08L138.3,416a.63.63,0,0,0-.36.53h0l0,6.73h0a.66.66,0,0,0,.31.52l3.57,2.57a1.74,1.74,0,0,1-.88.37l-10.34.65a1.05,1.05,0,0,0-1,1v4.4h0l0,8.09a1,1,0,0,0,1,1l10.34.66a1.7,1.7,0,0,1,.9.38l-3.55,2.55a.66.66,0,0,0-.31.52h0l0,6.74h0a.66.66,0,0,0,.37.52l7.76,4.48a2.07,2.07,0,0,0,1.72.08l7.86-3.64a2.85,2.85,0,0,1,1.8-.11,47.75,47.75,0,0,0,6.11,1.45,1.49,1.49,0,0,1,1.14,1.11l1,5.18a1.21,1.21,0,0,0,1.15.95h11.41a1.21,1.21,0,0,0,1.15-.95l1-5.18a1.49,1.49,0,0,1,1.14-1.11,47.75,47.75,0,0,0,6.11-1.45,2.85,2.85,0,0,1,1.8.11l7.87,3.64a2.07,2.07,0,0,0,1.72-.08l7.76-4.48a.64.64,0,0,0,.36-.51h0l0-6.75h0a.66.66,0,0,0-.31-.52l-3.57-2.57a1.73,1.73,0,0,1,.88-.36l10.34-.66a1,1,0,0,0,1-1v-6.7a0,0,0,0,0,0,0v-5.77a1.05,1.05,0,0,0-1-1l-10.34-.65a1.7,1.7,0,0,1-.9-.38l3.55-2.56a.64.64,0,0,0,.31-.51h0l0-6.74h0A.63.63,0,0,0,206.78,416ZM154.37,433.4c.56-1.86,2.22-3.68,5-5.32,7.25-4.18,19-4.18,26.23,0,2.66,1.54,4.39,3.22,5.17,4.95-.61,2.12-2.33,4.15-5.16,5.79-7.25,4.18-19,4.18-26.23,0A10.8,10.8,0,0,1,154.37,433.4Z"
          style={{
            fill: "#213E60",
            transformOrigin: "172.575px 434.57px",
          }}
          id="el1x4tr767eyw"
          className="animable"
        />
        <g id="elvz1vfqp09kg">
          <path
            d="M206.78,416,199,411.48a2.08,2.08,0,0,0-1.71-.08l-7.87,3.65a2.92,2.92,0,0,1-1.8.11,46.14,46.14,0,0,0-6.11-1.46,1.46,1.46,0,0,1-1.14-1.1l-1-5.19a1.23,1.23,0,0,0-1.15-1H166.83a1.23,1.23,0,0,0-1.15,1l-1,5.19a1.46,1.46,0,0,1-1.14,1.1,46.14,46.14,0,0,0-6.11,1.46,2.92,2.92,0,0,1-1.8-.11l-7.87-3.65a2.08,2.08,0,0,0-1.71.08L138.3,416a.63.63,0,0,0-.36.53h0l0,6.73h0a.66.66,0,0,0,.31.52l3.57,2.57a1.74,1.74,0,0,1-.88.37l-10.34.65a1.05,1.05,0,0,0-1,1v4.4h0l0,8.09a1,1,0,0,0,1,1l10.34.66a1.7,1.7,0,0,1,.9.38l-3.55,2.55a.66.66,0,0,0-.31.52h0l0,6.74h0a.66.66,0,0,0,.37.52l7.76,4.48a2.07,2.07,0,0,0,1.72.08l7.86-3.64a2.85,2.85,0,0,1,1.8-.11,47.75,47.75,0,0,0,6.11,1.45,1.49,1.49,0,0,1,1.14,1.11l1,5.18a1.21,1.21,0,0,0,1.15.95h11.41a1.21,1.21,0,0,0,1.15-.95l1-5.18a1.49,1.49,0,0,1,1.14-1.11,47.75,47.75,0,0,0,6.11-1.45,2.85,2.85,0,0,1,1.8.11l7.87,3.64a2.07,2.07,0,0,0,1.72-.08l7.76-4.48a.64.64,0,0,0,.36-.51h0l0-6.75h0a.66.66,0,0,0-.31-.52l-3.57-2.57a1.73,1.73,0,0,1,.88-.36l10.34-.66a1,1,0,0,0,1-1v-6.7a0,0,0,0,0,0,0v-5.77a1.05,1.05,0,0,0-1-1l-10.34-.65a1.7,1.7,0,0,1-.9-.38l3.55-2.56a.64.64,0,0,0,.31-.51h0l0-6.74h0A.63.63,0,0,0,206.78,416ZM154.37,433.4c.56-1.86,2.22-3.68,5-5.32,7.25-4.18,19-4.18,26.23,0,2.66,1.54,4.39,3.22,5.17,4.95-.61,2.12-2.33,4.15-5.16,5.79-7.25,4.18-19,4.18-26.23,0A10.8,10.8,0,0,1,154.37,433.4Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.2,
              transformOrigin: "172.575px 434.57px",
            }}
            className="animable"
            id="eluzjfglwtpy"
          />
        </g>
        <g id="elf0ioe7y8bzo">
          <path
            d="M142.32,436.75a1.89,1.89,0,0,0-1.4-.93l-10.35-.66a1,1,0,0,1-1-1v-1.36l0,8.09a1.05,1.05,0,0,0,1,1l10.35.66a1.7,1.7,0,0,1,.91.37l2.58-1.86a.83.83,0,0,0,.12-1.27A15.56,15.56,0,0,1,142.32,436.75Zm-4.4-13.53h0a.62.62,0,0,0,.3.52l3.57,2.58a1.75,1.75,0,0,0,.52-.57,15.5,15.5,0,0,1,2.2-3.05.81.81,0,0,0-.12-1.26L138.25,417a.73.73,0,0,1-.31-.45Z"
            style={{
              opacity: 0.1,
              transformOrigin: "137.171px 429.735px",
            }}
            className="animable"
            id="elu3owug6za6"
          />
        </g>
        <g id="elggl1smmzqcw">
          <path
            d="M185.65,423.68c-7.24-4.18-19-4.19-26.22,0-4.58,2.65-6.27,6.33-5.06,9.73.55-1.85,2.22-3.68,5-5.32,7.25-4.18,19-4.18,26.23,0,2.65,1.53,4.39,3.21,5.18,4.94C191.79,429.73,190.06,426.22,185.65,423.68Z"
            style={{
              opacity: 0.1,
              transformOrigin: "172.525px 426.976px",
            }}
            className="animable"
            id="ellnvlok9dnzh"
          />
        </g>
        <path
          d="M215.46,434.27a1.05,1.05,0,0,1-1,.89l-10.34.66a1.26,1.26,0,0,0-.52.14v6.74a1.41,1.41,0,0,1,.51-.15l10.34-.66a1,1,0,0,0,1-1Zm-8.32-17.78h0a.52.52,0,0,1,0,.21.49.49,0,0,1-.13.2.55.55,0,0,1-.14.12l-6.15,4.43a.64.64,0,0,0-.15.13.8.8,0,0,0-.19.38.77.77,0,0,0,0,.26.5.5,0,0,0,0,.13,1.07,1.07,0,0,0,.2.36.81.81,0,0,1,.12.14,15.2,15.2,0,0,1,2.08,2.91,2.11,2.11,0,0,0,.49.55l3.56-2.55a.67.67,0,0,0,.31-.52h0Zm0,29.57a.69.69,0,0,1-.36.48L199,451a2.07,2.07,0,0,1-1.2.21V458a2,2,0,0,0,1.2-.21l7.76-4.48a.62.62,0,0,0,.36-.51Zm-50.71,1.2a2.55,2.55,0,0,0-.78.18l-7.87,3.65a1.54,1.54,0,0,1-.7.15V458a1.94,1.94,0,0,0,.7-.14l7.87-3.65a2.81,2.81,0,0,1,.77-.18Zm22.78,8.26a1.19,1.19,0,0,1-1,.51H166.83a1.21,1.21,0,0,1-.7-.26v6.73a1.08,1.08,0,0,0,.69.25h11.41a1.25,1.25,0,0,0,1-.57Z"
          style={{
            fill: "#213E60",
            transformOrigin: "181.27px 439.62px",
          }}
          id="el06jpe715d729"
          className="animable"
        />
        <g id="el0gy0v1f78py">
          <path
            d="M215.46,434.27a1.05,1.05,0,0,1-1,.89l-10.34.66a1.26,1.26,0,0,0-.52.14v6.74a1.41,1.41,0,0,1,.51-.15l10.34-.66a1,1,0,0,0,1-1Zm-8.32-17.78h0a.52.52,0,0,1,0,.21.49.49,0,0,1-.13.2.55.55,0,0,1-.14.12l-6.15,4.43a.64.64,0,0,0-.15.13.8.8,0,0,0-.19.38.77.77,0,0,0,0,.26.5.5,0,0,0,0,.13,1.07,1.07,0,0,0,.2.36.81.81,0,0,1,.12.14,15.2,15.2,0,0,1,2.08,2.91,2.11,2.11,0,0,0,.49.55l3.56-2.55a.67.67,0,0,0,.31-.52h0Zm0,29.57a.69.69,0,0,1-.36.48L199,451a2.07,2.07,0,0,1-1.2.21V458a2,2,0,0,0,1.2-.21l7.76-4.48a.62.62,0,0,0,.36-.51Zm-50.71,1.2a2.55,2.55,0,0,0-.78.18l-7.87,3.65a1.54,1.54,0,0,1-.7.15V458a1.94,1.94,0,0,0,.7-.14l7.87-3.65a2.81,2.81,0,0,1,.77-.18Zm22.78,8.26a1.19,1.19,0,0,1-1,.51H166.83a1.21,1.21,0,0,1-.7-.26v6.73a1.08,1.08,0,0,0,.69.25h11.41a1.25,1.25,0,0,0,1-.57Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.7,
              transformOrigin: "181.27px 439.62px",
            }}
            className="animable"
            id="el2dteihctok"
          />
        </g>
        <path
          d="M197.3,411.4l-7.87,3.65a2.92,2.92,0,0,1-1.8.11,46.14,46.14,0,0,0-6.11-1.46,1.46,1.46,0,0,1-1.14-1.1l-1-5.19a1.23,1.23,0,0,0-1.15-1H166.83a1.23,1.23,0,0,0-1.15,1l-1,5.19a1.46,1.46,0,0,1-1.14,1.1,46.14,46.14,0,0,0-6.11,1.46,2.92,2.92,0,0,1-1.8-.11l-7.87-3.65a2.08,2.08,0,0,0-1.71.08L138.3,416a.58.58,0,0,0-.05,1.05l6.15,4.43a.81.81,0,0,1,.12,1.26,15.92,15.92,0,0,0-2.2,3.05,1.91,1.91,0,0,1-1.4.93l-10.34.65a1.05,1.05,0,0,0-1,1v5.77a1,1,0,0,0,1,1l10.34.66a1.9,1.9,0,0,1,1.4.93,15.56,15.56,0,0,0,2.2,3,.83.83,0,0,1-.12,1.27l-6.15,4.42a.58.58,0,0,0,.05,1l7.77,4.48a2,2,0,0,0,1.71.08l7.87-3.64a2.85,2.85,0,0,1,1.8-.11,47.75,47.75,0,0,0,6.11,1.45,1.49,1.49,0,0,1,1.14,1.11l1,5.18a1.21,1.21,0,0,0,1.15.95h11.42a1.21,1.21,0,0,0,1.15-.95l1-5.18a1.49,1.49,0,0,1,1.14-1.11,47.75,47.75,0,0,0,6.11-1.45,2.85,2.85,0,0,1,1.8.11l7.87,3.64A2,2,0,0,0,199,451l7.77-4.48a.58.58,0,0,0,.05-1l-6.15-4.42a.83.83,0,0,1-.12-1.27,15.56,15.56,0,0,0,2.2-3,1.9,1.9,0,0,1,1.4-.93l10.34-.66a1,1,0,0,0,1-1v-5.77a1.05,1.05,0,0,0-1-1l-10.34-.65a1.93,1.93,0,0,1-1.4-.93,15.92,15.92,0,0,0-2.2-3.05.81.81,0,0,1,.12-1.26l6.15-4.43a.58.58,0,0,0-.05-1.05L199,411.48A2.08,2.08,0,0,0,197.3,411.4Zm-11.64,12.28c7.24,4.18,7.24,11,0,15.14s-19,4.18-26.23,0-7.25-11,0-15.14S178.41,419.49,185.66,423.68Z"
          style={{
            fill: "#213E60",
            transformOrigin: "172.535px 431.165px",
          }}
          id="elql91l9c2vn"
          className="animable"
        />
        <g id="eltvbhwohvy1">
          <g
            style={{
              opacity: 0.55,
              transformOrigin: "172.535px 431.25px",
            }}
            className="animable"
            id="elgh6uvsp7g16"
          >
            <path
              d="M197.3,411.4l-7.87,3.65a2.92,2.92,0,0,1-1.8.11,46.14,46.14,0,0,0-6.11-1.46,1.46,1.46,0,0,1-1.14-1.1l-1-5.19a1.23,1.23,0,0,0-1.15-1H166.83a1.23,1.23,0,0,0-1.15,1l-1,5.19a1.46,1.46,0,0,1-1.14,1.1,46.14,46.14,0,0,0-6.11,1.46,2.92,2.92,0,0,1-1.8-.11l-7.87-3.65a2.08,2.08,0,0,0-1.71.08L138.3,416a.58.58,0,0,0-.05,1.05l6.15,4.43a.81.81,0,0,1,.12,1.26,15.92,15.92,0,0,0-2.2,3.05,1.91,1.91,0,0,1-1.4.93l-10.34.65a1.05,1.05,0,0,0-1,1v5.77a1,1,0,0,0,1,1l10.34.66a1.9,1.9,0,0,1,1.4.93,15.56,15.56,0,0,0,2.2,3,.83.83,0,0,1-.12,1.27l-6.15,4.42a.58.58,0,0,0,.05,1l7.77,4.48a2,2,0,0,0,1.71.08l7.87-3.64a2.85,2.85,0,0,1,1.8-.11,47.75,47.75,0,0,0,6.11,1.45,1.49,1.49,0,0,1,1.14,1.11l1,5.18a1.21,1.21,0,0,0,1.15.95h11.42a1.21,1.21,0,0,0,1.15-.95l1-5.18a1.49,1.49,0,0,1,1.14-1.11,47.75,47.75,0,0,0,6.11-1.45,2.85,2.85,0,0,1,1.8.11l7.87,3.64A2,2,0,0,0,199,451l7.77-4.48a.58.58,0,0,0,.05-1l-6.15-4.42a.83.83,0,0,1-.12-1.27,15.56,15.56,0,0,0,2.2-3,1.9,1.9,0,0,1,1.4-.93l10.34-.66a1,1,0,0,0,1-1v-5.77a1.05,1.05,0,0,0-1-1l-10.34-.65a1.93,1.93,0,0,1-1.4-.93,15.92,15.92,0,0,0-2.2-3.05.81.81,0,0,1,.12-1.26l6.15-4.43a.58.58,0,0,0-.05-1.05L199,411.48A2.08,2.08,0,0,0,197.3,411.4Zm-11.64,12.28c7.24,4.18,7.24,11,0,15.14s-19,4.18-26.23,0-7.25-11,0-15.14S178.41,419.49,185.66,423.68Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "172.535px 431.165px",
              }}
              id="elr1bx2syaup"
              className="animable"
            />
            <path
              d="M178.25,456.31H166.83a1.49,1.49,0,0,1-1.42-1.18l-1-5.18a1.23,1.23,0,0,0-.91-.89,46.06,46.06,0,0,1-6.15-1.46,2.57,2.57,0,0,0-1.6.1l-7.87,3.64a2.34,2.34,0,0,1-2-.09l-7.76-4.48a.88.88,0,0,1-.5-.73.91.91,0,0,1,.42-.78l6.15-4.43a.52.52,0,0,0,.24-.39.57.57,0,0,0-.17-.46,15.61,15.61,0,0,1-2.23-3.1,1.63,1.63,0,0,0-1.18-.79l-10.34-.65a1.33,1.33,0,0,1-1.23-1.31v-5.77a1.32,1.32,0,0,1,1.22-1.3l10.35-.66a1.64,1.64,0,0,0,1.17-.78,15.33,15.33,0,0,1,2.23-3.1.59.59,0,0,0,.17-.47.55.55,0,0,0-.24-.39l-6.15-4.42a.86.86,0,0,1,.08-1.52l7.76-4.48a2.38,2.38,0,0,1,2-.09l7.87,3.65a2.65,2.65,0,0,0,1.6.09,47.65,47.65,0,0,1,6.15-1.46,1.22,1.22,0,0,0,.91-.88l1-5.19a1.48,1.48,0,0,1,1.42-1.17h11.42a1.48,1.48,0,0,1,1.42,1.17l1,5.19a1.21,1.21,0,0,0,.92.88,49.63,49.63,0,0,1,6.14,1.46,2.64,2.64,0,0,0,1.6-.09l7.87-3.65a2.38,2.38,0,0,1,2,.09l7.77,4.48a1,1,0,0,1,.5.74.93.93,0,0,1-.43.78l-6.15,4.42a.55.55,0,0,0-.07.86,15.61,15.61,0,0,1,2.23,3.1,1.62,1.62,0,0,0,1.18.78l10.34.66a1.33,1.33,0,0,1,1.23,1.3v5.77a1.33,1.33,0,0,1-1.23,1.31l-10.34.65a1.68,1.68,0,0,0-1.18.79,15.61,15.61,0,0,1-2.23,3.1.54.54,0,0,0,.07.85l6.15,4.43a.85.85,0,0,1-.07,1.51l-7.77,4.48a2.31,2.31,0,0,1-2,.09l-7.87-3.64a2.57,2.57,0,0,0-1.6-.1,46.06,46.06,0,0,1-6.15,1.46,1.23,1.23,0,0,0-.91.89l-1,5.18A1.49,1.49,0,0,1,178.25,456.31ZM156.74,447a2.92,2.92,0,0,1,.8.1,46.42,46.42,0,0,0,6.07,1.45,1.77,1.77,0,0,1,1.36,1.32l1,5.19a.94.94,0,0,0,.87.73h11.42a1,1,0,0,0,.88-.73l1-5.19a1.77,1.77,0,0,1,1.36-1.32,48.51,48.51,0,0,0,6.07-1.44,3.17,3.17,0,0,1,2,.11l7.87,3.65a1.8,1.8,0,0,0,1.47-.07l7.76-4.48c.14-.08.22-.18.22-.28a.36.36,0,0,0-.19-.3l-6.15-4.43a1.08,1.08,0,0,1-.47-.78,1.15,1.15,0,0,1,.31-.89,15,15,0,0,0,2.16-3,2.18,2.18,0,0,1,1.62-1.07l10.35-.65a.77.77,0,0,0,.7-.76v-5.77a.75.75,0,0,0-.7-.75L204.14,427a2.18,2.18,0,0,1-1.62-1.07,15.26,15.26,0,0,0-2.16-3,1.17,1.17,0,0,1-.31-.89,1.08,1.08,0,0,1,.47-.78l6.15-4.43a.37.37,0,0,0,.19-.31c0-.1-.08-.2-.22-.28l-7.76-4.48a1.88,1.88,0,0,0-1.47-.07l-7.87,3.65a3.15,3.15,0,0,1-2,.12,46.58,46.58,0,0,0-6.08-1.44,1.76,1.76,0,0,1-1.36-1.33l-1-5.18a1,1,0,0,0-.88-.73H166.83a.93.93,0,0,0-.87.73l-1,5.18a1.76,1.76,0,0,1-1.36,1.33,46.42,46.42,0,0,0-6.07,1.44,3.18,3.18,0,0,1-2-.12l-7.87-3.65a1.85,1.85,0,0,0-1.46.07l-7.77,4.48c-.14.08-.22.18-.22.28a.37.37,0,0,0,.19.31l6.16,4.43a1.1,1.1,0,0,1,.15,1.67,15.68,15.68,0,0,0-2.16,3,2.18,2.18,0,0,1-1.62,1.07l-10.34.66a.76.76,0,0,0-.71.75v5.77a.78.78,0,0,0,.71.76l10.34.65a2.18,2.18,0,0,1,1.62,1.07,15.74,15.74,0,0,0,2.16,3,1.09,1.09,0,0,1-.16,1.67l-6.15,4.43a.36.36,0,0,0-.19.3c0,.1.08.2.22.28l7.77,4.48a1.77,1.77,0,0,0,1.46.07l7.87-3.64A3,3,0,0,1,156.74,447Zm15.8-4.75a27.07,27.07,0,0,1-13.25-3.16c-3.59-2.07-5.57-4.85-5.57-7.81s2-5.74,5.57-7.81c7.31-4.22,19.2-4.22,26.5,0,3.6,2.07,5.57,4.84,5.57,7.81s-2,5.73-5.57,7.81A27.07,27.07,0,0,1,172.54,442.22Zm0-21.4a26.51,26.51,0,0,0-13,3.1c-3.41,2-5.29,4.57-5.29,7.33s1.88,5.36,5.29,7.33c7.16,4.13,18.8,4.13,26,0,3.41-2,5.29-4.58,5.29-7.33s-1.88-5.36-5.29-7.33A26.51,26.51,0,0,0,172.54,420.82Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "172.535px 431.25px",
              }}
              id="elbyngch1t15"
              className="animable"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="freepik--Arrow--inject-835"
      className="animable"
      style={{
        transformOrigin: "321.93px 72.4278px",
      }}
    >
      <g
        id="freepik--arrow--inject-835"
        className="animable"
        style={{
          transformOrigin: "321.93px 72.4278px",
        }}
      >
        <polygon
          points="363.74 79.52 359.68 81.86 359.68 86.55 367.8 81.86 363.74 79.52"
          style={{
            fill: "#213E60",
            transformOrigin: "363.74px 83.035px",
          }}
          id="elae50289o716"
          className="animable"
        />
        <g id="elqjp039vsk4">
          <polygon
            points="363.74 79.52 359.68 81.86 359.68 86.55 367.8 81.86 363.74 79.52"
            style={{
              opacity: 0.15,
              transformOrigin: "363.74px 83.035px",
            }}
            className="animable"
            id="elrrx5c5weq0o"
          />
        </g>
        <path
          d="M343.43,95.93V57.28a7.46,7.46,0,0,0-7.15-7.46,8.07,8.07,0,0,1,1.19.15,7.35,7.35,0,0,1,1.9,5V93.59l-8.13,4.69,16.25,14.07,4.06,2.35L335.3,100.62Z"
          style={{
            fill: "#213E60",
            transformOrigin: "341.395px 82.26px",
          }}
          id="el04mc593q0mjo"
          className="animable"
        />
        <g id="ely4oqo2avjz">
          <path
            d="M343.43,95.93V57.28a7.46,7.46,0,0,0-7.15-7.46,8.07,8.07,0,0,1,1.19.15,7.35,7.35,0,0,1,1.9,5V93.59l-8.13,4.69,16.25,14.07,4.06,2.35L335.3,100.62Z"
            style={{
              opacity: 0.15,
              transformOrigin: "341.395px 82.26px",
            }}
            className="animable"
            id="elb2mywd59kkm"
          />
        </g>
        <g id="eloyfwbvrzw1p">
          <polygon
            points="335.3 100.62 351.55 114.69 347.49 112.35 331.24 98.28 335.3 100.62"
            style={{
              opacity: 0.25,
              transformOrigin: "341.395px 106.485px",
            }}
            className="animable"
            id="eld2s9j10e5tr"
          />
        </g>
        <g id="el0ccwbd9fqw0a">
          <path
            d="M343.42,95.93h0V57.28a7.44,7.44,0,0,0-6-7.3,7.31,7.31,0,0,1,1.9,5V93.59Z"
            style={{
              opacity: 0.25,
              transformOrigin: "340.42px 72.955px",
            }}
            className="animable"
            id="el83s9577yfr7"
          />
        </g>
        <path
          d="M348.22,35.37l-3.81-2.2a22.11,22.11,0,0,0-22.29,0L276.06,59.77v4.68l50.11-28.92A22.12,22.12,0,0,1,348.22,35.37Z"
          style={{
            fill: "#213E60",
            transformOrigin: "312.14px 47.3028px",
          }}
          id="elh59e85fe4a"
          className="animable"
        />
        <g id="el26voe3mpe9z">
          <g
            style={{
              opacity: 0.2,
              transformOrigin: "312.14px 47.3028px",
            }}
            className="animable"
            id="el85w5gseupu"
          >
            <path
              d="M348.22,35.37l-3.81-2.2a22.11,22.11,0,0,0-22.29,0L276.06,59.77v4.68l50.11-28.92A22.12,22.12,0,0,1,348.22,35.37Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "312.14px 47.3028px",
              }}
              id="elpiml4wgy6g"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M276.06,64.45l50.12-28.92a22.33,22.33,0,0,1,33.49,19.34V86.55l8.13-4.69-16.25,32.83L335.3,100.62l8.12-4.69V57.28a7.46,7.46,0,0,0-11.2-6.47L276.06,83.23Z"
          style={{
            fill: "#213E60",
            transformOrigin: "321.93px 73.6156px",
          }}
          id="elv4vp3qevizf"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--Character--inject-835"
      className="animable"
      style={{
        transformOrigin: "315.085px 313.806px",
      }}
    >
      <g
        id="freepik--character--inject-835"
        className="animable"
        style={{
          transformOrigin: "315.085px 313.806px",
        }}
      >
        <g
          id="freepik--Chair--inject-835"
          className="animable"
          style={{
            transformOrigin: "265px 309.364px",
          }}
        >
          <path
            d="M319.14,369.07l-9.39-54.16-5.94-.3,12.34,54.46h0a.84.84,0,0,0,.4.53,2.36,2.36,0,0,0,2.12.1.7.7,0,0,0,.46-.63Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "311.475px 342.257px",
            }}
            id="elfrtwu05p32"
            className="animable"
          />
          <path
            d="M230.8,306h-5.94l-14,56.26h0a.72.72,0,0,0,.43.66,2.39,2.39,0,0,0,2.12,0,.84.84,0,0,0,.43-.52h0Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "220.83px 334.584px",
            }}
            id="elbqsp7p0m45a"
            className="animable"
          />
          <path
            d="M271.94,394.89l-.26-60.67-5.94-.3,3.21,61h0a.84.84,0,0,0,.4.53,2.34,2.34,0,0,0,2.11.11.73.73,0,0,0,.47-.63Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "268.84px 364.84px",
            }}
            id="ellqyttw2prj"
            className="animable"
          />
          <path
            d="M263.27,287.13h-5.95l-9.52,59.78h0a.75.75,0,0,0,.44.66,2.39,2.39,0,0,0,2.12,0,.86.86,0,0,0,.42-.51h0Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "255.535px 317.474px",
            }}
            id="elf8c8uqcv1xm"
            className="animable"
          />
          <g
            id="freepik--chair--inject-835"
            className="animable"
            style={{
              transformOrigin: "261.754px 281.348px",
            }}
          >
            <path
              d="M213.68,240.31a33.82,33.82,0,0,0-2.38,10.44c-.67,8,2,33.93,3.66,45.52h0c2.35,19.37,5.24,19.41,9.44,22.65,7.21,5.58,28,16.51,34.83,19.21,12.43,4.89,22.59-2.65,30.16-6.39a175.61,175.61,0,0,0,20.06-11.89c1.89-1.37,2.88-2.77,2.86-4.23,0-.58,0-3,0-3.58,0-1.87-1.65-3.87-5.12-6.13-6.42-4.16-29.62-17.69-38.61-22.67a.09.09,0,0,0-.07-.07c-6.92-4.2-11.08-32.74-15.87-47.92-.1-.33-.2-.64-.31-1s-.17-.47-.25-.7c-.3-.83-.61-1.58-.94-2.28"
              style={{
                fill: "#213E60",
                transformOrigin: "261.752px 285.499px",
              }}
              id="el53042d1smmi"
              className="animable"
            />
            <path
              d="M312.31,312c0-1.87-1.65-3.87-5.12-6.13-6.42-4.16-29.62-17.69-38.61-22.67a.09.09,0,0,0-.07-.07c-6.92-4.2-11.08-32.74-15.87-47.92a26.71,26.71,0,0,0-1-2.8l-.09-.2-.27-.62c-.05-.1-.09-.21-.14-.31h0a14.54,14.54,0,0,0-3.19-4.61,7.26,7.26,0,0,0-1.57-1.1L243.55,224c-4.7-2.81-10.86.56-18.54,4.77-4.77,2.62-8.85,5.73-11.33,11.53h0a33.82,33.82,0,0,0-2.38,10.44c-.67,8,2,33.93,3.66,45.52h0c2.35,19.37,5.24,19.41,9.44,22.65,7.21,5.58,28,16.51,34.83,19.21,12.43,4.89,22.59-2.65,30.16-6.39a175.61,175.61,0,0,0,20.06-11.89c1.89-1.37,2.88-2.77,2.86-4.23C312.3,315,312.31,312.65,312.31,312Z"
              style={{
                fill: "#213E60",
                transformOrigin: "261.752px 281.343px",
              }}
              id="el3augzu5pa0w"
              className="animable"
            />
            <g id="el4ahan6ywy6z">
              <path
                d="M312.31,312c0-1.87-1.65-3.87-5.12-6.13-6.42-4.16-29.62-17.69-38.61-22.67a.09.09,0,0,0-.07-.07c-6.92-4.2-11.08-32.74-15.87-47.92a26.71,26.71,0,0,0-1-2.8l-.09-.2-.27-.62c-.05-.1-.09-.21-.14-.31h0a14.54,14.54,0,0,0-3.19-4.61,7.26,7.26,0,0,0-1.57-1.1L243.55,224c-4.7-2.81-10.86.56-18.54,4.77-4.77,2.62-8.85,5.73-11.33,11.53h0a33.82,33.82,0,0,0-2.38,10.44c-.67,8,2,33.93,3.66,45.52h0c2.35,19.37,5.24,19.41,9.44,22.65,7.21,5.58,28,16.51,34.83,19.21,12.43,4.89,22.59-2.65,30.16-6.39a175.61,175.61,0,0,0,20.06-11.89c1.89-1.37,2.88-2.77,2.86-4.23C312.3,315,312.31,312.65,312.31,312Z"
                style={{
                  opacity: 0.15,
                  transformOrigin: "261.752px 281.343px",
                }}
                className="animable"
                id="el2ikk05t9u9o"
              />
            </g>
            <path
              d="M289.39,328.13a176.2,176.2,0,0,0,20.06-11.89c4.31-3.13,3.91-6.33-2.26-10.33-8.58-5.57-43.54-25.41-43.54-25.41s-44.2,26.09-42.3,30.9,29.26,19.72,37.88,23.11C271.66,339.4,281.82,331.86,289.39,328.13Z"
              style={{
                fill: "#213E60",
                transformOrigin: "266.802px 308.305px",
              }}
              id="elngitllfdmi"
              className="animable"
            />
            <g id="elpb5w2zeygbh">
              <path
                d="M289.39,328.13a176.2,176.2,0,0,0,20.06-11.89c4.31-3.13,3.91-6.33-2.26-10.33-8.58-5.57-43.54-25.41-43.54-25.41s-44.2,26.09-42.3,30.9,29.26,19.72,37.88,23.11C271.66,339.4,281.82,331.86,289.39,328.13Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: 0.3,
                  transformOrigin: "266.802px 308.305px",
                }}
                className="animable"
                id="el1eygwup3eba"
              />
            </g>
            <path
              d="M246.37,225.6c-4.65-2.45-10.7.87-18.18,5-4.79,2.63-8.87,5.74-11.35,11.56l-3.16-1.82c2.48-5.8,6.56-8.91,11.33-11.53,7.68-4.21,13.84-7.58,18.54-4.77Z"
              style={{
                fill: "#213E60",
                transformOrigin: "230.025px 232.584px",
              }}
              id="elze54mwzkk4"
              className="animable"
            />
            <g id="elmjxq7nk2tdp">
              <path
                d="M246.37,225.6c-4.65-2.45-10.7.87-18.18,5-4.79,2.63-8.87,5.74-11.35,11.56l-3.16-1.82c2.48-5.8,6.56-8.91,11.33-11.53,7.68-4.21,13.84-7.58,18.54-4.77Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: 0.3,
                  transformOrigin: "230.025px 232.584px",
                }}
                className="animable"
                id="el93tvgwdqkav"
              />
            </g>
            <path
              d="M252.64,235.24c-.1-.33-1.7-5.9-4.7-8.54a7.55,7.55,0,0,0-5.09-1.94c-4.06,0-8.94,2.68-14.66,5.81-.48.27-.95.53-1.41.81l-.53.32c-.22.12-.43.26-.64.39l-.46.31a26.55,26.55,0,0,0-2.88,2.18l-.43.4a17.53,17.53,0,0,0-1.63,1.7c-.1.1-.19.21-.28.32l-.32.4-.32.42q-.15.19-.3.42a21,21,0,0,0-1.15,1.83l-.13.24-.27.52c-.13.26-.25.51-.37.77a33,33,0,0,0-2.59,11c-1.11,13.15,3.4,56.61,7.92,60.36,0,0-.7-4.25,8.4-10,6.18-3.89,10.52-7.16,17.12-10.39,16.08-7.9,20.59-9.38,20.59-9.38C261.59,279,257.43,250.42,252.64,235.24Z"
              style={{
                fill: "#213E60",
                transformOrigin: "241.41px 268.86px",
              }}
              id="elxquoiw6pqt"
              className="animable"
            />
            <g id="el5gr09zsei1n">
              <path
                d="M252.64,235.24c-.1-.33-1.7-5.9-4.7-8.54a7.55,7.55,0,0,0-5.09-1.94c-4.06,0-8.94,2.68-14.66,5.81-.48.27-.95.53-1.41.81l-.53.32c-.22.12-.43.26-.64.39l-.46.31a26.55,26.55,0,0,0-2.88,2.18l-.43.4a17.53,17.53,0,0,0-1.63,1.7c-.1.1-.19.21-.28.32l-.32.4-.32.42q-.15.19-.3.42a21,21,0,0,0-1.15,1.83l-.13.24-.27.52c-.13.26-.25.51-.37.77a33,33,0,0,0-2.59,11c-1.11,13.15,3.4,56.61,7.92,60.36,0,0-.7-4.25,8.4-10,6.18-3.89,10.52-7.16,17.12-10.39,16.08-7.9,20.59-9.38,20.59-9.38C261.59,279,257.43,250.42,252.64,235.24Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: 0.1,
                  transformOrigin: "241.41px 268.86px",
                }}
                className="animable"
                id="elj20zcgcy0w"
              />
            </g>
          </g>
        </g>
        <g
          id="freepik--Bottom--inject-835"
          className="animable"
          style={{
            transformOrigin: "274.52px 340.044px",
          }}
        >
          <path
            d="M277.4,330.6l8.43-11L299,329.25c-8.75,5.93-18.36,13.33-20.73,16.19,0,0-7.45-3.17-7.94-7.35S275.06,331.52,277.4,330.6Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: "284.649px 332.52px",
            }}
            id="el3h2gs2rdzn"
            className="animable"
          />
          <path
            d="M267.76,333.74a6.46,6.46,0,0,0-2.07,1.56c-.64.65-1.15,4.27-1.94,5.85s-1.24,2-2.43,3.9c-1.32,2.16-3.35,4-2.61,10.27s3.17,9.7,5.39,11.62a6.66,6.66,0,0,0,2.88,1.29s3.5-.62,3.36-2.65S267.76,333.74,267.76,333.74Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "264.448px 350.985px",
            }}
            id="el7vvad52nphk"
            className="animable"
          />
          <path
            d="M280.9,343c-.2.59-1.24,1.38-1.68,1.81a16.61,16.61,0,0,0-3.23,5.57c-3.69,9.07-.83,14.56-6.57,17.15-1.64.65-4.64-.17-8.17-7-1.81-3.48-2-10-.54-12.63s3.05-4.26,4.06-6.32,1.44-6.18,3-7.82a9,9,0,0,1,3.42-2c1-.38,3.1-.73,4.12-1.08s1.63-.85,2.1-.07l-1.31,1.11c-2.08,2-1.68,2.4-1.87,3.63a18.85,18.85,0,0,1-1.34,3.77c1.46-1.27,2.18-2.48,3.42-2s1.41.44,2.93,2.51S281.08,342.43,280.9,343Z"
            style={{
              fill: "#213E60",
              transformOrigin: "270.342px 348.954px",
            }}
            id="elzooe44xziss"
            className="animable"
          />
          <g id="eladcln9ak5m">
            <path
              d="M280.9,343c-.2.59-1.24,1.38-1.68,1.81a16.61,16.61,0,0,0-3.23,5.57c-3.69,9.07-.83,14.56-6.57,17.15-1.64.65-4.64-.17-8.17-7-1.81-3.48-2-10-.54-12.63s3.05-4.26,4.06-6.32,1.44-6.18,3-7.82a9,9,0,0,1,3.42-2c1-.38,3.1-.73,4.12-1.08s1.63-.85,2.1-.07l-1.31,1.11c-2.08,2-1.68,2.4-1.87,3.63a18.85,18.85,0,0,1-1.34,3.77c1.46-1.27,2.18-2.48,3.42-2s1.41.44,2.93,2.51S281.08,342.43,280.9,343Z"
              style={{
                opacity: 0.4,
                transformOrigin: "270.342px 348.954px",
              }}
              className="animable"
              id="elr9z9sjpjbu9"
            />
          </g>
          <g id="eliav1pxmtx2r">
            <path
              d="M261.25,360.51c-1.81-3.48-2-10-.54-12.63a24.72,24.72,0,0,1,1.6-2.53c-.08.18-.17.36-.23.52-.13.36-.24.72-.35,1.08a8.55,8.55,0,0,0-.32,4.37c.31,1.27,1,4.45,2.57,4.81a2.43,2.43,0,0,0,2.35-1.47c.22-.4.68-1.5.68-1.5a14.32,14.32,0,0,1,3.81,2.45c2,1.95,1.87,2.28,1.87,2.28a6,6,0,0,0-.45,2,5,5,0,0,0,.48,2.17,2.87,2.87,0,0,0,.5.58,6.23,6.23,0,0,1-3.8,4.85C267.78,368.14,264.78,367.32,261.25,360.51Z"
              style={{
                opacity: 0.3,
                transformOrigin: "266.479px 356.511px",
              }}
              className="animable"
              id="eliexte2hiu8"
            />
          </g>
          <path
            d="M276,350.34a32.14,32.14,0,0,0-2,7.43c-1.32,2.25-2.07,2-1.94.77s2.77-6.16,4.81-10.22C276.55,349,276.26,349.68,276,350.34Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "274.458px 353.894px",
            }}
            id="elhkgsfqvfbu"
            className="animable"
          />
          <path
            d="M273.07,334.14a5.33,5.33,0,0,1,1.57-3.28l.66-.19c1.1-.38,1.63-.85,2.1-.07l-1.31,1.11c-2.08,2-1.68,2.4-1.87,3.63a18.85,18.85,0,0,1-1.34,3.77c-1.72,3.91-2.85,5.12-4,8.9s-.88,6.53-1.47,6.65-1.61-.53-1.23-3.67,2.72-8.09,4.14-10.38S273,335.83,273.07,334.14Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "271.749px 342.426px",
            }}
            id="el5qnfu28khkv"
            className="animable"
          />
          <path
            d="M266.68,353.38a.37.37,0,0,0,.18.14,9.44,9.44,0,0,1,5.51,4.78.39.39,0,0,0,.68-.39,10.15,10.15,0,0,0-5.9-5.11.39.39,0,0,0-.51.21A.4.4,0,0,0,266.68,353.38Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "269.857px 355.633px",
            }}
            id="elblamrzin4q5"
            className="animable"
          />
          <path
            d="M267.77,350.24a.35.35,0,0,0,.17.15,10.53,10.53,0,0,1,5.78,5.17.39.39,0,0,0,.55.14.4.4,0,0,0,.15-.55,11.34,11.34,0,0,0-6.15-5.5.4.4,0,0,0-.5.59Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "271.086px 352.686px",
            }}
            id="els8mgkfcz8hn"
            className="animable"
          />
          <path
            d="M268.36,346.68a.46.46,0,0,0,.2.16,12,12,0,0,1,6.45,5.8.45.45,0,0,0,.77-.45,12.9,12.9,0,0,0-6.87-6.17.45.45,0,0,0-.58.23A.44.44,0,0,0,268.36,346.68Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "272.051px 349.4px",
            }}
            id="el8mc1ct3cc4i"
            className="animable"
          />
          <path
            d="M269.44,343.74a.49.49,0,0,0,.19.16,11.6,11.6,0,0,1,6.31,5.66.45.45,0,0,0,.6.16.43.43,0,0,0,.16-.59,12.5,12.5,0,0,0-6.72-6,.43.43,0,0,0-.57.22A.42.42,0,0,0,269.44,343.74Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "273.067px 346.434px",
            }}
            id="elzfp9c9db3sk"
            className="animable"
          />
          <path
            d="M271.11,341a.43.43,0,0,0,.19.16,11.69,11.69,0,0,1,6.31,5.67.42.42,0,0,0,.59.15.43.43,0,0,0,.16-.59,12.53,12.53,0,0,0-6.72-6,.43.43,0,0,0-.57.22A.44.44,0,0,0,271.11,341Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "274.73px 343.698px",
            }}
            id="elabkeubrm47u"
            className="animable"
          />
          <path
            d="M270.38,280.92s33.87,7.48,46.16,10.82c12.54,3.4,11.22,13.14,6.55,18.08-8.94,9.48-34.36,26.94-34.36,26.94s-7.2-4.43-7.75-11.08l7-9.87-25.24-3.08-3.59-4.36Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "292.786px 308.84px",
            }}
            id="el1u2hq3j0eyl"
            className="animable"
          />
          <path
            d="M294.07,326.59c-1.79-4.16-3.38-5.44-7.79-8.41l-5.3,7.5c.55,6.65,7.75,11.08,7.75,11.08s2.93-2,7.15-5A49.44,49.44,0,0,0,294.07,326.59Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "288.43px 327.47px",
            }}
            id="el8hrs1rd1bl"
            className="animable"
          />
          <path
            d="M292.37,305.91c-2.2,1.93-4.12,3.68-5.82,5.39s-5.58,1.73-9.06,0c-4.32-2.14-8.9-5.79-11.57-7.89,3.93-4.39,2.36-10.82,2.36-10.82-.39,4.17-2.27,7.65-4.29,9.3l-2.13,1.5-.77,6.62,1.19,2.61L288,315.81c7.05-9.16,9.48-13.37,15.38-14.07C303.33,301.74,298.87,300.2,292.37,305.91Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "282.235px 304.2px",
            }}
            id="elfi1xspqff3"
            className="animable"
          />
          <path
            d="M288.05,378.7l-.36-1.21-8.22-21.3,15.5-5.8c2,10.95,4.5,25.4,6.85,29.2,0,0-4.2,6.51-8.34,5.75S288.25,381.2,288.05,378.7Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: "290.645px 367.896px",
            }}
            id="elss24ym9i8g8"
            className="animable"
          />
          <path
            d="M288.58,386.48a6.42,6.42,0,0,0,.89,2.43c.43.8,3.75,2.36,5,3.57s1.51,1.76,3,3.46c1.68,1.89,2.82,4.36,9.06,5.5s10.2-.2,12.69-1.77a6.57,6.57,0,0,0,2.07-2.37s.43-3.53-1.55-4S288.58,386.48,288.58,386.48Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "304.955px 394.173px",
            }}
            id="elfhzyehnxe0i"
            className="animable"
          />
          <path
            d="M301.24,376.6a7.32,7.32,0,0,1,1.24,2.14,16.68,16.68,0,0,0,4.38,4.72c7.6,6.17,13.69,5.05,14.49,11.29.14,1.76-1.52,4.39-9.06,5.78-3.86.71-10.12-1-12.24-3.17s-3.18-4.17-4.86-5.73-5.49-3.19-6.61-5.15a9,9,0,0,1-.9-3.85c-.07-1.07-.1-4.69-.1-4.69,1.29,2.57,3.3,2.29,4.42,2.83a18.78,18.78,0,0,1,3.21,2.38c-.78-1.76-1.73-2.81-.92-3.86s.83-1.22,3.25-2.07S300.78,376.27,301.24,376.6Z"
            style={{
              fill: "#213E60",
              transformOrigin: "304.469px 388.559px",
            }}
            id="elwmna9tnmjg"
            className="animable"
          />
          <g id="elexc2mf5tga">
            <path
              d="M301.24,376.6a7.32,7.32,0,0,1,1.24,2.14,16.68,16.68,0,0,0,4.38,4.72c7.6,6.17,13.69,5.05,14.49,11.29.14,1.76-1.52,4.39-9.06,5.78-3.86.71-10.12-1-12.24-3.17s-3.18-4.17-4.86-5.73-5.49-3.19-6.61-5.15a9,9,0,0,1-.9-3.85c-.07-1.07-.1-4.69-.1-4.69,1.29,2.57,3.3,2.29,4.42,2.83a18.78,18.78,0,0,1,3.21,2.38c-.78-1.76-1.73-2.81-.92-3.86s.83-1.22,3.25-2.07S300.78,376.27,301.24,376.6Z"
              style={{
                opacity: 0.4,
                transformOrigin: "304.469px 388.559px",
              }}
              className="animable"
              id="ell6wy53t7jj"
            />
          </g>
          <g id="elx2lclt1hat8">
            <path
              d="M312.29,400.53c-3.86.71-10.12-1-12.24-3.17a28.34,28.34,0,0,1-2-2.27c.15.12.3.27.44.37.3.22.61.44.92.64a8.63,8.63,0,0,0,4.09,1.59c1.31.07,4.55.35,5.35-1.05a2.42,2.42,0,0,0-.72-2.68c-.32-.33-1.23-1.09-1.23-1.09a14.09,14.09,0,0,1,3.45-2.92c2.46-1.36,2.72-1.13,2.72-1.13a6.48,6.48,0,0,0,1.79,1,5,5,0,0,0,2.22.17,2.61,2.61,0,0,0,.7-.31,6.25,6.25,0,0,1,3.53,5.05C321.49,396.51,319.83,399.14,312.29,400.53Z"
              style={{
                opacity: 0.3,
                transformOrigin: "309.686px 394.749px",
              }}
              className="animable"
              id="elxprz0bfcox"
            />
          </g>
          <path
            d="M306.86,383.46a32.39,32.39,0,0,0,6.52,4.07c1.77,1.92,1.35,2.57.17,2.08s-5.07-4.44-8.36-7.58C305.74,382.53,306.31,383,306.86,383.46Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "309.882px 385.898px",
            }}
            id="elqu1ucr96au"
            className="animable"
          />
          <path
            d="M290.52,381.52a7.13,7.13,0,0,1-2.88-1.45c-.54-.49-.17-1.94.05-2.58l.41,1.29a13.17,13.17,0,0,0,3.9,2,18.78,18.78,0,0,1,3.21,2.38c3.25,2.79,4.07,4.22,7.34,6.45s6,2.75,5.93,3.35-1,1.38-3.87.11-6.94-5-8.72-7S292.1,382.12,290.52,381.52Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "297.921px 385.621px",
            }}
            id="eljpajypmiqj"
            className="animable"
          />
          <path
            d="M307.05,393.25a.41.41,0,0,0,.19-.13,9.42,9.42,0,0,1,6.17-3.87.39.39,0,0,0-.17-.77,10.2,10.2,0,0,0-6.61,4.15.4.4,0,0,0,.06.55A.39.39,0,0,0,307.05,393.25Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "310.132px 390.869px",
            }}
            id="elebo7n32j2tp"
            className="animable"
          />
          <path
            d="M304.37,391.29a.39.39,0,0,0,.19-.12,10.57,10.57,0,0,1,6.63-4,.38.38,0,0,0,.3-.48.4.4,0,0,0-.48-.3,11.31,11.31,0,0,0-7.06,4.27.4.4,0,0,0,0,.57A.41.41,0,0,0,304.37,391.29Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "307.668px 388.851px",
            }}
            id="elmjhlu0ykjsl"
            className="animable"
          />
          <path
            d="M301.13,389.68a.46.46,0,0,0,.21-.13,12,12,0,0,1,7.43-4.48.45.45,0,0,0,.34-.53.46.46,0,0,0-.54-.34,12.82,12.82,0,0,0-7.9,4.77.43.43,0,0,0,.05.62A.42.42,0,0,0,301.13,389.68Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "304.84px 386.945px",
            }}
            id="el3p86ilvipkc"
            className="animable"
          />
          <path
            d="M298.64,387.79a.39.39,0,0,0,.2-.13,11.61,11.61,0,0,1,7.27-4.38.45.45,0,0,0,.32-.53.43.43,0,0,0-.52-.32,12.54,12.54,0,0,0-7.73,4.66.44.44,0,0,0,.46.7Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "302.262px 385.112px",
            }}
            id="el3m0jrw9980b"
            className="animable"
          />
          <path
            d="M296.5,385.4a.46.46,0,0,0,.2-.14,11.65,11.65,0,0,1,7.26-4.38.44.44,0,1,0-.19-.85A12.55,12.55,0,0,0,296,384.7a.42.42,0,0,0,0,.61A.44.44,0,0,0,296.5,385.4Z"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "300.118px 382.721px",
            }}
            id="el8xnif01uekb"
            className="animable"
          />
          <path
            d="M299.62,369.85c-4.07,4.23-13.86,3.92-13.86,3.92s-2.82-5.38-7.9-17.15c-2.84-6.57-4.43-9.56-5.63-18.73-8.62-4.23-24-10.29-38.48-21.16C223.34,309,221.7,298.39,223,285.87c1.62-15.38,46.79-2.81,46.79-2.81-3,8.34-2.31,16.55-7.95,20.33,0,0,18.19,13.05,24.32,17.71,2.82,2.14,4.15,2.84,5.51,9.32C295.66,349.42,299.62,369.85,299.62,369.85Z"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "261.119px 325.998px",
            }}
            id="elffzmd4z3y8a"
            className="animable"
          />
          <path
            d="M287.91,373.73l.81-.06c-3.13-5.87-7.85-18.48-9.61-23.91-.57-1.77-1.75-6.76-2.1-8.12-1.66-6.53-1.9-8.9-3.69-9.51-.45-.15-1.44-.74-3-1.5-7.87-3.91-26.92-13.58-33.5-19.76l-.56-.57c3.32-1.91,4.35-7,3.15-10.57-1.29-3.85-1.2-10.81.83-13.67l-.59-.42c-2.37,3.34-2.13,10.71-.93,14.32,1.13,3.37.08,8.19-3,9.81-6.13-6.55-7.72-15.57-4.55-26.21l-.69-.21c-3.43,11.53-1.41,21.23,5.84,28,6.65,6.26,25.77,16,33.67,19.88,1.48.74,2.56,1.27,3,1.49,1.7.93,2.32,5.42,3.31,9.18.36,1.37,1.54,6.31,2.15,8.09C280.34,355.54,285,368,287.91,373.73Z"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "258.787px 328.54px",
            }}
            id="elzc1v4jr5yb"
            className="animable"
          />
        </g>
        <g
          id="freepik--Desk--inject-835"
          className="animable"
          style={{
            transformOrigin: "315.085px 345.504px",
          }}
        >
          <polygon
            points="307.33 354.59 304.6 353.01 297.5 442.41 300.23 443.99 307.33 354.59"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "302.415px 398.5px",
            }}
            id="el3xy1e6qtfso"
            className="animable"
          />
          <polygon
            points="307.33 354.59 311.43 352.23 302.97 442.41 300.23 443.99 307.33 354.59"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "305.83px 398.11px",
            }}
            id="ele5l4dp0kymr"
            className="animable"
          />
          <polygon
            points="385.31 309.59 382.57 308.01 391.03 388.43 393.76 390 385.31 309.59"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "388.165px 349.005px",
            }}
            id="el60ih5bozc04"
            className="animable"
          />
          <polygon
            points="385.31 309.59 389.4 307.23 396.5 388.43 393.76 390 385.31 309.59"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "390.905px 348.615px",
            }}
            id="el2m1kxte2exk"
            className="animable"
          />
          <polygon
            points="247.06 319.78 244.32 318.2 237.22 407.6 239.96 409.18 247.06 319.78"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "242.14px 363.69px",
            }}
            id="elnavl4u1k0oj"
            className="animable"
          />
          <polygon
            points="247.06 319.79 251.15 317.42 242.69 407.6 239.96 409.18 247.06 319.79"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "245.555px 363.3px",
            }}
            id="elhotfm2btz5"
            className="animable"
          />
          <polygon
            points="325.03 274.79 322.3 273.21 330.75 353.62 333.49 355.2 325.03 274.79"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "327.895px 314.205px",
            }}
            id="elg82xav6xd8"
            className="animable"
          />
          <polygon
            points="325.03 274.79 329.13 272.42 336.22 353.62 333.49 355.2 325.03 274.79"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "330.625px 313.81px",
            }}
            id="elgmo36p4o5s"
            className="animable"
          />
          <g
            id="freepik--desk--inject-835"
            className="animable"
            style={{
              transformOrigin: "315.085px 310.425px",
            }}
          >
            <path
              d="M209.34,325.41v-3.24a1.83,1.83,0,0,1,.83-1.44l127.27-73.5a1.82,1.82,0,0,1,1.67,0L420,294a1.84,1.84,0,0,1,.83,1.44v3.24a1.83,1.83,0,0,1-.83,1.44L292.7,373.63a1.82,1.82,0,0,1-1.67,0l-80.86-46.78A1.84,1.84,0,0,1,209.34,325.41Z"
              style={{
                fill: "#213E60",
                transformOrigin: "315.085px 310.43px",
              }}
              id="elf0ilrxvro2"
              className="animable"
            />
            <g id="ele0y674mzbw6">
              <path
                d="M209.34,325.41v-3.24a1.83,1.83,0,0,1,.83-1.44l127.27-73.5a1.82,1.82,0,0,1,1.67,0L420,294a1.84,1.84,0,0,1,.83,1.44v3.24a1.83,1.83,0,0,1-.83,1.44L292.7,373.63a1.82,1.82,0,0,1-1.67,0l-80.86-46.78A1.84,1.84,0,0,1,209.34,325.41Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: 0.2,
                  transformOrigin: "315.085px 310.43px",
                }}
                className="animable"
                id="eln9vgx0io3yb"
              />
            </g>
            <path
              d="M291.87,368.67v5.16a1.76,1.76,0,0,1-.84-.19l-80.86-46.79a1.84,1.84,0,0,1-.83-1.44v-3.24a1.83,1.83,0,0,1,.68-1.33c-.3.25-.25.61.15.85L291,368.48A1.76,1.76,0,0,0,291.87,368.67Z"
              style={{
                fill: "#213E60",
                transformOrigin: "250.605px 347.335px",
              }}
              id="elzxc5wfkxdj"
              className="animable"
            />
            <path
              d="M210.17,321.69,291,368.47a1.82,1.82,0,0,0,1.67,0L420,295c.46-.26.46-.69,0-1l-80.86-46.78a1.82,1.82,0,0,0-1.67,0l-127.27,73.5C209.71,321,209.71,321.42,210.17,321.69Z"
              style={{
                fill: "#213E60",
                transformOrigin: "315.087px 307.845px",
              }}
              id="el2gowcq20yam"
              className="animable"
            />
            <g id="el0qpkfdoxx1x">
              <path
                d="M210.17,321.69,291,368.47a1.82,1.82,0,0,0,1.67,0L420,295c.46-.26.46-.69,0-1l-80.86-46.78a1.82,1.82,0,0,0-1.67,0l-127.27,73.5C209.71,321,209.71,321.42,210.17,321.69Z"
                style={{
                  fill: "rgb(255, 255, 255)",
                  opacity: 0.5,
                  transformOrigin: "315.087px 307.845px",
                }}
                className="animable"
                id="elkthoplba7mm"
              />
            </g>
          </g>
        </g>
        <g
          id="freepik--Laptop--inject-835"
          className="animable"
          style={{
            transformOrigin: "312.299px 297.508px",
          }}
        >
          <g
            id="freepik--laptop--inject-835"
            className="animable"
            style={{
              transformOrigin: "312.299px 297.508px",
            }}
          >
            <g id="el5vhxstrof8i">
              <path
                d="M358.28,290.83l-32.86-19a1.88,1.88,0,0,0-1.89,0l-57,32.91a.42.42,0,0,0,0,.73l33.17,19.15Z"
                style={{
                  opacity: 0.2,
                  transformOrigin: "312.299px 298.098px",
                }}
                className="animable"
                id="elmzvdi07cob"
              />
            </g>
            <path
              d="M353.62,288.06v.7a2.93,2.93,0,0,1-1.45,2.53l-50.92,29.39a2.9,2.9,0,0,1-1.45.39,2.93,2.93,0,0,1-1.46-.39l-27.76-16a2.94,2.94,0,0,1-1.45-2.52v-1h0a.38.38,0,0,0,.18.32l30.48,17.6Z"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "311.375px 304.565px",
              }}
              id="el0okq5kc2k08"
              className="animable"
            />
            <path
              d="M353.63,288.05l-30.19-17.42a1.74,1.74,0,0,0-1.74,0l-52.38,30.24a.39.39,0,0,0,0,.67l30.48,17.59Z"
              style={{
                fill: "rgb(69, 90, 100)",
                transformOrigin: "311.38px 294.763px",
              }}
              id="eli6zb4zwi38"
              className="animable"
            />
            <polygon
              points="299.52 316.57 283.24 307.18 330.85 279.69 347.22 289.03 299.52 316.57"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "315.23px 298.13px",
              }}
              id="ely47rt7933h"
              className="animable"
            />
            <polygon
              points="347.22 289.03 346.6 289.39 330.85 280.4 283.86 307.54 283.24 307.18 330.85 279.69 347.22 289.03"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "315.23px 293.615px",
              }}
              id="eldo0f02l45ww"
              className="animable"
            />
            <polygon
              points="291.52 290.44 291.82 290.62 299.8 295.23 313.99 287.03 314.29 286.86 306.01 282.08 291.52 290.44"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "302.905px 288.655px",
              }}
              id="el3nznub6gqs2"
              className="animable"
            />
            <polygon
              points="291.82 290.62 299.8 295.23 313.99 287.03 306.01 282.42 291.82 290.62"
              style={{
                fill: "rgb(55, 71, 79)",
                transformOrigin: "302.905px 288.825px",
              }}
              id="el23f4jahcllp"
              className="animable"
            />
            <path
              d="M299.8,319.13v1.94a2.9,2.9,0,0,0,1.45-.39l50.92-29.39a2.93,2.93,0,0,0,1.46-2.53v-.71Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "326.715px 304.56px",
              }}
              id="elj0tabrhc9ab"
              className="animable"
            />
          </g>
        </g>
        <g
          id="freepik--Arm--inject-835"
          className="animable"
          style={{
            transformOrigin: "286.945px 257.441px",
          }}
        >
          <path
            d="M299.8,264.37c-5-1.94-17.62-7.49-17.62-7.49s-11.36-19-13.85-23c-3-4.79-7.2-8.36-14.1-7.82l1.21,20s12.25,17.58,14.44,20.47c1.67,2.2,1.57,2.82,6,3.74l20.85,4.36.84.25a2.77,2.77,0,0,1,1.45,1,8,8,0,0,1,.92,1.53c.87,1.87.81,2.49,1.7,4.51s1.32,1.83,2.73,3.37,1.87,2.4,2.51,2.25,1-1.77.5-3.15-1.82-2.61-2-3.19-.16-1.4,1.41-1.06,5,3.37,6.5,4.67,2.76,3.27,4.14,4.11,1.31-.59,1.4-1.82,1.35-3.1,1.35-5.05-2.18-6.65-4.16-8.23-5.78-4.31-6.79-4.89A57.23,57.23,0,0,0,299.8,264.37Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: "287.205px 257.589px",
            }}
            id="elkxrs15t539s"
            className="animable"
          />
          <path
            d="M253.71,225.81c3-.27,6.68-.14,9.78,2.28s4.64,4.52,9.22,12.26,6.87,11.72,6.87,11.72a14.58,14.58,0,0,1-5.48,6.61,28.11,28.11,0,0,1-7.91,3.1L254.6,246Z"
            style={{
              fill: "#213E60",
              transformOrigin: "266.645px 243.745px",
            }}
            id="elv3zfo9vies"
            className="animable"
          />
        </g>
        <g
          id="freepik--Top--inject-835"
          className="animable"
          style={{
            transformOrigin: "244.321px 242.709px",
          }}
        >
          <g
            id="freepik--Chest--inject-835"
            className="animable"
            style={{
              transformOrigin: "244.321px 242.709px",
            }}
          >
            <path
              d="M266.43,244.32c-1.21-13.5-5.83-18-12.72-18.51a136,136,0,0,0-15,1.47,59.35,59.35,0,0,0-16.52,6.4c-3.41,2.13-4.5,6.7-4.57,16.26a214.62,214.62,0,0,0,1.79,27.56,143.26,143.26,0,0,0,4.71,23.76c9.51,3.18,47.19-8.35,46.9-20.42-1-2.76-2.68-5.95-3.45-11.55C266.54,259.47,266.82,248.56,266.43,244.32Z"
              style={{
                fill: "rgb(38, 50, 56)",
                transformOrigin: "244.321px 263.803px",
              }}
              id="el7ekjya8wc79"
              className="animable"
            />
            <g
              id="freepik--Head--inject-835"
              className="animable"
              style={{
                transformOrigin: "246.573px 209.743px",
              }}
            >
              <path
                d="M234.14,222.36c-.39-3.81-3.88-8-5.35-11.39s-2.23-5.8-1.85-8.77c.23-1.75,1.5-4.07,2.84-4.49-1.08-6.66,3.95-9,6.22-9.59,1-.28,3.17-.67,4.16-1,1.46-.5,1.85-1.62,3.06-2.52,2.09-1.54,5.41-1.36,6.51,1.26,1.42-1.61,3.2-1.45,5.23-.79a3.52,3.52,0,0,1,2.43,4.14,3.7,3.7,0,0,1,5.39,2.39c.11,1.2-.21,2.19.5,3.32s2.46,1.35,3,.41c.17,1.71-.57,3-2.41,2.74a3.85,3.85,0,0,1,.27,3.27,3.51,3.51,0,0,1-3.34,2.21,6,6,0,0,1-1,2.53,6.14,6.14,0,0,1-2.3,1.81c-2.87,1.14-6,1.37-9,1.8l-3.61.5c-.21,0-1.29,0-1.43.2Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "246.573px 202.991px",
                }}
                id="el8gmr20sp9p5"
                className="animable"
              />
              <path
                d="M229.9,217.18a3.65,3.65,0,0,0,4.45.17l-1,12.42c1.72,5.45,10.75,6.95,14.16,5.66s3.11-3.27,1.16-6.4l.37-2a37,37,0,0,0,4.49.09c3-.21,5.37-2.46,6.42-5.6a33.44,33.44,0,0,0,1.2-12.66,10.87,10.87,0,0,1,.05-3.12,14.81,14.81,0,0,0-.48-6.72c-3.08-2.83-10.55-4.22-17.84-.42.53,4.23-1.31,7.43-4.45,8.82.07,1.13,0,4-1.83,3.82-1.33-.13-1.31-1.81-2.58-3.38s-4.45-2.17-5.83-.08A7.23,7.23,0,0,0,229.9,217.18Z"
                style={{
                  fill: "rgb(255, 168, 167)",
                  transformOrigin: "244.27px 216.071px",
                }}
                id="elqudhipl6ar8"
                className="animable"
              />
              <path
                d="M242.51,205.48l-9,1.85a3.6,3.6,0,0,1,1.19,1.51l7.86-1.28Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "238.035px 207.16px",
                }}
                id="el3xgub27uduc"
                className="animable"
              />
              <path
                d="M263.3,204.38l-.59,0a17.07,17.07,0,0,0-5.89.51c-1.93.69-2.65,1.38-3.7,1.45s-1.75-.58-3.7-1.07a19.1,19.1,0,0,0-6.27.14l-.64.11a1.27,1.27,0,0,0-.84,1.12,2.06,2.06,0,0,0,.44,1.24,1.23,1.23,0,0,1,.15.5,21.68,21.68,0,0,0,.33,3.53,3.75,3.75,0,0,0,.67,1.25,2.1,2.1,0,0,0,.37.36l.22.16a3.15,3.15,0,0,0,.69.33l.11,0,.19.05.19,0a4.19,4.19,0,0,0,.63.07h.61a5.26,5.26,0,0,0,4.69-2.92c.78-1.39.8-3.28,2-3.34h.22c.87.17.6,1.92,1,3.15a4.42,4.42,0,0,0,.73,1.35l.19.21.1.09.11.09.09.08.11.08.09.05a.1.1,0,0,0,0,0,3.34,3.34,0,0,0,1,.39l.1,0a5.09,5.09,0,0,0,1.27.07,4.33,4.33,0,0,0,3.91-2.7,25.53,25.53,0,0,0,1-3.59,1.21,1.21,0,0,1,.25-.48,2.67,2.67,0,0,0,.63-1.31C263.94,204.9,263.62,204.41,263.3,204.38ZM250.41,210A5.11,5.11,0,0,1,249.3,212h0a4.21,4.21,0,0,1-3,1.24,2.6,2.6,0,0,1-2.6-1.24l-.07-.13a.91.91,0,0,1-.07-.14l-.05-.12s0-.07,0-.11l0-.09,0-.08,0-.13h0q0-.21-.09-.39h0c0-.08,0-.16,0-.24s0-.26,0-.37,0,0,0-.08V210c-.09-.93-.1-2.75.39-3.19a5.49,5.49,0,0,1,3.63-.82h.21a6.13,6.13,0,0,1,.86.11l.33.07a7.51,7.51,0,0,1,.83.24l.25.1.27.13.06,0,.1.05a1.42,1.42,0,0,1,.52.46C251,207.73,250.73,209,250.41,210Zm11.39-1a4.78,4.78,0,0,1-2.07,3.13,3.39,3.39,0,0,1-1.48.41,2.7,2.7,0,0,1-2.81-1.27h0l-.05-.09a.47.47,0,0,0,0-.1.17.17,0,0,0,0-.05l-.06-.14-.07-.18s0-.05,0-.08,0,0,0,0a.25.25,0,0,0,0-.07s0,0,0,0a5.27,5.27,0,0,1-.13-.7,4.84,4.84,0,0,1,.32-2.83,6.11,6.11,0,0,1,3.27-1.53,7.7,7.7,0,0,1,.89-.11h.78l.23,0a2.75,2.75,0,0,1,.44.06l.1,0h0l.07,0,.1,0,.13,0,.2.08,0,0a1.34,1.34,0,0,1,.45.28C262.42,206.22,262.06,208.06,261.8,209Z"
                style={{
                  fill: "rgb(55, 71, 79)",
                  transformOrigin: "252.741px 209.222px",
                }}
                id="el7tf7oei7av7"
                className="animable"
              />
              <path
                d="M257.69,214.39l-4.6,2-1.17-7.6c.23-.51.53-.87,1.05-.91h.22l.14.05,0,0,.22.22a12,12,0,0,1,1.45,1.84c.44.67.91,1.41,1.37,2.18l.77,1.3Z"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "254.805px 212.135px",
                }}
                id="eljd89w1rxjeg"
                className="animable"
              />
              <path
                d="M249,227c-4.66-.87-8.18-1.61-10.4-5.17a29.49,29.49,0,0,1-2.46-5.74,22.7,22.7,0,0,0,1.55,7.09c1,2.25,3.7,4.35,11,5.47Z"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "242.57px 222.37px",
                }}
                id="el1j9c45jgniw"
                className="animable"
              />
              <path
                d="M248.57,209.49a1.32,1.32,0,1,1-1.3-1.41A1.37,1.37,0,0,1,248.57,209.49Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "247.252px 209.4px",
                }}
                id="eld9bxwh2gma"
                className="animable"
              />
              <path
                d="M248.2,203.37l-3.11.88a1.69,1.69,0,0,1,1.16-2A1.57,1.57,0,0,1,248.2,203.37Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "246.623px 203.22px",
                }}
                id="el8l20fs3bdjv"
                className="animable"
              />
              <path
                d="M247.48,217.14l4.31,1.59a2.42,2.42,0,0,1-3,1.39A2.25,2.25,0,0,1,247.48,217.14Z"
                style={{
                  fill: "rgb(177, 102, 104)",
                  transformOrigin: "249.549px 218.691px",
                }}
                id="elb1h3fp5cp"
                className="animable"
              />
              <path
                d="M250,220.2a2.72,2.72,0,0,0-2.69-2.42,2.24,2.24,0,0,0,1.43,2.34A2.26,2.26,0,0,0,250,220.2Z"
                style={{
                  fill: "rgb(242, 143, 143)",
                  transformOrigin: "248.648px 219.017px",
                }}
                id="elnwq9x8jipte"
                className="animable"
              />
              <path
                d="M260.13,204.07l-3.21-.58a1.57,1.57,0,0,1,1.84-1.33A1.71,1.71,0,0,1,260.13,204.07Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "258.533px 203.102px",
                }}
                id="elviev7gk2mx"
                className="animable"
              />
              <path
                d="M258.85,209.16a1.32,1.32,0,1,1-1.17-1.51A1.35,1.35,0,0,1,258.85,209.16Z"
                style={{
                  fill: "rgb(38, 50, 56)",
                  transformOrigin: "257.543px 208.963px",
                }}
                id="elrb4i6231w8p"
                className="animable"
              />
            </g>
          </g>
        </g>
        <g
          id="freepik--arm--inject-835"
          className="animable"
          style={{
            transformOrigin: "254.692px 264.882px",
          }}
        >
          <path
            d="M276.52,283.23a22,22,0,0,1,8.47-1c3.22.19,5.76-.69,6.21-.53,1.71.61.63,3.48-3.49,3.95C284.55,286.05,276.52,283.23,276.52,283.23Z"
            style={{
              fill: "rgb(242, 143, 143)",
              transformOrigin: "284.249px 283.685px",
            }}
            id="elvrzzcmiw2hm"
            className="animable"
          />
          <path
            d="M233.65,293.3c7.31,1.08,29,2,30.06,2.21.45.09,2.4.41,2.91.49,1.07.19,2.12.41,3.2.56a8.56,8.56,0,0,0,1.89.14,24,24,0,0,0,4.35-.84,8,8,0,0,1,3.51-.2c1.45.25,2.86.59,4.29.92a5.78,5.78,0,0,0,3.49-.19,9.2,9.2,0,0,0,1.1-.63,6.55,6.55,0,0,1,1.76-.35,2.4,2.4,0,0,0,1.22-.66c.17-.2.22-.55.43-.72a2.17,2.17,0,0,1,1.15-.29,9.07,9.07,0,0,0,1.8-.33c.77-.26,1.88-.82,1.66-1.81-.1-.45-.46-.62-.83-.87-.64-.45-1.33-.88-1.93-1.37-1.4-1.15-3-2.06-4.39-3.2a8.57,8.57,0,0,0-4.3-1.67c-1.64-.26-3.27-.66-4.93-.84-1.36-.16-2.67-.66-4-.33-3.36.8-6.75,2.35-10.25,1.68-5.1-1-27.72-7.1-27.72-7.1l-5.46-20.54s-3.8-18.38-9.59-23.8c-4.18,1.58-8,4.76-9.2,9-1.46,5,.07,9.45,2.94,21.67,2.18,9.27,2.64,10.12,5.15,18.82C224,290.21,224.69,292,233.65,293.3Z"
            style={{
              fill: "rgb(255, 168, 167)",
              transformOrigin: "254.903px 265.162px",
            }}
            id="elmtauarniez"
            className="animable"
          />
          <path
            d="M223.34,233c-4.37,2-9.17,4.74-10.32,11.79s5.49,28.51,5.49,28.51A26.72,26.72,0,0,0,228.57,272c6-1.79,7.29-4.51,7.29-4.51s-2-9.31-3.18-13.65S229.16,238.32,223.34,233Z"
            style={{
              fill: "#213E60",
              transformOrigin: "224.373px 253.176px",
            }}
            id="elog5yck0lu2"
            className="animable"
          />
        </g>
        <path
          d="M300.62,319.56a3.45,3.45,0,0,0,3-.23l50.69-29.27a3.4,3.4,0,0,0,1.68-2.41l5.55-33.09a3.66,3.66,0,0,0,.05-.57,3.47,3.47,0,0,0-1-2.45L307.86,282a2.54,2.54,0,0,0-1.24,1.78Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "331.105px 285.67px",
          }}
          id="elxeisqk2gla"
          className="animable"
        />
        <path
          d="M299.8,319.13l.35.2a2.92,2.92,0,0,0,.47.23l6-35.82a2.54,2.54,0,0,1,1.24-1.78l52.68-30.42a3.75,3.75,0,0,0-.71-.53l-52.78,30.47a2.54,2.54,0,0,0-1.24,1.79Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "330.17px 285.285px",
          }}
          id="elh6ln9tenm56"
          className="animable"
        />
        <path
          d="M307.11,282.64l-.82-.48a2.63,2.63,0,0,0-.48,1.11l-6,35.86.35.2a2.92,2.92,0,0,0,.47.23l6-35.82A2.44,2.44,0,0,1,307.11,282.64Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "303.46px 300.86px",
          }}
          id="el4xdz8g5avfa"
          className="animable"
        />
        <path
          d="M329.17,289c.37-2.22,2.66-5.16,5.11-6.57s4.14-.77,3.76,1.45-2.66,5.16-5.11,6.57S328.8,291.23,329.17,289Z"
          style={{
            fill: "#213E60",
            transformOrigin: "333.606px 286.441px",
          }}
          id="el91byyu58tvh"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--speech-bubble--inject-835"
      className="animable"
      style={{
        transformOrigin: "198.261px 217.545px",
      }}
    >
      <g
        id="freepik--speech-bubble--inject-835"
        className="animable"
        style={{
          transformOrigin: "198.261px 217.545px",
        }}
      >
        <path
          d="M215,203.81a1.39,1.39,0,0,0-.65-.16l-10.87-.77-.9,13.55,5.94,3.42,11.72-11a1.31,1.31,0,0,0-.18-2.11Z"
          style={{
            fill: "#213E60",
            transformOrigin: "211.636px 211.365px",
          }}
          id="eli41ooya7om"
          className="animable"
        />
        <g id="el8zu9keii5w">
          <g
            style={{
              opacity: 0.2,
              transformOrigin: "211.636px 211.365px",
            }}
            className="animable"
            id="el41s4iy8alsl"
          >
            <path
              d="M215,203.81a1.39,1.39,0,0,0-.65-.16l-10.87-.77-.9,13.55,5.94,3.42,11.72-11a1.31,1.31,0,0,0-.18-2.11Z"
              style={{
                fill: "rgb(255, 255, 255)",
                transformOrigin: "211.636px 211.365px",
              }}
              id="elnjxj9iv6g5"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M175.83,242.15a3.9,3.9,0,0,0,1.76,3.06l.55.3a4,4,0,0,0,3.23.15c-.83.32-1.46-.16-1.46-1.17V211.74a3.62,3.62,0,0,1,.51-1.74l-4.07-2.34a3.61,3.61,0,0,0-.52,1.74Z"
          style={{
            fill: "#213E60",
            transformOrigin: "178.6px 226.795px",
          }}
          id="el8wiqg0lqbbc"
          className="animable"
        />
        <g id="elv2etgu7u2fo">
          <path
            d="M175.83,242.15a3.9,3.9,0,0,0,1.76,3.06l.55.3a4,4,0,0,0,3.23.15c-.83.32-1.46-.16-1.46-1.17V211.74a3.62,3.62,0,0,1,.51-1.74l-4.07-2.34a3.61,3.61,0,0,0-.52,1.74Z"
            style={{
              opacity: 0.15,
              transformOrigin: "178.6px 226.795px",
            }}
            className="animable"
            id="elyh10wkhbi3c"
          />
        </g>
        <path
          d="M211.56,191.68a1.62,1.62,0,0,0-.79.24l-29.1,16.76a3.52,3.52,0,0,0-1.24,1.32,3.61,3.61,0,0,0-.52,1.74v32.75c0,.81.39,1.27,1,1.27a1.41,1.41,0,0,0,.43-.08l.06,0a1.77,1.77,0,0,0,.31-.15l5.73-3.32,5.88-3.4,17.64-10.16a2.73,2.73,0,0,0,1.6-2.94V192.94a2.2,2.2,0,0,0-.06-.5.92.92,0,0,0-.91-.76Z"
          style={{
            fill: "#213E60",
            transformOrigin: "196.253px 218.72px",
          }}
          id="el91rowwr2hfm"
          className="animable"
        />
        <path
          d="M208.47,205.78l10.87.76a1.3,1.3,0,0,1,.85,2.29l-11.72,11Z"
          style={{
            fill: "#213E60",
            transformOrigin: "214.559px 212.805px",
          }}
          id="eljis2hnpwua8"
          className="animable"
        />
        <path
          d="M212.47,192.44c-.2-.75-.89-1-1.7-.52l-29.1,16.77a3.49,3.49,0,0,0-1.24,1.31l-4.08-2.34a3.51,3.51,0,0,1,1.25-1.31l29.08-16.77a3.94,3.94,0,0,1,3.54,0l.55.31A3.89,3.89,0,0,1,212.47,192.44Z"
          style={{
            fill: "#213E60",
            transformOrigin: "194.41px 199.58px",
          }}
          id="elnpj7ie3k91"
          className="animable"
        />
        <g id="elvwjalj3mde">
          <path
            d="M212.47,192.44c-.2-.75-.89-1-1.7-.52l-29.1,16.77a3.49,3.49,0,0,0-1.24,1.31l-4.08-2.34a3.51,3.51,0,0,1,1.25-1.31l29.08-16.77a3.94,3.94,0,0,1,3.54,0l.55.31A3.89,3.89,0,0,1,212.47,192.44Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.2,
              transformOrigin: "194.41px 199.58px",
            }}
            className="animable"
            id="el3exc9uck36l"
          />
        </g>
        <g
          id="freepik--check-list--inject-835"
          className="animable"
          style={{
            transformOrigin: "196.203px 217.154px",
          }}
        >
          <path
            id="freepik--Check--inject-835"
            d="M205,202.87a2.55,2.55,0,0,0-3.34,1.18l-9.12,21.06L190.14,223a2.74,2.74,0,0,0-3.65-.05,2.24,2.24,0,0,0,.16,3.35l5.16,4.64a2.88,2.88,0,0,0,1.82.72,4.36,4.36,0,0,0,.51,0,2.35,2.35,0,0,0,1.82-1.36L206.44,206A2.43,2.43,0,0,0,205,202.87Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "196.203px 217.154px",
            }}
            className="animable"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
export default WebDevelopmentSVG;
